
if (!window.postponeJQueryMainFunctionsLoading) {
    jQuery(function() {
    	initSlickCarousel();
    	initSameHeight();
    	initItemsZindex();
    	initLightbox();
    	initCustomMap();
    	initLoadMore();
    	initLightboxOpener();
    	initFixedBlock();
    	initNavigationSelect();
    	initCustomForms();
    	initFixedMap();
    });
}

// init fixed map
function initFixedMap() {

	ResponsiveHelper.addRange({
		'768..': {
				on: function() {
				var win = jQuery(window);
				jQuery('.js-map-fixed').each(function() {
					var block = jQuery(this);
					var topBlock = jQuery('#' + block.data('top-block'));
					var bottomBlock = jQuery('#' + block.data('bottom-block'));
					var activeClass = 'map-static';

					scrollHandler();

					win.on('scroll resize orientationchange', scrollHandler);

					function scrollHandler() {
						var winTop = win.scrollTop();
						var winHeight = win.height();
						var topBlockTop = topBlock.offset().top;
						var bottomBlockTop = bottomBlock.offset().top;
						var footerheight = $('.footer-area' ).height();
						var headerheight = $('#header').outerHeight(true);
						var bannerheight = $('.form-block' ).outerHeight(true);

						if ((winTop > topBlockTop) && (winTop + winHeight < bottomBlockTop)) {
							block.addClass(activeClass);
							$('.js-map-fixed').css({
									'top': '0',
								});
						} else {
							if (winTop + winHeight > bottomBlockTop) {
								block.removeClass(activeClass);
								$('.js-map-fixed').css({
										'top': (bottomBlockTop - headerheight - bannerheight - winHeight),
									});
							} else {
								block.removeClass(activeClass);
								$('.js-map-fixed').css({
										'top': '0',
									});
						  }
					  }
					}
				});
			}
		}
	})
}

// init fixed block
function initFixedBlock() {
	var win = jQuery(window);
	jQuery('.js-fixed-block').each(function() {
		var block = jQuery(this);
		var bottomBlock = jQuery('#' + block.data('bottom-block'));
		var activeClass = 'static-state';

		scrollHandler();

		win.on('scroll resize orientationchange', scrollHandler);

		function scrollHandler() {
			var winTop = win.scrollTop();
			var winHeight = win.height();
			var blockTop = bottomBlock.offset().top;

			if (winTop + winHeight > blockTop) {
				block.addClass(activeClass);
			} else {
				block.removeClass(activeClass);
			}
		}
	});
}

// init lightbox opener
function initLightboxOpener() {
	jQuery('.lightbox-extra-opener').each(function() {
		var opener = jQuery(this);

		opener.on('click', function(e) {
			e.preventDefault();
			jQuery('#' + opener.data('target')).trigger('click');
		});
	})
}

// generate select from navigation
function initNavigationSelect() {
	jQuery('ul.link-list').navigationSelect({
		activeClass: 'nav-active',
		defaultOptionAttr: 'title',
		levelIndentHTML: ' &amp;bull; ',
		defaultOptionText: 'Vorschlag'
	});
}

// initialize custom form elements
function initCustomForms() {
	jcf.setOptions('Select', {
		wrapNative: false,
	});
	jcf.replaceAll();
}


// load more init
function initLoadMore() {
	jQuery('.employee').loadMore({
		linkSelector: 'a.load-more',
		newContentTarget: '.employee-list'
	});
}

// lightbox init
function initLightbox() {
	jQuery('a.lightbox, a[rel*="lightbox"]').fancybox({
		helpers: {
			overlay: {
				css: {
					background: 'rgba(0, 0, 0, 0.65)'
				}
			}
		},
		afterLoad: function(current, previous) {
			// handle custom close button in inline modal
			if (current.href.indexOf('#') === 0) {
				jQuery(current.href).find('a.close').off('click.fb').on('click.fb', function(e) {
					e.preventDefault();
					jQuery.fancybox.close();
				});
			}
		},
	});
}

function initCustomMap() {
	var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

	if (!jQuery('.map').length) return;

	jQuery('.map').сustomMap({
		useBounds: false,
		startCoords: [35.9379498, 14.386326],
		mapOptions: {
			zoom: 14,
			maxZoom: 17,
			minZoom: 3,
			disableDefaultUI: true,
			scrollwheel: true,
			panControl: false,
			zoomControl: true,
			panControlOptions: {
				position: google.maps.ControlPosition.LEFT_CENTER
			},
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_BOTTOM
			},
			draggable: !isTouchDevice
		},
		onInit: function (self) {},
		onMarkersLoaded: function(self) {
			this.addMarkers(this.markersObj);
		},
		onResize: function(self) {
			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(function() {
				if (self.addedMarkers && self.addedMarkers.length) {
					for (var i = self.addedMarkers.length - 1; i >= 0; i--) {
						if (self.addedMarkers[i].popupAPI) self.addedMarkers[i].popupAPI.hidePopup();
					}
				}
				if (self.bounds && self.options.useBounds) {
					self.mapCanvas.fitBounds(self.bounds);
				}
			}, 100);
		},
		onMarkerAdded: function (self, marker) {
		    self.mapCanvas.setCenter(new google.maps.LatLng(marker.location[0], marker.location[1]));
		},
		onMarkerRemove: function(self, marker) { }
	});
}

function initCustomDesktopMap(initStartCoords, initZoom) {
	jQuery('.map.map-right-side').сustomMap({
		useBounds: initStartCoords === undefined,
		startCoords: initStartCoords || [39.659501, -74.9424346],
		mapOptions: {
			zoom: initZoom || 8,
			maxZoom: 17,
			minZoom: 3,
			disableDefaultUI: true,
			scrollwheel: true,
			panControl: false,
			zoomControl: true,
			panControlOptions: {
				position: google.maps.ControlPosition.LEFT_CENTER
			},
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_BOTTOM
			},
			draggable: true
		},
		onInit: function (self) {},
		onMarkersLoaded: function(self) {
			this.addMarkers(this.markersObj);
		},
		onResize: function(self) {
			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(function() {
				if (self.addedMarkers && self.addedMarkers.length) {
					for (var i = self.addedMarkers.length - 1; i >= 0; i--) {
						if (self.addedMarkers[i].popupAPI) self.addedMarkers[i].popupAPI.hidePopup();
					}
				}
				if (self.bounds && self.options.useBounds) {
					self.mapCanvas.fitBounds(self.bounds);
				}
			}, 100);
		},
		onMarkerAdded: function (self, marker) {
			marker.popupHolder.find(".map-marker").tooltip();
		},
		onMarkerRemove: function(self, marker) { }
	});
}

function initCustomMobileMap() {
	jQuery('.map.map-view').сustomMap({
		useBounds: true,
		startCoords: [39.659501, -74.9424346],
		mapOptions: {
			zoom: 8,
			maxZoom: 16,
			minZoom: 3,
			disableDefaultUI: true,
			scrollwheel: true,
			panControl: false,
			zoomControl: true,
			panControlOptions: {
				position: google.maps.ControlPosition.LEFT_CENTER
			},
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_BOTTOM
			},
			draggable: true
		},
		onInit: function (self) {},
		onMarkersLoaded: function(self) {
			this.addMarkers(this.markersObj);
		},
		onResize: function(self) {
			
			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(function() {
				if (self.addedMarkers && self.addedMarkers.length) {
					for (var i = self.addedMarkers.length - 1; i >= 0; i--) {
						if (self.addedMarkers[i].popupAPI) self.addedMarkers[i].popupAPI.hidePopup();
					}
				}
				if (self.bounds && self.options.useBounds) {
					self.mapCanvas.fitBounds(self.bounds);
				}
			}, 100);
			
		},
		onMarkerRemove: function(self, marker) { }
	});
}

// add z-index to elements
function initItemsZindex() {
	jQuery('.breadcrumb li').zIndexOrder({
		startIndex: 0
	});
}

// slick init
function initSlickCarousel() {
	jQuery('.employee-list').each(function() {
		var employeeGallery = jQuery(this);

		ResponsiveHelper.addRange({
			'..767': {
				on: function() {
					if(!employeeGallery.hasClass('slick-initialized')) {
						employeeGallery.slick({
							slidesToScroll: 1,
							prevArrow: '<button class="slick-prev">Previous</button>',
							nextArrow: '<button class="slick-next">Next</button>',
							pauseOnHover: false,
							arrows: false,
							slidesToShow: 2,
							mobileFirst: true
						});
					}
				}
			},
			'768..': {
				on: function() {
					if(employeeGallery.hasClass('slick-initialized')) {
						employeeGallery.slick('unslick');
					}
				}
			}
		})
	});

	jQuery('.image-gallery').each(function() {
		var imageGallery = jQuery(this);

		ResponsiveHelper.addRange({
			'..767': {
				on: function() {
					if(!imageGallery.hasClass('slick-initialized')) {
						imageGallery.slick({
							slidesToScroll: 1,
							variableWidth:!0,
							prevArrow: '<button class="slick-prev">Previous</button>',
							nextArrow: '<button class="slick-next">Next</button>',
							pauseOnHover: false,
							arrows: false,
							slidesToShow: 2,
							mobileFirst: true
						});
					}
				}
			},
			'768..': {
				on: function() {
					if(imageGallery.hasClass('slick-initialized')) {
						imageGallery.slick('unslick');
					}
				}
			}
		})
	});
}

// align blocks height
function initSameHeight() {
	jQuery('.image-gallery').sameHeight({
		elements: 'li',
		flexible: true,
		multiLine: true
	});
}

/*
 * jQuery SameHeight plugin
 */
 ;(function($){
 	$.fn.sameHeight = function(opt) {
 		var options = $.extend({
 			skipClass: 'same-height-ignore',
 			leftEdgeClass: 'same-height-left',
 			rightEdgeClass: 'same-height-right',
 			elements: '>*',
 			flexible: false,
 			multiLine: false,
 			useMinHeight: false,
 			biggestHeight: false
 		},opt);
 		return this.each(function(){
 			var holder = $(this), postResizeTimer, ignoreResize;
 			var elements = holder.find(options.elements).not('.' + options.skipClass);
 			if(!elements.length) return;

			// resize handler
			function doResize() {
				elements.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', '');
				if(options.multiLine) {
					// resize elements row by row
					resizeElementsByRows(elements, options);
				} else {
					// resize elements by holder
					resizeElements(elements, holder, options);
				}
			}
			doResize();

			// handle flexible layout / font resize
			var delayedResizeHandler = function() {
				if(!ignoreResize) {
					ignoreResize = true;
					doResize();
					clearTimeout(postResizeTimer);
					postResizeTimer = setTimeout(function() {
						doResize();
						setTimeout(function(){
							ignoreResize = false;
						}, 10);
					}, 100);
				}
			};

			// handle flexible/responsive layout
			if(options.flexible) {
				$(window).bind('resize orientationchange fontresize', delayedResizeHandler);
			}

			// handle complete page load including images and fonts
			$(window).bind('load', delayedResizeHandler);
		});
 	};

	// detect css min-height support
	var supportMinHeight = typeof document.documentElement.style.maxHeight !== 'undefined';

	// get elements by rows
	function resizeElementsByRows(boxes, options) {
		var currentRow = $(), maxHeight, maxCalcHeight = 0, firstOffset = boxes.eq(0).offset().top;
		boxes.each(function(ind){
			var curItem = $(this);
			if(curItem.offset().top === firstOffset) {
				currentRow = currentRow.add(this);
			} else {
				maxHeight = getMaxHeight(currentRow);
				maxCalcHeight = Math.max(maxCalcHeight, resizeElements(currentRow, maxHeight, options));
				currentRow = curItem;
				firstOffset = curItem.offset().top;
			}
		});
		if(currentRow.length) {
			maxHeight = getMaxHeight(currentRow);
			maxCalcHeight = Math.max(maxCalcHeight, resizeElements(currentRow, maxHeight, options));
		}
		if(options.biggestHeight) {
			boxes.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', maxCalcHeight);
		}
	}

	// calculate max element height
	function getMaxHeight(boxes) {
		var maxHeight = 0;
		boxes.each(function(){
			maxHeight = Math.max(maxHeight, $(this).outerHeight());
		});
		return maxHeight;
	}

	// resize helper function
	function resizeElements(boxes, parent, options) {
		var calcHeight;
		var parentHeight = typeof parent === 'number' ? parent : parent.height();
		boxes.removeClass(options.leftEdgeClass).removeClass(options.rightEdgeClass).each(function(i){
			var element = $(this);
			var depthDiffHeight = 0;
			var isBorderBox = element.css('boxSizing') === 'border-box' || element.css('-moz-box-sizing') === 'border-box' || element.css('-webkit-box-sizing') === 'border-box';

			if(typeof parent !== 'number') {
				element.parents().each(function(){
					var tmpParent = $(this);
					if(parent.is(this)) {
						return false;
					} else {
						depthDiffHeight += tmpParent.outerHeight() - tmpParent.height();
					}
				});
			}
			calcHeight = parentHeight - depthDiffHeight;
			calcHeight -= isBorderBox ? 0 : element.outerHeight() - element.height();

			if(calcHeight > 0) {
				element.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', calcHeight);
			}
		});
		boxes.filter(':first').addClass(options.leftEdgeClass);
		boxes.filter(':last').addClass(options.rightEdgeClass);
		return calcHeight;
	}
}(jQuery));


// zIndex order plugin
jQuery.fn.zIndexOrder = function(opt) {
	var options = jQuery.extend({
		reverse: false,
		startIndex: 0
	}, opt);

	var items = this;
	return items.each(function(index, item) {
		items.eq(options.reverse ? items.length - index - 1 : index).css({
			zIndex: index + (options.startIndex || 1)
		});
	});
};

// main custom map plugin
;(function($, window) {
	'use strict';
	var win = $(window);

	// custom map init
	function CustomMap(opt) {
		this.options = jQuery.extend(true, {
			map: '.map-canvas',
			useBounds: true,
			startCoords: [35.8635395, 14.4434443],
			createPopup: false,
			mapOptions: {
				zoom: 8,
				maxZoom: 14
			}
		}, opt);
		this.init();
	}
	CustomMap.prototype = {
		init: function() {
			if (this.options.holder) {
				$.data(this.options.holder, 'CustomMap', this);
				this.findElements();
				this.createMap();
				this.makeCallback('onInit', this);
			}
		},
		findElements: function() {
			this.holder = $(this.options.holder);
			this.map = this.holder.find(this.options.map);
			this.options = $.extend(this.options, this.holder.data('mapOptions'));
		},
		createMap: function() {
			var self = this;
			this.options.mapOptions.center = new google.maps.LatLng(this.options.startCoords[0], this.options.startCoords[1]);
			this.mapCanvas = new google.maps.Map(this.map[0], this.options.mapOptions);
			this.getAjaxData(this.holder.data('styles'), function(data, noAjax) {
				self.mapCanvas.setOptions({ styles: data });
			});
			this.getAjaxData(this.holder.data('markers'), function(data, noAjax) {
				if (noAjax) {
					self.markersObj = data;
				} else {
					self.markersObj = data.markers;
				}
				self.makeCallback('onMarkersLoaded', self);
				self.attachEvents();
			});
		},
		attachEvents: function() {
			this.bindHandlers();
			win.on('resize orientationcahnge', this.onResize);
		},
		onResize: function() {
			this.makeCallback('onResize', this);
		},
		getAjaxData: function(url, complete) {
			var self = this;
			if (!url) return;
			if (typeof url == 'object') {
				complete(url, true);
			} else {
				$.getJSON(url, function(data) {
					complete(data);
				});
			}
		},
		removeMarker: function(marker) {
			this.makeCallback('onMarkerRemove', this, marker);
			if (marker.popupAPI) {
				marker.popupAPI.destroy();
				delete marker.popupAPI;
			}
			if (marker.customMarker) {
				marker.customMarker.remove();
				marker.customMarker.draw = function() {};
				delete marker.customMarker;
			}
		},
		removeMarkers: function() {
			if (this.addedMarkers && this.addedMarkers.length) {
				for (var i = this.addedMarkers.length - 1; i >= 0; i--) {
					this.removeMarker(this.addedMarkers[i]);
				}
				this.addedMarkers = null;
			}
		},
		addMarker: function(marker) {
			var self = this,
			popupHolder = $('<div class="js-custom-marker"></div>').css({ position: 'absolute' }).html(marker.popupHTML);

			marker.popupHolder = popupHolder;
			if (marker.extraClass) {
				popupHolder.addClass(marker.extraClass);
			}

			if (this.options.createPopup && marker.createPopup !== false) {
				marker.popupAPI = new MapPopup({
					holder: popupHolder,
					map: this.mapCanvas,
					mapHolder: this.map
				});
			}

			marker.customMarker = new CustomMarker({
				mapAPI: this,
				map: this.mapCanvas,
				mapHolder: this.map,
				marker: marker,
				holder: popupHolder
			});
			if (this.bounds && this.options.useBounds) {
				this.bounds.extend(new google.maps.LatLng(marker.location[0], marker.location[1]));
			}
			if (!this.addedMarkers || !this.addedMarkers.length) {
				this.addedMarkers = [];
			}
			this.addedMarkers.push(marker);
			this.makeCallback('onMarkerAdded', self, marker);
		},
		addMarkers: function(markersArray) {
			if (markersArray && markersArray.length) {
				if (!this.bounds && this.options.useBounds) {
					this.bounds = new google.maps.LatLngBounds();
				}
				for (var i = markersArray.length - 1; i >= 0; i--) {
					this.addMarker(markersArray[i]);
				}
			}
			if (this.bounds && this.options.useBounds) {
				this.mapCanvas.fitBounds(this.bounds);
			}
		},
		bindHandlers: function() {
			var self = this;
			$.each(self, function(propName, propValue) {
				if (propName.indexOf('on') === 0 && $.isFunction(propValue)) {
					self[propName] = function() {
						return propValue.apply(self, arguments);
					};
				}
			});
		},
		makeCallback: function(name) {
			if (typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		},
		destroy: function() {
			var self = this;
			this.removeMarkers();
			win.off('resize orientationcahnge', this.onResize);
			this.holder.removeData('CustomMap');
		}
	};

	// jQuery plugin interface
	$.fn.сustomMap = function(options) {
		return this.each(function() {
			var params = $.extend({}, options, { holder: this }),
			instance = new CustomMap(params);
		});
	};

	// module exports
	window.CustomMap = CustomMap;
}(jQuery, this));


// map marker plugin
;(function($, window) {
	'use strict';
	if (!window.google) return;
	if (!window.google.maps) return;

	// custom marker module part
	function CustomMarker(obj) {
		this.options = obj;
		this.setMap(obj.map);
	}
	CustomMarker.prototype = new google.maps.OverlayView();
	CustomMarker.prototype.draw = function() {
		var holder = this.holder,
		panes;

		if (!holder) {
			holder = this.holder = this.options.holder;

			panes = this.getPanes();
			panes.overlayImage.appendChild(holder[0]);
		}
		var point = this.getProjection().fromLatLngToDivPixel(new google.maps.LatLng(this.options.marker.location[0], this.options.marker.location[1]));
		if (point) {
			holder.css({
				left: point.x,
				top: point.y
			});
		}
	};
	CustomMarker.prototype.remove = function() {
		if (this.holder && this.holder.length) {
			this.holder.remove();
			this.holder = null;
			this.setMap(null);
			delete this.draw;
		}
	};

	// module exports
	window.CustomMarker = CustomMarker;
}(jQuery, this));

// map popup plugin
;(function($, window) {
	'use strict';

	var doc = $(document);
	var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

	// custom map popup init
	function MapPopup(opt) {
		this.options = jQuery.extend({
			activeClass: 'active',
			popup: '.popup',
			opener: 'a.marker-opener, a.close'
		}, opt);
		this.init();
	}
	MapPopup.prototype = {
		init: function() {
			if (this.options.holder && this.options.map) {
				this.findElements();
				this.attachEvents();
			}
		},
		findElements: function() {
			this.holder = jQuery(this.options.holder);
			this.opener = this.holder.find(this.options.opener);
			this.popup = this.holder.find(this.options.popup);
			this.doc = jQuery(document);
		},
		attachEvents: function() {
			var self = this;
			var clickTimer;

			this.tooglePopup = function() {
				if (self.holder.hasClass(self.options.activeClass)) {
					self.hidePopup();
				} else {
					self.showPopup();
				}
			};
			this.opener.on('click', function(e) {
				e.preventDefault();
				if (isTouchDevice) {
					clearTimeout(clickTimer);
					clickTimer = setTimeout(self.tooglePopup, 10);
				} else {
					self.tooglePopup();
				}
			});
			this.outsideClickHandler = function(e) {
				var target = jQuery(e.target);
				if (!target.closest(self.holder).length) {
					self.hidePopup();
				}
			};
		},
		showPopup: function() {
			var self = this;
			this.holder.addClass(this.options.activeClass);
			this.holder.trigger('popupShow');
			this.state = true;
			this.checkPopupPosition();

			setTimeout(function() {
				doc.on('click', self.outsideClickHandler);
			}, 100);
		},
		hidePopup: function() {
			this.state = false;
			this.holder.removeClass(this.options.activeClass);
			this.holder.trigger('popupHide');
			doc.off('click', this.outsideClickHandler);
		},
		checkPopupPosition: function() {
			var popupOffsets = {
				top: this.popup.offset().top,
				left: this.popup.offset().left,
				height: this.popup.innerHeight(),
				width: this.popup.innerWidth()
			},
			holderOffsets = {
				top: this.options.mapHolder.offset().top,
				left: this.options.mapHolder.offset().left,
				height: this.options.mapHolder.innerHeight(),
				width: this.options.mapHolder.innerWidth()
			},
			vDiff = Math.min(popupOffsets.top - holderOffsets.top - 20, 0),
			hDiff = holderOffsets.left + holderOffsets.width - (popupOffsets.left + popupOffsets.width) - 20;

			if (hDiff < 0) {
				this.repositionMap(vDiff, hDiff);
				return;
			} else {
				hDiff = holderOffsets.left - popupOffsets.left + 80;
				if (hDiff > 0) {
					this.repositionMap(vDiff, hDiff);
					return;
				}
			}
			this.repositionMap(vDiff, 0);
		},
		repositionMap: function(vDiff, hDiff) {
			var currCenter = this.options.map.getCenter(),
			pixelpoint = this.options.map.getProjection().fromLatLngToPoint(currCenter),
			newCenter,
			scale = Math.pow(2, this.options.map.getZoom());

			pixelpoint.y = pixelpoint.y + vDiff / scale;
			pixelpoint.x = pixelpoint.x - hDiff / scale;
			newCenter = this.options.map.getProjection().fromPointToLatLng(pixelpoint);
			this.options.map.setCenter(newCenter);
		},
		destroy: function() {
			doc.off('click', this.outsideClickHandler);
			this.opener.on('click');
		}
	};

	// module exports
	window.MapPopup = MapPopup;
}(jQuery, this));

/*!
 * JavaScript Custom Forms
 *
 * Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
 * Released under the MIT license (LICENSE.txt)
 *
 * Version: 1.1.3
 */
 ;(function(root, factory) {
 	'use strict';
 	if (typeof define === 'function' && define.amd) {
 		define(['jquery'], factory);
 	} else if (typeof exports === 'object') {
 		module.exports = factory(require('jquery'));
 	} else {
 		root.jcf = factory(jQuery);
 	}
 }(this, function($) {
 	'use strict';

	// define version
	var version = '1.1.3';

	// private variables
	var customInstances = [];

	// default global options
	var commonOptions = {
		optionsKey: 'jcf',
		dataKey: 'jcf-instance',
		rtlClass: 'jcf-rtl',
		focusClass: 'jcf-focus',
		pressedClass: 'jcf-pressed',
		disabledClass: 'jcf-disabled',
		hiddenClass: 'jcf-hidden',
		resetAppearanceClass: 'jcf-reset-appearance',
		unselectableClass: 'jcf-unselectable'
	};

	// detect device type
	var isTouchDevice = ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch,
	isWinPhoneDevice = /Windows Phone/.test(navigator.userAgent);
	commonOptions.isMobileDevice = !!(isTouchDevice || isWinPhoneDevice);

	var isIOS = /(iPad|iPhone).*OS ([0-9_]*) .*/.exec(navigator.userAgent);
	if(isIOS) isIOS = parseFloat(isIOS[2].replace(/_/g, '.'));
	commonOptions.ios = isIOS;

	// create global stylesheet if custom forms are used
	var createStyleSheet = function() {
		var styleTag = $('<style>').appendTo('head'),
		styleSheet = styleTag.prop('sheet') || styleTag.prop('styleSheet');

		// crossbrowser style handling
		var addCSSRule = function(selector, rules, index) {
			if (styleSheet.insertRule) {
				styleSheet.insertRule(selector + '{' + rules + '}', index);
			} else {
				styleSheet.addRule(selector, rules, index);
			}
		};

		// add special rules
		addCSSRule('.' + commonOptions.hiddenClass, 'position:absolute !important;left:-9999px !important;height:1px !important;width:1px !important;margin:0 !important;border-width:0 !important;-webkit-appearance:none;-moz-appearance:none;appearance:none');
		addCSSRule('.' + commonOptions.rtlClass + ' .' + commonOptions.hiddenClass, 'right:-9999px !important; left: auto !important');
		addCSSRule('.' + commonOptions.unselectableClass, '-webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; -webkit-tap-highlight-color: rgba(0,0,0,0);');
		addCSSRule('.' + commonOptions.resetAppearanceClass, 'background: none; border: none; -webkit-appearance: none; appearance: none; opacity: 0; filter: alpha(opacity=0);');

		// detect rtl pages
		var html = $('html'), body = $('body');
		if (html.css('direction') === 'rtl' || body.css('direction') === 'rtl') {
			html.addClass(commonOptions.rtlClass);
		}

		// handle form reset event
		html.on('reset', function() {
			setTimeout(function() {
				api.refreshAll();
			}, 0);
		});

		// mark stylesheet as created
		commonOptions.styleSheetCreated = true;
	};

	// simplified pointer events handler
	(function() {
		var pointerEventsSupported = navigator.pointerEnabled || navigator.msPointerEnabled,
		touchEventsSupported = ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch,
		eventList, eventMap = {}, eventPrefix = 'jcf-';

		// detect events to attach
		if (pointerEventsSupported) {
			eventList = {
				pointerover: navigator.pointerEnabled ? 'pointerover' : 'MSPointerOver',
				pointerdown: navigator.pointerEnabled ? 'pointerdown' : 'MSPointerDown',
				pointermove: navigator.pointerEnabled ? 'pointermove' : 'MSPointerMove',
				pointerup: navigator.pointerEnabled ? 'pointerup' : 'MSPointerUp'
			};
		} else {
			eventList = {
				pointerover: 'mouseover',
				pointerdown: 'mousedown' + (touchEventsSupported ? ' touchstart' : ''),
				pointermove: 'mousemove' + (touchEventsSupported ? ' touchmove' : ''),
				pointerup: 'mouseup' + (touchEventsSupported ? ' touchend' : '')
			};
		}

		// create event map
		$.each(eventList, function(targetEventName, fakeEventList) {
			$.each(fakeEventList.split(' '), function(index, fakeEventName) {
				eventMap[fakeEventName] = targetEventName;
			});
		});

		// jQuery event hooks
		$.each(eventList, function(eventName, eventHandlers) {
			eventHandlers = eventHandlers.split(' ');
			$.event.special[eventPrefix + eventName] = {
				setup: function() {
					var self = this;
					$.each(eventHandlers, function(index, fallbackEvent) {
						if (self.addEventListener) self.addEventListener(fallbackEvent, fixEvent, commonOptions.isMobileDevice ? {passive: false} : false);
						else self['on' + fallbackEvent] = fixEvent;
					});
				},
				teardown: function() {
					var self = this;
					$.each(eventHandlers, function(index, fallbackEvent) {
						if (self.addEventListener) self.removeEventListener(fallbackEvent, fixEvent, commonOptions.isMobileDevice ? {passive: false} : false);
						else self['on' + fallbackEvent] = null;
					});
				}
			};
		});

		// check that mouse event are not simulated by mobile browsers
		var lastTouch = null;
		var mouseEventSimulated = function(e) {
			var dx = Math.abs(e.pageX - lastTouch.x),
			dy = Math.abs(e.pageY - lastTouch.y),
			rangeDistance = 25;

			if (dx <= rangeDistance && dy <= rangeDistance) {
				return true;
			}
		};

		// normalize event
		var fixEvent = function(e) {
			var origEvent = e || window.event,
			touchEventData = null,
			targetEventName = eventMap[origEvent.type];

			e = $.event.fix(origEvent);
			e.type = eventPrefix + targetEventName;

			if (origEvent.pointerType) {
				switch (origEvent.pointerType) {
					case 2: e.pointerType = 'touch'; break;
					case 3: e.pointerType = 'pen'; break;
					case 4: e.pointerType = 'mouse'; break;
					default: e.pointerType = origEvent.pointerType;
				}
			} else {
				e.pointerType = origEvent.type.substr(0, 5); // "mouse" or "touch" word length
			}

			if (!e.pageX && !e.pageY) {
				touchEventData = origEvent.changedTouches ? origEvent.changedTouches[0] : origEvent;
				e.pageX = touchEventData.pageX;
				e.pageY = touchEventData.pageY;
			}

			if (origEvent.type === 'touchend') {
				lastTouch = { x: e.pageX, y: e.pageY };
			}
			if (e.pointerType === 'mouse' && lastTouch && mouseEventSimulated(e)) {
				return;
			} else {
				return ($.event.dispatch || $.event.handle).call(this, e);
			}
		};
	}());

	// custom mousewheel/trackpad handler
	(function() {
		var wheelEvents = ('onwheel' in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll').split(' '),
		shimEventName = 'jcf-mousewheel';

		$.event.special[shimEventName] = {
			setup: function() {
				var self = this;
				$.each(wheelEvents, function(index, fallbackEvent) {
					if (self.addEventListener) self.addEventListener(fallbackEvent, fixEvent, false);
					else self['on' + fallbackEvent] = fixEvent;
				});
			},
			teardown: function() {
				var self = this;
				$.each(wheelEvents, function(index, fallbackEvent) {
					if (self.addEventListener) self.removeEventListener(fallbackEvent, fixEvent, false);
					else self['on' + fallbackEvent] = null;
				});
			}
		};

		var fixEvent = function(e) {
			var origEvent = e || window.event;
			e = $.event.fix(origEvent);
			e.type = shimEventName;

			// old wheel events handler
			if ('detail'      in origEvent) { e.deltaY = -origEvent.detail;      }
			if ('wheelDelta'  in origEvent) { e.deltaY = -origEvent.wheelDelta;  }
			if ('wheelDeltaY' in origEvent) { e.deltaY = -origEvent.wheelDeltaY; }
			if ('wheelDeltaX' in origEvent) { e.deltaX = -origEvent.wheelDeltaX; }

			// modern wheel event handler
			if ('deltaY' in origEvent) {
				e.deltaY = origEvent.deltaY;
			}
			if ('deltaX' in origEvent) {
				e.deltaX = origEvent.deltaX;
			}

			// handle deltaMode for mouse wheel
			e.delta = e.deltaY || e.deltaX;
			if (origEvent.deltaMode === 1) {
				var lineHeight = 16;
				e.delta *= lineHeight;
				e.deltaY *= lineHeight;
				e.deltaX *= lineHeight;
			}

			return ($.event.dispatch || $.event.handle).call(this, e);
		};
	}());

	// extra module methods
	var moduleMixin = {
		// provide function for firing native events
		fireNativeEvent: function(elements, eventName) {
			$(elements).each(function() {
				var element = this, eventObject;
				if (element.dispatchEvent) {
					eventObject = document.createEvent('HTMLEvents');
					eventObject.initEvent(eventName, true, true);
					element.dispatchEvent(eventObject);
				} else if (document.createEventObject) {
					eventObject = document.createEventObject();
					eventObject.target = element;
					element.fireEvent('on' + eventName, eventObject);
				}
			});
		},
		// bind event handlers for module instance (functions beggining with "on")
		bindHandlers: function() {
			var self = this;
			$.each(self, function(propName, propValue) {
				if (propName.indexOf('on') === 0 && $.isFunction(propValue)) {
					// dont use $.proxy here because it doesn't create unique handler
					self[propName] = function() {
						return propValue.apply(self, arguments);
					};
				}
			});
		}
	};

	// public API
	var api = {
		version: version,
		modules: {},
		getOptions: function() {
			return $.extend({}, commonOptions);
		},
		setOptions: function(moduleName, moduleOptions) {
			if (arguments.length > 1) {
				// set module options
				if (this.modules[moduleName]) {
					$.extend(this.modules[moduleName].prototype.options, moduleOptions);
				}
			} else {
				// set common options
				$.extend(commonOptions, moduleName);
			}
		},
		addModule: function(proto) {
			// add module to list
			var Module = function(options) {
				// save instance to collection
				if (!options.element.data(commonOptions.dataKey)) {
					options.element.data(commonOptions.dataKey, this);
				}
				customInstances.push(this);

				// save options
				this.options = $.extend({}, commonOptions, this.options, getInlineOptions(options.element), options);

				// bind event handlers to instance
				this.bindHandlers();

				// call constructor
				this.init.apply(this, arguments);
			};

			// parse options from HTML attribute
			var getInlineOptions = function(element) {
				var dataOptions = element.data(commonOptions.optionsKey),
				attrOptions = element.attr(commonOptions.optionsKey);

				if (dataOptions) {
					return dataOptions;
				} else if (attrOptions) {
					try {
						return $.parseJSON(attrOptions);
					} catch (e) {
						// ignore invalid attributes
					}
				}
			};

			// set proto as prototype for new module
			Module.prototype = proto;

			// add mixin methods to module proto
			$.extend(proto, moduleMixin);
			if (proto.plugins) {
				$.each(proto.plugins, function(pluginName, plugin) {
					$.extend(plugin.prototype, moduleMixin);
				});
			}

			// override destroy method
			var originalDestroy = Module.prototype.destroy;
			Module.prototype.destroy = function() {
				this.options.element.removeData(this.options.dataKey);

				for (var i = customInstances.length - 1; i >= 0; i--) {
					if (customInstances[i] === this) {
						customInstances.splice(i, 1);
						break;
					}
				}

				if (originalDestroy) {
					originalDestroy.apply(this, arguments);
				}
			};

			// save module to list
			this.modules[proto.name] = Module;
		},
		getInstance: function(element) {
			return $(element).data(commonOptions.dataKey);
		},
		replace: function(elements, moduleName, customOptions) {
			var self = this,
			instance;

			if (!commonOptions.styleSheetCreated) {
				createStyleSheet();
			}

			$(elements).each(function() {
				var moduleOptions,
				element = $(this);

				instance = element.data(commonOptions.dataKey);
				if (instance) {
					instance.refresh();
				} else {
					if (!moduleName) {
						$.each(self.modules, function(currentModuleName, module) {
							if (module.prototype.matchElement.call(module.prototype, element)) {
								moduleName = currentModuleName;
								return false;
							}
						});
					}
					if (moduleName) {
						moduleOptions = $.extend({ element: element }, customOptions);
						instance = new self.modules[moduleName](moduleOptions);
					}
				}
			});
			return instance;
		},
		refresh: function(elements) {
			$(elements).each(function() {
				var instance = $(this).data(commonOptions.dataKey);
				if (instance) {
					instance.refresh();
				}
			});
		},
		destroy: function(elements) {
			$(elements).each(function() {
				var instance = $(this).data(commonOptions.dataKey);
				if (instance) {
					instance.destroy();
				}
			});
		},
		replaceAll: function(context) {
			var self = this;
			$.each(this.modules, function(moduleName, module) {
				$(module.prototype.selector, context).each(function() {
					if (this.className.indexOf('jcf-ignore') < 0) {
						self.replace(this, moduleName);
					}
				});
			});
		},
		refreshAll: function(context) {
			if (context) {
				$.each(this.modules, function(moduleName, module) {
					$(module.prototype.selector, context).each(function() {
						var instance = $(this).data(commonOptions.dataKey);
						if (instance) {
							instance.refresh();
						}
					});
				});
			} else {
				for (var i = customInstances.length - 1; i >= 0; i--) {
					customInstances[i].refresh();
				}
			}
		},
		destroyAll: function(context) {
			if (context) {
				$.each(this.modules, function(moduleName, module) {
					$(module.prototype.selector, context).each(function(index, element) {
						var instance = $(element).data(commonOptions.dataKey);
						if (instance) {
							instance.destroy();
						}
					});
				});
			} else {
				while (customInstances.length) {
					customInstances[0].destroy();
				}
			}
		}
	};

	// always export API to the global window object
	window.jcf = api;

	return api;
}));

 /*!
 * JavaScript Custom Forms : Select Module
 *
 * Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
 * Released under the MIT license (LICENSE.txt)
 *
 * Version: 1.1.3
 */
 ;(function($, window) {
 	'use strict';

 	jcf.addModule({
 		name: 'Select',
 		selector: 'select',
 		options: {
 			element: null,
 			multipleCompactStyle: false
 		},
 		plugins: {
 			ListBox: ListBox,
 			ComboBox: ComboBox,
 			SelectList: SelectList
 		},
 		matchElement: function(element) {
 			return element.is('select');
 		},
 		init: function() {
 			this.element = $(this.options.element);
 			this.createInstance();
 		},
 		isListBox: function() {
 			return this.element.is('[size]:not([jcf-size]), [multiple]');
 		},
 		createInstance: function() {
 			if (this.instance) {
 				this.instance.destroy();
 			}
 			if (this.isListBox() && !this.options.multipleCompactStyle) {
 				this.instance = new ListBox(this.options);
 			} else {
 				this.instance = new ComboBox(this.options);
 			}
 		},
 		refresh: function() {
 			var typeMismatch = (this.isListBox() && this.instance instanceof ComboBox) ||
 			(!this.isListBox() && this.instance instanceof ListBox);

 			if (typeMismatch) {
 				this.createInstance();
 			} else {
 				this.instance.refresh();
 			}
 		},
 		destroy: function() {
 			this.instance.destroy();
 		}
 	});

	// combobox module
	function ComboBox(options) {
		this.options = $.extend({
			wrapNative: true,
			wrapNativeOnMobile: true,
			fakeDropInBody: true,
			useCustomScroll: true,
			flipDropToFit: true,
			maxVisibleItems: 10,
			fakeAreaStructure: '<span class="jcf-select"><span class="jcf-select-text"></span><span class="jcf-select-opener"></span></span>',
			fakeDropStructure: '<div class="jcf-select-drop"><div class="jcf-select-drop-content"></div></div>',
			optionClassPrefix: 'jcf-option-',
			selectClassPrefix: 'jcf-select-',
			dropContentSelector: '.jcf-select-drop-content',
			selectTextSelector: '.jcf-select-text',
			dropActiveClass: 'jcf-drop-active',
			flipDropClass: 'jcf-drop-flipped'
		}, options);
		this.init();
	}
	$.extend(ComboBox.prototype, {
		init: function() {
			this.initStructure();
			this.bindHandlers();
			this.attachEvents();
			this.refresh();
		},
		initStructure: function() {
			// prepare structure
			this.win = $(window);
			this.doc = $(document);
			this.realElement = $(this.options.element);
			this.fakeElement = $(this.options.fakeAreaStructure).insertAfter(this.realElement);
			this.selectTextContainer = this.fakeElement.find(this.options.selectTextSelector);
			this.selectText = $('<span></span>').appendTo(this.selectTextContainer);
			makeUnselectable(this.fakeElement);

			// copy classes from original select
			this.fakeElement.addClass(getPrefixedClasses(this.realElement.prop('className'), this.options.selectClassPrefix));

			// handle compact multiple style
			if (this.realElement.prop('multiple')) {
				this.fakeElement.addClass('jcf-compact-multiple');
			}

			// detect device type and dropdown behavior
			if (this.options.isMobileDevice && this.options.wrapNativeOnMobile && !this.options.wrapNative) {
				this.options.wrapNative = true;
			}

			if (this.options.wrapNative) {
				// wrap native select inside fake block
				this.realElement.prependTo(this.fakeElement).css({
					position: 'absolute',
					height: '100%',
					width: '100%'
				}).addClass(this.options.resetAppearanceClass);
			} else {
				// just hide native select
				this.realElement.addClass(this.options.hiddenClass);
				this.fakeElement.attr('title', this.realElement.attr('title'));
				this.fakeDropTarget = this.options.fakeDropInBody ? $('body') : this.fakeElement;
			}
		},
		attachEvents: function() {
			// delayed refresh handler
			var self = this;
			this.delayedRefresh = function() {
				setTimeout(function() {
					self.refresh();
					if (self.list) {
						self.list.refresh();
						self.list.scrollToActiveOption();
					}
				}, 1);
			};

			// native dropdown event handlers
			if (this.options.wrapNative) {
				this.realElement.on({
					focus: this.onFocus,
					change: this.onChange,
					click: this.onChange,
					keydown: this.onChange
				});
			} else {
				// custom dropdown event handlers
				this.realElement.on({
					focus: this.onFocus,
					change: this.onChange,
					keydown: this.onKeyDown
				});
				this.fakeElement.on({
					'jcf-pointerdown': this.onSelectAreaPress
				});
			}
		},
		onKeyDown: function(e) {
			if (e.which === 13) {
				this.toggleDropdown();
			} else if (this.dropActive) {
				this.delayedRefresh();
			}
		},
		onChange: function() {
			this.refresh();
		},
		onFocus: function() {
			if (!this.pressedFlag || !this.focusedFlag) {
				this.fakeElement.addClass(this.options.focusClass);
				this.realElement.on('blur', this.onBlur);
				this.toggleListMode(true);
				this.focusedFlag = true;
			}
		},
		onBlur: function() {
			if (!this.pressedFlag) {
				this.fakeElement.removeClass(this.options.focusClass);
				this.realElement.off('blur', this.onBlur);
				this.toggleListMode(false);
				this.focusedFlag = false;
			}
		},
		onResize: function() {
			if (this.dropActive) {
				this.hideDropdown();
			}
		},
		onSelectDropPress: function() {
			this.pressedFlag = true;
		},
		onSelectDropRelease: function(e, pointerEvent) {
			this.pressedFlag = false;
			if (pointerEvent.pointerType === 'mouse') {
				this.realElement.focus();
			}
		},
		onSelectAreaPress: function(e) {
			// skip click if drop inside fake element or real select is disabled
			var dropClickedInsideFakeElement = !this.options.fakeDropInBody && $(e.target).closest(this.dropdown).length;
			if (dropClickedInsideFakeElement || e.button > 1 || this.realElement.is(':disabled')) {
				return;
			}

			// toggle dropdown visibility
			this.selectOpenedByEvent = e.pointerType;
			this.toggleDropdown();

			// misc handlers
			if (!this.focusedFlag) {
				if (e.pointerType === 'mouse') {
					this.realElement.focus();
				} else {
					this.onFocus(e);
				}
			}
			this.pressedFlag = true;
			this.fakeElement.addClass(this.options.pressedClass);
			this.doc.on('jcf-pointerup', this.onSelectAreaRelease);
		},
		onSelectAreaRelease: function(e) {
			if (this.focusedFlag && e.pointerType === 'mouse') {
				this.realElement.focus();
			}
			this.pressedFlag = false;
			this.fakeElement.removeClass(this.options.pressedClass);
			this.doc.off('jcf-pointerup', this.onSelectAreaRelease);
		},
		onOutsideClick: function(e) {
			var target = $(e.target),
			clickedInsideSelect = target.closest(this.fakeElement).length || target.closest(this.dropdown).length;

			if (!clickedInsideSelect) {
				this.hideDropdown();
			}
		},
		onSelect: function() {
			this.refresh();

			if (this.realElement.prop('multiple')) {
				this.repositionDropdown();
			} else {
				this.hideDropdown();
			}

			this.fireNativeEvent(this.realElement, 'change');
		},
		toggleListMode: function(state) {
			if (!this.options.wrapNative) {
				if (state) {
					// temporary change select to list to avoid appearing of native dropdown
					this.realElement.attr({
						size: 4,
						'jcf-size': ''
					});
				} else {
					// restore select from list mode to dropdown select
					if (!this.options.wrapNative) {
						this.realElement.removeAttr('size jcf-size');
					}
				}
			}
		},
		createDropdown: function() {
			// destroy previous dropdown if needed
			if (this.dropdown) {
				this.list.destroy();
				this.dropdown.remove();
			}

			// create new drop container
			this.dropdown = $(this.options.fakeDropStructure).appendTo(this.fakeDropTarget);
			this.dropdown.addClass(getPrefixedClasses(this.realElement.prop('className'), this.options.selectClassPrefix));
			makeUnselectable(this.dropdown);

			// handle compact multiple style
			if (this.realElement.prop('multiple')) {
				this.dropdown.addClass('jcf-compact-multiple');
			}

			// set initial styles for dropdown in body
			if (this.options.fakeDropInBody) {
				this.dropdown.css({
					position: 'absolute',
					top: -9999
				});
			}

			// create new select list instance
			this.list = new SelectList({
				useHoverClass: true,
				handleResize: false,
				alwaysPreventMouseWheel: true,
				maxVisibleItems: this.options.maxVisibleItems,
				useCustomScroll: this.options.useCustomScroll,
				holder: this.dropdown.find(this.options.dropContentSelector),
				multipleSelectWithoutKey: this.realElement.prop('multiple'),
				element: this.realElement
			});
			$(this.list).on({
				select: this.onSelect,
				press: this.onSelectDropPress,
				release: this.onSelectDropRelease
			});
		},
		repositionDropdown: function() {
			var selectOffset = this.fakeElement.offset(),
			selectWidth = this.fakeElement.outerWidth(),
			selectHeight = this.fakeElement.outerHeight(),
			dropHeight = this.dropdown.css('width', selectWidth).outerHeight(),
			winScrollTop = this.win.scrollTop(),
			winHeight = this.win.height(),
			calcTop, calcLeft, bodyOffset, needFlipDrop = false;

			// check flip drop position
			if (selectOffset.top + selectHeight + dropHeight > winScrollTop + winHeight && selectOffset.top - dropHeight > winScrollTop) {
				needFlipDrop = true;
			}

			if (this.options.fakeDropInBody) {
				bodyOffset = this.fakeDropTarget.css('position') !== 'static' ? this.fakeDropTarget.offset().top : 0;
				if (this.options.flipDropToFit && needFlipDrop) {
					// calculate flipped dropdown position
					calcLeft = selectOffset.left;
					calcTop = selectOffset.top - dropHeight - bodyOffset;
				} else {
					// calculate default drop position
					calcLeft = selectOffset.left;
					calcTop = selectOffset.top + selectHeight - bodyOffset;
				}

				// update drop styles
				this.dropdown.css({
					width: selectWidth,
					left: calcLeft,
					top: calcTop
				});
			}

			// refresh flipped class
			this.dropdown.add(this.fakeElement).toggleClass(this.options.flipDropClass, this.options.flipDropToFit && needFlipDrop);
		},
		showDropdown: function() {
			// do not show empty custom dropdown
			if (!this.realElement.prop('options').length) {
				return;
			}

			// create options list if not created
			if (!this.dropdown) {
				this.createDropdown();
			}

			// show dropdown
			this.dropActive = true;
			this.dropdown.appendTo(this.fakeDropTarget);
			this.fakeElement.addClass(this.options.dropActiveClass);
			this.refreshSelectedText();
			this.repositionDropdown();
			this.list.setScrollTop(this.savedScrollTop);
			this.list.refresh();

			// add temporary event handlers
			this.win.on('resize', this.onResize);
			this.doc.on('jcf-pointerdown', this.onOutsideClick);
		},
		hideDropdown: function() {
			if (this.dropdown) {
				this.savedScrollTop = this.list.getScrollTop();
				this.fakeElement.removeClass(this.options.dropActiveClass + ' ' + this.options.flipDropClass);
				this.dropdown.removeClass(this.options.flipDropClass).detach();
				this.doc.off('jcf-pointerdown', this.onOutsideClick);
				this.win.off('resize', this.onResize);
				this.dropActive = false;
				if (this.selectOpenedByEvent === 'touch') {
					this.onBlur();
				}
			}
		},
		toggleDropdown: function() {
			if (this.dropActive) {
				this.hideDropdown();
			} else {
				this.showDropdown();
			}
		},
		refreshSelectedText: function() {
			// redraw selected area
			var selectedIndex = this.realElement.prop('selectedIndex'),
			selectedOption = this.realElement.prop('options')[selectedIndex],
			selectedOptionImage = selectedOption ? selectedOption.getAttribute('data-image') : null,
			selectedOptionText = '',
			selectedOptionClasses,
			self = this;

			if (this.realElement.prop('multiple')) {
				$.each(this.realElement.prop('options'), function(index, option) {
					if (option.selected) {
						selectedOptionText += (selectedOptionText ? ', ' : '') + option.innerHTML;
					}
				});
				if (!selectedOptionText) {
					selectedOptionText = self.realElement.attr('placeholder') || '';
				}
				this.selectText.removeAttr('class').html(selectedOptionText);
			} else if (!selectedOption) {
				if (this.selectImage) {
					this.selectImage.hide();
				}
				this.selectText.removeAttr('class').empty();
			} else if (this.currentSelectedText !== selectedOption.innerHTML || this.currentSelectedImage !== selectedOptionImage) {
				selectedOptionClasses = getPrefixedClasses(selectedOption.className, this.options.optionClassPrefix);
				this.selectText.attr('class', selectedOptionClasses).html(selectedOption.innerHTML);

				if (selectedOptionImage) {
					if (!this.selectImage) {
						this.selectImage = $('<img>').prependTo(this.selectTextContainer).hide();
					}
					this.selectImage.attr('src', selectedOptionImage).show();
				} else if (this.selectImage) {
					this.selectImage.hide();
				}

				this.currentSelectedText = selectedOption.innerHTML;
				this.currentSelectedImage = selectedOptionImage;
			}
		},
		refresh: function() {
			// refresh fake select visibility
			if (this.realElement.prop('style').display === 'none') {
				this.fakeElement.hide();
			} else {
				this.fakeElement.show();
			}

			// refresh selected text
			this.refreshSelectedText();

			// handle disabled state
			this.fakeElement.toggleClass(this.options.disabledClass, this.realElement.is(':disabled'));
		},
		destroy: function() {
			// restore structure
			if (this.options.wrapNative) {
				this.realElement.insertBefore(this.fakeElement).css({
					position: '',
					height: '',
					width: ''
				}).removeClass(this.options.resetAppearanceClass);
			} else {
				this.realElement.removeClass(this.options.hiddenClass);
				if (this.realElement.is('[jcf-size]')) {
					this.realElement.removeAttr('size jcf-size');
				}
			}

			// removing element will also remove its event handlers
			this.fakeElement.remove();

			// remove other event handlers
			this.doc.off('jcf-pointerup', this.onSelectAreaRelease);
			this.realElement.off({
				focus: this.onFocus
			});
		}
	});

	// listbox module
	function ListBox(options) {
		this.options = $.extend({
			wrapNative: true,
			useCustomScroll: true,
			fakeStructure: '<span class="jcf-list-box"><span class="jcf-list-wrapper"></span></span>',
			selectClassPrefix: 'jcf-select-',
			listHolder: '.jcf-list-wrapper'
		}, options);
		this.init();
	}
	$.extend(ListBox.prototype, {
		init: function() {
			this.bindHandlers();
			this.initStructure();
			this.attachEvents();
		},
		initStructure: function() {
			this.realElement = $(this.options.element);
			this.fakeElement = $(this.options.fakeStructure).insertAfter(this.realElement);
			this.listHolder = this.fakeElement.find(this.options.listHolder);
			makeUnselectable(this.fakeElement);

			// copy classes from original select
			this.fakeElement.addClass(getPrefixedClasses(this.realElement.prop('className'), this.options.selectClassPrefix));
			this.realElement.addClass(this.options.hiddenClass);

			this.list = new SelectList({
				useCustomScroll: this.options.useCustomScroll,
				holder: this.listHolder,
				selectOnClick: false,
				element: this.realElement
			});
		},
		attachEvents: function() {
			// delayed refresh handler
			var self = this;
			this.delayedRefresh = function(e) {
				if (e && e.which === 16) {
					// ignore SHIFT key
					return;
				} else {
					clearTimeout(self.refreshTimer);
					self.refreshTimer = setTimeout(function() {
						self.refresh();
						self.list.scrollToActiveOption();
					}, 1);
				}
			};

			// other event handlers
			this.realElement.on({
				focus: this.onFocus,
				click: this.delayedRefresh,
				keydown: this.delayedRefresh
			});

			// select list event handlers
			$(this.list).on({
				select: this.onSelect,
				press: this.onFakeOptionsPress,
				release: this.onFakeOptionsRelease
			});
		},
		onFakeOptionsPress: function(e, pointerEvent) {
			this.pressedFlag = true;
			if (pointerEvent.pointerType === 'mouse') {
				this.realElement.focus();
			}
		},
		onFakeOptionsRelease: function(e, pointerEvent) {
			this.pressedFlag = false;
			if (pointerEvent.pointerType === 'mouse') {
				this.realElement.focus();
			}
		},
		onSelect: function() {
			this.fireNativeEvent(this.realElement, 'change');
			this.fireNativeEvent(this.realElement, 'click');
		},
		onFocus: function() {
			if (!this.pressedFlag || !this.focusedFlag) {
				this.fakeElement.addClass(this.options.focusClass);
				this.realElement.on('blur', this.onBlur);
				this.focusedFlag = true;
			}
		},
		onBlur: function() {
			if (!this.pressedFlag) {
				this.fakeElement.removeClass(this.options.focusClass);
				this.realElement.off('blur', this.onBlur);
				this.focusedFlag = false;
			}
		},
		refresh: function() {
			this.fakeElement.toggleClass(this.options.disabledClass, this.realElement.is(':disabled'));
			this.list.refresh();
		},
		destroy: function() {
			this.list.destroy();
			this.realElement.insertBefore(this.fakeElement).removeClass(this.options.hiddenClass);
			this.fakeElement.remove();
		}
	});

	// options list module
	function SelectList(options) {
		this.options = $.extend({
			holder: null,
			maxVisibleItems: 10,
			selectOnClick: true,
			useHoverClass: false,
			useCustomScroll: false,
			handleResize: true,
			multipleSelectWithoutKey: false,
			alwaysPreventMouseWheel: false,
			indexAttribute: 'data-index',
			cloneClassPrefix: 'jcf-option-',
			containerStructure: '<span class="jcf-list"><span class="jcf-list-content"></span></span>',
			containerSelector: '.jcf-list-content',
			captionClass: 'jcf-optgroup-caption',
			disabledClass: 'jcf-disabled',
			optionClass: 'jcf-option',
			groupClass: 'jcf-optgroup',
			hoverClass: 'jcf-hover',
			selectedClass: 'jcf-selected',
			scrollClass: 'jcf-scroll-active'
		}, options);
		this.init();
	}
	$.extend(SelectList.prototype, {
		init: function() {
			this.initStructure();
			this.refreshSelectedClass();
			this.attachEvents();
		},
		initStructure: function() {
			this.element = $(this.options.element);
			this.indexSelector = '[' + this.options.indexAttribute + ']';
			this.container = $(this.options.containerStructure).appendTo(this.options.holder);
			this.listHolder = this.container.find(this.options.containerSelector);
			this.lastClickedIndex = this.element.prop('selectedIndex');
			this.rebuildList();
		},
		attachEvents: function() {
			this.bindHandlers();
			this.listHolder.on('jcf-pointerdown', this.indexSelector, this.onItemPress);
			this.listHolder.on('jcf-pointerdown', this.onPress);

			if (this.options.useHoverClass) {
				this.listHolder.on('jcf-pointerover', this.indexSelector, this.onHoverItem);
			}
		},
		onPress: function(e) {
			$(this).trigger('press', e);
			this.listHolder.on('jcf-pointerup', this.onRelease);
		},
		onRelease: function(e) {
			$(this).trigger('release', e);
			this.listHolder.off('jcf-pointerup', this.onRelease);
		},
		onHoverItem: function(e) {
			var hoverIndex = parseFloat(e.currentTarget.getAttribute(this.options.indexAttribute));
			this.fakeOptions.removeClass(this.options.hoverClass).eq(hoverIndex).addClass(this.options.hoverClass);
		},
		onItemPress: function(e) {
			if (e.pointerType === 'touch' || this.options.selectOnClick) {
				// select option after "click"
				this.tmpListOffsetTop = this.list.offset().top;
				this.listHolder.on('jcf-pointerup', this.indexSelector, this.onItemRelease);
			} else {
				// select option immediately
				this.onSelectItem(e);
			}
		},
		onItemRelease: function(e) {
			// remove event handlers and temporary data
			this.listHolder.off('jcf-pointerup', this.indexSelector, this.onItemRelease);

			// simulate item selection
			if (this.tmpListOffsetTop === this.list.offset().top) {
				this.listHolder.on('click', this.indexSelector, { savedPointerType: e.pointerType }, this.onSelectItem);
			}
			delete this.tmpListOffsetTop;
		},
		onSelectItem: function(e) {
			var clickedIndex = parseFloat(e.currentTarget.getAttribute(this.options.indexAttribute)),
			pointerType = e.data && e.data.savedPointerType || e.pointerType || 'mouse',
			range;

			// remove click event handler
			this.listHolder.off('click', this.indexSelector, this.onSelectItem);

			// ignore clicks on disabled options
			if (e.button > 1 || this.realOptions[clickedIndex].disabled) {
				return;
			}

			if (this.element.prop('multiple')) {
				if (e.metaKey || e.ctrlKey || pointerType === 'touch' || this.options.multipleSelectWithoutKey) {
					// if CTRL/CMD pressed or touch devices - toggle selected option
					this.realOptions[clickedIndex].selected = !this.realOptions[clickedIndex].selected;
				} else if (e.shiftKey) {
					// if SHIFT pressed - update selection
					range = [this.lastClickedIndex, clickedIndex].sort(function(a, b) {
						return a - b;
					});
					this.realOptions.each(function(index, option) {
						option.selected = (index >= range[0] && index <= range[1]);
					});
				} else {
					// set single selected index
					this.element.prop('selectedIndex', clickedIndex);
				}
			} else {
				this.element.prop('selectedIndex', clickedIndex);
			}

			// save last clicked option
			if (!e.shiftKey) {
				this.lastClickedIndex = clickedIndex;
			}

			// refresh classes
			this.refreshSelectedClass();

			// scroll to active item in desktop browsers
			if (pointerType === 'mouse') {
				this.scrollToActiveOption();
			}

			// make callback when item selected
			$(this).trigger('select');
		},
		rebuildList: function() {
			// rebuild options
			var self = this,
			rootElement = this.element[0];

			// recursively create fake options
			this.storedSelectHTML = rootElement.innerHTML;
			this.optionIndex = 0;
			this.list = $(this.createOptionsList(rootElement));
			this.listHolder.empty().append(this.list);
			this.realOptions = this.element.find('option');
			this.fakeOptions = this.list.find(this.indexSelector);
			this.fakeListItems = this.list.find('.' + this.options.captionClass + ',' + this.indexSelector);
			delete this.optionIndex;

			// detect max visible items
			var maxCount = this.options.maxVisibleItems,
			sizeValue = this.element.prop('size');
			if (sizeValue > 1 && !this.element.is('[jcf-size]')) {
				maxCount = sizeValue;
			}

			// handle scrollbar
			var needScrollBar = this.fakeOptions.length > maxCount;
			this.container.toggleClass(this.options.scrollClass, needScrollBar);
			if (needScrollBar) {
				// change max-height
				this.listHolder.css({
					maxHeight: this.getOverflowHeight(maxCount),
					overflow: 'auto'
				});

				if (this.options.useCustomScroll && jcf.modules.Scrollable) {
					// add custom scrollbar if specified in options
					jcf.replace(this.listHolder, 'Scrollable', {
						handleResize: this.options.handleResize,
						alwaysPreventMouseWheel: this.options.alwaysPreventMouseWheel
					});
					return;
				}
			}

			// disable edge wheel scrolling
			if (this.options.alwaysPreventMouseWheel) {
				this.preventWheelHandler = function(e) {
					var currentScrollTop = self.listHolder.scrollTop(),
					maxScrollTop = self.listHolder.prop('scrollHeight') - self.listHolder.innerHeight();

					// check edge cases
					if ((currentScrollTop <= 0 && e.deltaY < 0) || (currentScrollTop >= maxScrollTop && e.deltaY > 0)) {
						e.preventDefault();
					}
				};
				this.listHolder.on('jcf-mousewheel', this.preventWheelHandler);
			}
		},
		refreshSelectedClass: function() {
			var self = this,
			selectedItem,
			isMultiple = this.element.prop('multiple'),
			selectedIndex = this.element.prop('selectedIndex');

			if (isMultiple) {
				this.realOptions.each(function(index, option) {
					self.fakeOptions.eq(index).toggleClass(self.options.selectedClass, !!option.selected);
				});
			} else {
				this.fakeOptions.removeClass(this.options.selectedClass + ' ' + this.options.hoverClass);
				selectedItem = this.fakeOptions.eq(selectedIndex).addClass(this.options.selectedClass);
				if (this.options.useHoverClass) {
					selectedItem.addClass(this.options.hoverClass);
				}
			}
		},
		scrollToActiveOption: function() {
			// scroll to target option
			var targetOffset = this.getActiveOptionOffset();
			if (typeof targetOffset === 'number') {
				this.listHolder.prop('scrollTop', targetOffset);
			}
		},
		getSelectedIndexRange: function() {
			var firstSelected = -1, lastSelected = -1;
			this.realOptions.each(function(index, option) {
				if (option.selected) {
					if (firstSelected < 0) {
						firstSelected = index;
					}
					lastSelected = index;
				}
			});
			return [firstSelected, lastSelected];
		},
		getChangedSelectedIndex: function() {
			var selectedIndex = this.element.prop('selectedIndex'),
			targetIndex;

			if (this.element.prop('multiple')) {
				// multiple selects handling
				if (!this.previousRange) {
					this.previousRange = [selectedIndex, selectedIndex];
				}
				this.currentRange = this.getSelectedIndexRange();
				targetIndex = this.currentRange[this.currentRange[0] !== this.previousRange[0] ? 0 : 1];
				this.previousRange = this.currentRange;
				return targetIndex;
			} else {
				// single choice selects handling
				return selectedIndex;
			}
		},
		getActiveOptionOffset: function() {
			// calc values
			var dropHeight = this.listHolder.height(),
			dropScrollTop = this.listHolder.prop('scrollTop'),
			currentIndex = this.getChangedSelectedIndex(),
			fakeOption = this.fakeOptions.eq(currentIndex),
			fakeOptionOffset = fakeOption.offset().top - this.list.offset().top,
			fakeOptionHeight = fakeOption.innerHeight();

			// scroll list
			if (fakeOptionOffset + fakeOptionHeight >= dropScrollTop + dropHeight) {
				// scroll down (always scroll to option)
				return fakeOptionOffset - dropHeight + fakeOptionHeight;
			} else if (fakeOptionOffset < dropScrollTop) {
				// scroll up to option
				return fakeOptionOffset;
			}
		},
		getOverflowHeight: function(sizeValue) {
			var item = this.fakeListItems.eq(sizeValue - 1),
			listOffset = this.list.offset().top,
			itemOffset = item.offset().top,
			itemHeight = item.innerHeight();

			return itemOffset + itemHeight - listOffset;
		},
		getScrollTop: function() {
			return this.listHolder.scrollTop();
		},
		setScrollTop: function(value) {
			this.listHolder.scrollTop(value);
		},
		createOption: function(option) {
			var newOption = document.createElement('span');
			newOption.className = this.options.optionClass;
			newOption.innerHTML = option.innerHTML;
			newOption.setAttribute(this.options.indexAttribute, this.optionIndex++);

			var optionImage, optionImageSrc = option.getAttribute('data-image');
			if (optionImageSrc) {
				optionImage = document.createElement('img');
				optionImage.src = optionImageSrc;
				newOption.insertBefore(optionImage, newOption.childNodes[0]);
			}
			if (option.disabled) {
				newOption.className += ' ' + this.options.disabledClass;
			}
			if (option.className) {
				newOption.className += ' ' + getPrefixedClasses(option.className, this.options.cloneClassPrefix);
			}
			return newOption;
		},
		createOptGroup: function(optgroup) {
			var optGroupContainer = document.createElement('span'),
			optGroupName = optgroup.getAttribute('label'),
			optGroupCaption, optGroupList;

			// create caption
			optGroupCaption = document.createElement('span');
			optGroupCaption.className = this.options.captionClass;
			optGroupCaption.innerHTML = optGroupName;
			optGroupContainer.appendChild(optGroupCaption);

			// create list of options
			if (optgroup.children.length) {
				optGroupList = this.createOptionsList(optgroup);
				optGroupContainer.appendChild(optGroupList);
			}

			optGroupContainer.className = this.options.groupClass;
			return optGroupContainer;
		},
		createOptionContainer: function() {
			var optionContainer = document.createElement('li');
			return optionContainer;
		},
		createOptionsList: function(container) {
			var self = this,
			list = document.createElement('ul');

			$.each(container.children, function(index, currentNode) {
				var item = self.createOptionContainer(currentNode),
				newNode;

				switch (currentNode.tagName.toLowerCase()) {
					case 'option': newNode = self.createOption(currentNode); break;
					case 'optgroup': newNode = self.createOptGroup(currentNode); break;
				}
				list.appendChild(item).appendChild(newNode);
			});
			return list;
		},
		refresh: function() {
			// check for select innerHTML changes
			if (this.storedSelectHTML !== this.element.prop('innerHTML')) {
				this.rebuildList();
			}

			// refresh custom scrollbar
			var scrollInstance = jcf.getInstance(this.listHolder);
			if (scrollInstance) {
				scrollInstance.refresh();
			}

			// refresh selectes classes
			this.refreshSelectedClass();
		},
		destroy: function() {
			this.listHolder.off('jcf-mousewheel', this.preventWheelHandler);
			this.listHolder.off('jcf-pointerdown', this.indexSelector, this.onSelectItem);
			this.listHolder.off('jcf-pointerover', this.indexSelector, this.onHoverItem);
			this.listHolder.off('jcf-pointerdown', this.onPress);
		}
	});

	// helper functions
	var getPrefixedClasses = function(className, prefixToAdd) {
		return className ? className.replace(/[\s]*([\S]+)+[\s]*/gi, prefixToAdd + '$1 ') : '';
	};
	var makeUnselectable = (function() {
		var unselectableClass = jcf.getOptions().unselectableClass;
		function preventHandler(e) {
			e.preventDefault();
		}
		return function(node) {
			node.addClass(unselectableClass).on('selectstart', preventHandler);
		};
	}());

}(jQuery, this));

/*
 * Convert navigation to select
 */
 ;(function($) {
 	function NavigationSelect(options) {
 		this.options = $.extend({
 			list: null,
 			levelIndentHTML: ' &bull; ',
 			defaultOptionAttr: 'title',
 			defaultOptionText: '...',
 			selectClass: 'nav-select',
 			activeClass: 'nav-active',
 			defaultOptionClass: 'opt-default',
 			hasDropClass: 'opt-sublevel',
 			levelPrefixClass: 'opt-level-',
 			useDefaultOption: false
 		}, options);
 		if(this.options.list) {
 			this.createSelect();
 			this.attachEvents();
 		}
 	}
 	NavigationSelect.prototype = {
 		createSelect: function() {
 			var self = this;
 			this.startIndex = 0;
 			this.navigation = $(this.options.list);
 			this.select = $('<select>').addClass(this.options.selectClass);
 			this.createDefaultOption();
 			this.createList(this.navigation, 0);
 			this.select.insertBefore(this.navigation);
 		},
 		createDefaultOption: function() {
 			if(this.options.useDefaultOption) {
 				var attrText = this.navigation.attr(this.options.defaultOptionAttr);
 				var defaultOption = $('<option>').addClass(this.options.defaultOptionClass).text(attrText || this.options.defaultOptionText);
 				this.navigation.removeAttr(this.options.defaultOptionAttr);
 				this.select.append(defaultOption);
 				this.startIndex = 1;
 			}
 		},
 		createList: function(list, level) {
 			var self = this;
 			list.children().each(function(index, item) {
 				var listItem = $(this),
 				listLink = listItem.find('a').eq(0),
 				listDrop = listItem.find('ul').eq(0),
 				hasDrop = listDrop.length > 0;

 				if(listLink.length) {
 					self.select.append(self.createOption(listLink, hasDrop, level, listLink.hasClass(self.options.activeClass)));
 				}
 				if(hasDrop) {
 					self.createList(listDrop, level + 1);
 				}
 			});
 		},
 		createOption: function(link, hasDrop, level, selected) {
 			var optionHTML = this.getLevelIndent(level) + link.html();
 			return $('<option>').html(optionHTML)
 			.addClass(this.options.levelPrefixClass + (level + 1))
 			.toggleClass(this.options.hasDropClass, hasDrop)
 			.val(link.data('href')).attr('id', 'option-' + link.data('href')).attr('selected', selected ? 'selected' : false); // [dom] added id to find option, and changed attr('href') to data('href'), so that no link is present in the desktop-case
 		},
 		getLevelIndent: function(level) {
 			return (new Array(level + 1)).join(this.options.levelIndentHTML);
 		},
 		attachEvents: function() {
			// redirect on select change
			var self = this;
			this.select.change(function() {
				if(this.selectedIndex >= self.startIndex) {
					// [dom] replaced redirect with click on element, we want angular to handle this
				    //location.href = this.value;
				    $('#'+this.value).trigger("click");
				}
			});
		}
	};

	// jquery pluginm interface
	$.fn.navigationSelect = function(opt) {
		return this.each(function() {
			new NavigationSelect($.extend({list: this}, opt));
		});
	};
}(jQuery));


/*
 * jQuery sticky box plugin
 */
 ;(function($, $win) {

 	'use strict';

 	function StickyScrollBlock($stickyBox, options) {
 		this.options = options;
 		this.$stickyBox = $stickyBox;
 		this.init();
 	}

 	var StickyScrollBlockPrototype = {
 		init: function() {
 			this.findElements();
 			this.attachEvents();
 			this.makeCallback('onInit');
 		},

 		findElements: function() {
			// find parent container in which will be box move
			this.$container = this.$stickyBox.closest(this.options.container);
			// define box wrap flag
			this.isWrap = this.options.positionType === 'fixed' && this.options.setBoxHeight;
			// define box move flag
			this.moveInContainer = !!this.$container.length;
			// wrapping box to set place in content
			if (this.isWrap) {
				this.$stickyBoxWrap = this.$stickyBox.wrap('<div class="' + this.getWrapClass() + '"/>').parent();
			}
			//define block to add active class
			this.parentForActive = this.getParentForActive();
			this.isInit = true;
		},

		attachEvents: function() {
			var self = this;

			// bind events
			this.onResize = function() {
				if (!self.isInit) return;
				self.resetState();
				self.recalculateOffsets();
				self.checkStickyPermission();
				self.scrollHandler();
			};

			this.onScroll = function() {
				self.scrollHandler();
			};

			// initial handler call
			this.onResize();

			// handle events
			$win.on('load resize orientationchange', this.onResize)
			.on('scroll', this.onScroll);
		},

		defineExtraTop: function() {
			// define box's extra top dimension
			var extraTop;

			if (typeof this.options.extraTop === 'number') {
				extraTop = this.options.extraTop;
			} else if (typeof this.options.extraTop === 'function') {
				extraTop = this.options.extraTop();
			}

			this.extraTop = this.options.positionType === 'absolute' ?
			extraTop :
			Math.min(this.winParams.height - this.data.boxFullHeight, extraTop);
		},

		checkStickyPermission: function() {
			// check the permission to set sticky
			this.isStickyEnabled = this.moveInContainer ?
			this.data.containerOffsetTop + this.data.containerHeight > this.data.boxFullHeight + this.data.boxOffsetTop + this.options.extraBottom :
			true;
		},

		getParentForActive: function() {
			if (this.isWrap) {
				return this.$stickyBoxWrap;
			}

			if (this.$container.length) {
				return this.$container;
			}

			return this.$stickyBox;
		},

		getWrapClass: function() {
			// get set of container classes
			try {
				return this.$stickyBox.attr('class').split(' ').map(function(name) {
					return 'sticky-wrap-' + name;
				}).join(' ');
			} catch (err) {
				return 'sticky-wrap';
			}
		},

		resetState: function() {
			// reset dimensions and state
			this.stickyFlag = false;
			this.$stickyBox.css({
				'-webkit-transition': '',
				'-webkit-transform': '',
				transition: '',
				transform: '',
				position: '',
				width: '',
				left: '',
				top: ''
			}).removeClass(this.options.activeClass);

			if (this.isWrap) {
				this.$stickyBoxWrap.removeClass(this.options.activeClass).removeAttr('style');
			}

			if (this.moveInContainer) {
				this.$container.removeClass(this.options.activeClass);
			}
		},

		recalculateOffsets: function() {
			// define box and container dimensions
			this.winParams = this.getWindowParams();

			this.data = $.extend(
				this.getBoxOffsets(),
				this.getContainerOffsets()
				);

			this.defineExtraTop();
		},

		getBoxOffsets: function() {
			var boxOffset = this.$stickyBox.offset();
			var boxPosition = this.$stickyBox.position();

			return {
				// sticky box offsets
				boxOffsetLeft: boxOffset.left,
				boxOffsetTop: boxOffset.top,
				// sticky box positions
				boxTopPosition: boxPosition.top,
				boxLeftPosition: boxPosition.left,
				// sticky box width/height
				boxFullHeight: this.$stickyBox.outerHeight(true),
				boxHeight: this.$stickyBox.outerHeight(),
				boxWidth: this.$stickyBox.outerWidth()
			};
		},

		getContainerOffsets: function() {
			var containerOffset = this.moveInContainer ? this.$container.offset() : null;

			return containerOffset ? {
				// container offsets
				containerOffsetLeft: containerOffset.left,
				containerOffsetTop: containerOffset.top,
				// container height
				containerHeight: this.$container.outerHeight()
			} : {};
		},

		getWindowParams: function() {
			return {
				height: window.innerHeight || document.documentElement.clientHeight
			};
		},

		makeCallback: function(name) {
			if (typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		},

		destroy: function() {
			this.isInit = false;
			// remove event handlers and styles
			$win.off('load resize orientationchange', this.onResize)
			.off('scroll', this.onScroll);
			this.resetState();
			this.$stickyBox.removeData('StickyScrollBlock');
			if (this.isWrap) {
				this.$stickyBox.unwrap();
			}
			this.makeCallback('onDestroy');
		}
	};

	var stickyMethods = {
		fixed: {
			scrollHandler: function() {
				this.winScrollTop = $win.scrollTop();
				var isActiveSticky = this.winScrollTop -
				(this.options.showAfterScrolled ? this.extraTop : 0) -
				(this.options.showAfterScrolled ? this.data.boxHeight + this.extraTop : 0) >
				this.data.boxOffsetTop - this.extraTop;

				if (isActiveSticky) {
					this.isStickyEnabled && this.stickyOn();
				} else {
					this.stickyOff();
				}
			},

			stickyOn: function() {
				if (!this.stickyFlag) {
					this.stickyFlag = true;
					this.parentForActive.addClass(this.options.activeClass);
					this.$stickyBox.css({
						width: this.data.boxWidth,
						position: this.options.positionType
					});
					if (this.isWrap) {
						this.$stickyBoxWrap.css({
							height: this.data.boxFullHeight
						});
					}
					this.makeCallback('fixedOn');
				}
				this.setDynamicPosition();
			},

			stickyOff: function() {
				if (this.stickyFlag) {
					this.stickyFlag = false;
					this.resetState();
					this.makeCallback('fixedOff');
				}
			},

			setDynamicPosition: function() {
				this.$stickyBox.css({
					top: this.getTopPosition(),
					left: this.data.boxOffsetLeft - $win.scrollLeft()
				});
			},

			getTopPosition: function() {
				if (this.moveInContainer) {
					var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;

					return Math.min(this.extraTop, (this.data.containerHeight + this.data.containerOffsetTop) - currScrollTop);
				} else {
					return this.extraTop;
				}
			}
		},
		absolute: {
			scrollHandler: function() {
				this.winScrollTop = $win.scrollTop();
				var isActiveSticky = this.winScrollTop > this.data.boxOffsetTop - this.extraTop;

				if (isActiveSticky) {
					this.isStickyEnabled && this.stickyOn();
				} else {
					this.stickyOff();
				}
			},

			stickyOn: function() {
				if (!this.stickyFlag) {
					this.stickyFlag = true;
					this.parentForActive.addClass(this.options.activeClass);
					this.$stickyBox.css({
						width: this.data.boxWidth,
						transition: 'transform ' + this.options.animSpeed + 's ease',
						'-webkit-transition': 'transform ' + this.options.animSpeed + 's ease',
					});

					if (this.isWrap) {
						this.$stickyBoxWrap.css({
							height: this.data.boxFullHeight
						});
					}

					this.makeCallback('fixedOn');
				}

				this.clearTimer();
				this.timer = setTimeout(function() {
					this.setDynamicPosition();
				}.bind(this), this.options.animDelay * 1000);
			},

			stickyOff: function() {
				if (this.stickyFlag) {
					this.clearTimer();
					this.stickyFlag = false;

					this.timer = setTimeout(function() {
						this.setDynamicPosition();
						setTimeout(function() {
							this.resetState();
						}.bind(this), this.options.animSpeed * 1000);
					}.bind(this), this.options.animDelay * 1000);
					this.makeCallback('fixedOff');
				}
			},

			clearTimer: function() {
				clearTimeout(this.timer);
			},

			setDynamicPosition: function() {
				var topPosition = Math.max(0, this.getTopPosition());

				this.$stickyBox.css({
					transform: 'translateY(' + topPosition + 'px)',
					'-webkit-transform': 'translateY(' + topPosition + 'px)'
				});
			},

			getTopPosition: function() {
				var currTopPosition = this.winScrollTop - this.data.boxOffsetTop + this.extraTop;

				if (this.moveInContainer) {
					var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
					var diffOffset = Math.abs(Math.min(0, (this.data.containerHeight + this.data.containerOffsetTop) - currScrollTop - this.extraTop));

					return currTopPosition - diffOffset;
				} else {
					return currTopPosition;
				}
			}
		}
	};

	// jQuery plugin interface
	$.fn.stickyScrollBlock = function(opt) {
		var args = Array.prototype.slice.call(arguments);
		var method = args[0];

		var options = $.extend({
			container: null,
			positionType: 'fixed', // 'fixed' or 'absolute'
			activeClass: 'fixed-position',
			setBoxHeight: true,
			showAfterScrolled: false,
			extraTop: 0,
			extraBottom: 0,
			animDelay: 0.1,
			animSpeed: 0.2
		}, opt);

		return this.each(function() {
			var $stickyBox = jQuery(this);
			var instance = $stickyBox.data('StickyScrollBlock');

			if (typeof opt === 'object' || typeof opt === 'undefined') {
				StickyScrollBlock.prototype = $.extend(stickyMethods[options.positionType], StickyScrollBlockPrototype);
				$stickyBox.data('StickyScrollBlock', new StickyScrollBlock($stickyBox, options));
			} else if (typeof method === 'string' && instance) {
				if (typeof instance[method] === 'function') {
					args.shift();
					instance[method].apply(instance, args);
				}
			}
		});
	};

	// module exports
	window.StickyScrollBlock = StickyScrollBlock;
}(jQuery, jQuery(window)));

 /*
 * Responsive Layout helper
 */
 ResponsiveHelper = (function($){
	// init variables
	var handlers = [],
	prevWinWidth,
	win = $(window),
	nativeMatchMedia = false;

	// detect match media support
	if(window.matchMedia) {
		if(window.Window && window.matchMedia === Window.prototype.matchMedia) {
			nativeMatchMedia = true;
		} else if(window.matchMedia.toString().indexOf('native') > -1) {
			nativeMatchMedia = true;
		}
	}

	// prepare resize handler
	function resizeHandler() {
		var winWidth = win.width();
		if(winWidth !== prevWinWidth) {
			prevWinWidth = winWidth;

			// loop through range groups
			$.each(handlers, function(index, rangeObject){
				// disable current active area if needed
				$.each(rangeObject.data, function(property, item) {
					if(item.currentActive && !matchRange(item.range[0], item.range[1])) {
						item.currentActive = false;
						if(typeof item.disableCallback === 'function') {
							item.disableCallback();
						}
					}
				});

				// enable areas that match current width
				$.each(rangeObject.data, function(property, item) {
					if(!item.currentActive && matchRange(item.range[0], item.range[1])) {
						// make callback
						item.currentActive = true;
						if(typeof item.enableCallback === 'function') {
							item.enableCallback();
						}
					}
				});
			});
		}
	}
	win.bind('load resize orientationchange', resizeHandler);

	// test range
	function matchRange(r1, r2) {
		var mediaQueryString = '';
		if(r1 > 0) {
			mediaQueryString += '(min-width: ' + r1 + 'px)';
		}
		if(r2 < Infinity) {
			mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
		}
		return matchQuery(mediaQueryString, r1, r2);
	}

	// media query function
	function matchQuery(query, r1, r2) {
		if(window.matchMedia && nativeMatchMedia) {
			return matchMedia(query).matches;
		} else if(window.styleMedia) {
			return styleMedia.matchMedium(query);
		} else if(window.media) {
			return media.matchMedium(query);
		} else {
			return prevWinWidth >= r1 && prevWinWidth <= r2;
		}
	}

	// range parser
	function parseRange(rangeStr) {
		var rangeData = rangeStr.split('..');
		var x1 = parseInt(rangeData[0], 10) || -Infinity;
		var x2 = parseInt(rangeData[1], 10) || Infinity;
		return [x1, x2].sort(function(a, b){
			return a - b;
		});
	}

	// export public functions
	return {
		addRange: function(ranges) {
			// parse data and add items to collection
			var result = {data:{}};
			$.each(ranges, function(property, data){
				result.data[property] = {
					range: parseRange(property),
					enableCallback: data.on,
					disableCallback: data.off
				};
			});
			handlers.push(result);

			// call resizeHandler to recalculate all events
			prevWinWidth = null;
			resizeHandler();
		}
	};
}(jQuery));

/*
 * jQuery Load More plugin
 */
 ;(function($, $win) {

 	'use strict';

 	var ScrollLoader = {
 		attachEvents: function() {
 			var self = this;

 			$win.on('load.ScrollLoader resize.ScrollLoader orientationchange.ScrollLoader', function() { self.onResizeHandler(); });
 			$win.on('scroll.ScrollLoader', function() { self.onScrollHandler(); });
 			this.$holder.on('ContentLoader/loaded.ScrollLoader', function() { self.onResizeHandler(); });

 			this.winProps = {};
 			this.holderProps = {};
 			this.onResizeHandler();
 		},

 		onResizeHandler: function() {
 			this.winProps.height = $win.height();
 			this.holderProps.height = this.$holder.outerHeight();
 			this.holderProps.offset = this.$holder.offset().top;

 			this.onScrollHandler();
 		},

 		onScrollHandler: function() {
 			this.winProps.scroll = $win.scrollTop();

 			if (this.winProps.scroll + this.winProps.height + Math.min(1, this.options.additionBottomOffset) > this.holderProps.height + this.holderProps.offset) {
 				this.loadInclude();
 			}
 		},

 		destroySubEvents: function() {
 			$win.off('.ScrollLoader');
 			this.$holder.off('.ScrollLoader');
 		}
 	};

 	var ClickLoader = {
 		attachEvents: function() {
 			var self = this;

 			this.$holder.on('click.ClickLoader', this.options.linkSelector, function(e) { self.onClickHandler(e); });
 		},

 		onClickHandler: function(e) {
 			e.preventDefault();

 			this.loadInclude();
 		},

 		destroySubEvents: function() {
 			this.$holder.off('.ClickLoader');
 		}
 	};

 	var ContentLoader = function($holder, options) {
 		this.$holder = $holder;
 		this.options = options;

 		this.init();
 	};

 	var ContentLoaderProto = {
 		init: function() {
 			this.$link = this.$holder.find(this.options.linkSelector);
 			this.$newContentTarget = this.options.newContentTarget ? this.$holder.find(this.options.newContentTarget) : this.$holder;

 			if (!this.$link.length) {
 				this.removeInstance();
 				return;
 			}

 			this.attachEvents();
 		},

 		loadInclude: function() {
 			if (this.isBusy) {
 				return;
 			}

 			var self = this;

 			this.toggleBusyMode(true);

 			$.get(self.$link.attr('href'), function(source) { self.successHandler(source); });
 		},

 		successHandler: function(include) {
 			var $tmpDiv = jQuery('<div>').html(include);
 			var $nextIncludeLink = $tmpDiv.find(this.options.linkSelector);

 			if ($nextIncludeLink.length) {
 				this.refreshLink($nextIncludeLink);
 			} else {
 				this.destroy();
 			}

 			this.appendItems($tmpDiv.children());
 		},

 		appendItems: function($newItems) {
 			var self = this;

 			this.$newContentTarget.append($newItems.addClass(this.options.preAppendClass));

			setTimeout(function() { // need this timeout coz need some time for css preAppendClass applied to the new items
				$newItems.removeClass(self.options.preAppendClass);

				self.toggleBusyMode(false);
				self.$holder.trigger('ContentLoader/loaded');
			}, 100);

			if (window.picturefill) {
				window.picturefill();
			}
		},

		refreshLink: function($nextIncludeLink) {
			this.$link.attr('href', $nextIncludeLink.attr('href'));
			$nextIncludeLink.remove();
		},

		toggleBusyMode: function(state) {
			this.$holder.toggleClass(this.options.busyClass, state);
			this.isBusy = state;
		},

		removeInstance: function() {
			this.$holder.removeData('ContentLoader');
		},

		destroy: function() {
			this.removeInstance();
			this.destroySubEvents();

			this.$link.remove();
		}
	};

	$.fn.loadMore = function(opt) {
		var args = Array.prototype.slice.call(arguments);
		var method = args[0];

		var options = $.extend({
			scroll: false,
			linkSelector: '.load-more',
			newContentTarget: null,
			busyClass: 'is-busy',
			additionBottomOffset: 50,
			preAppendClass: 'new-item'
		}, opt);

		return this.each(function() {
			var $holder = jQuery(this);
			var instance = $holder.data('ContentLoader');

			if (typeof opt === 'object' || typeof opt === 'undefined') {
				ContentLoader.prototype = $.extend(options.scroll ? ScrollLoader : ClickLoader, ContentLoaderProto);

				$holder.data('ContentLoader', new ContentLoader($holder, options));
			} else if (typeof method === 'string' && instance) {
				if (typeof instance[method] === 'function') {
					args.shift();
					instance[method].apply(instance, args);
				}
			}
		});
	};
}(jQuery, jQuery(window)));

/*
 _ _      _       _
 ___| (_) ___| | __  (_)___
 / __| | |/ __| |/ /  | / __|
 \__ \ | | (__|   < _ | \__ \
 |___/_|_|\___|_|\_(_)/ |___/
 |__/

 Version: 1.6.0
 Author: Ken Wheeler
 Website: http://kenwheeler.github.io
 Docs: http://kenwheeler.github.io/slick
 Repo: http://github.com/kenwheeler/slick
 Issues: http://github.com/kenwheeler/slick/issues

 */
 !function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):"undefined"!=typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){"use strict";var b=window.Slick||{};b=function(){function c(c,d){var f,e=this;e.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:a(c),appendDots:a(c),arrows:!0,asNavFor:null,prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(b,c){return a('<button type="button" data-role="none" role="button" tabindex="0" />').text(c+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:100,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:10,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},e.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},a.extend(e,e.initials),e.activeBreakpoint=null,e.animType=null,e.animProp=null,e.breakpoints=[],e.breakpointSettings=[],e.cssTransitions=!1,e.focussed=!1,e.interrupted=!1,e.hidden="hidden",e.paused=!0,e.positionProp=null,e.respondTo=null,e.rowCount=1,e.shouldClick=!0,e.$slider=a(c),e.$slidesCache=null,e.transformType=null,e.transitionType=null,e.visibilityChange="visibilitychange",e.windowWidth=0,e.windowTimer=null,f=a(c).data("slick")||{},e.options=a.extend({},e.defaults,d,f),e.currentSlide=e.options.initialSlide,e.originalSettings=e.options,"undefined"!=typeof document.mozHidden?(e.hidden="mozHidden",e.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(e.hidden="webkitHidden",e.visibilityChange="webkitvisibilitychange"),e.autoPlay=a.proxy(e.autoPlay,e),e.autoPlayClear=a.proxy(e.autoPlayClear,e),e.autoPlayIterator=a.proxy(e.autoPlayIterator,e),e.changeSlide=a.proxy(e.changeSlide,e),e.clickHandler=a.proxy(e.clickHandler,e),e.selectHandler=a.proxy(e.selectHandler,e),e.setPosition=a.proxy(e.setPosition,e),e.swipeHandler=a.proxy(e.swipeHandler,e),e.dragHandler=a.proxy(e.dragHandler,e),e.keyHandler=a.proxy(e.keyHandler,e),e.instanceUid=b++,e.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,e.registerBreakpoints(),e.init(!0)}var b=0;return c}(),b.prototype.activateADA=function(){var a=this;a.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},b.prototype.addSlide=b.prototype.slickAdd=function(b,c,d){var e=this;if("boolean"==typeof c)d=c,c=null;else if(0>c||c>=e.slideCount)return!1;e.unload(),"number"==typeof c?0===c&&0===e.$slides.length?a(b).appendTo(e.$slideTrack):d?a(b).insertBefore(e.$slides.eq(c)):a(b).insertAfter(e.$slides.eq(c)):d===!0?a(b).prependTo(e.$slideTrack):a(b).appendTo(e.$slideTrack),e.$slides=e.$slideTrack.children(this.options.slide),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.append(e.$slides),e.$slides.each(function(b,c){a(c).attr("data-slick-index",b)}),e.$slidesCache=e.$slides,e.reinit()},b.prototype.animateHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.animate({height:b},a.options.speed)}},b.prototype.animateSlide=function(b,c){var d={},e=this;e.animateHeight(),e.options.rtl===!0&&e.options.vertical===!1&&(b=-b),e.transformsEnabled===!1?e.options.vertical===!1?e.$slideTrack.animate({left:b},e.options.speed,e.options.easing,c):e.$slideTrack.animate({top:b},e.options.speed,e.options.easing,c):e.cssTransitions===!1?(e.options.rtl===!0&&(e.currentLeft=-e.currentLeft),a({animStart:e.currentLeft}).animate({animStart:b},{duration:e.options.speed,easing:e.options.easing,step:function(a){a=Math.ceil(a),e.options.vertical===!1?(d[e.animType]="translate("+a+"px, 0px)",e.$slideTrack.css(d)):(d[e.animType]="translate(0px,"+a+"px)",e.$slideTrack.css(d))},complete:function(){c&&c.call()}})):(e.applyTransition(),b=Math.ceil(b),e.options.vertical===!1?d[e.animType]="translate3d("+b+"px, 0px, 0px)":d[e.animType]="translate3d(0px,"+b+"px, 0px)",e.$slideTrack.css(d),c&&setTimeout(function(){e.disableTransition(),c.call()},e.options.speed))},b.prototype.getNavTarget=function(){var b=this,c=b.options.asNavFor;return c&&null!==c&&(c=a(c).not(b.$slider)),c},b.prototype.asNavFor=function(b){var c=this,d=c.getNavTarget();null!==d&&"object"==typeof d&&d.each(function(){var c=a(this).slick("getSlick");c.unslicked||c.slideHandler(b,!0)})},b.prototype.applyTransition=function(a){var b=this,c={};b.options.fade===!1?c[b.transitionType]=b.transformType+" "+b.options.speed+"ms "+b.options.cssEase:c[b.transitionType]="opacity "+b.options.speed+"ms "+b.options.cssEase,b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.autoPlay=function(){var a=this;a.autoPlayClear(),a.slideCount>a.options.slidesToShow&&(a.autoPlayTimer=setInterval(a.autoPlayIterator,a.options.autoplaySpeed))},b.prototype.autoPlayClear=function(){var a=this;a.autoPlayTimer&&clearInterval(a.autoPlayTimer)},b.prototype.autoPlayIterator=function(){var a=this,b=a.currentSlide+a.options.slidesToScroll;a.paused||a.interrupted||a.focussed||(a.options.infinite===!1&&(1===a.direction&&a.currentSlide+1===a.slideCount-1?a.direction=0:0===a.direction&&(b=a.currentSlide-a.options.slidesToScroll,a.currentSlide-1===0&&(a.direction=1))),a.slideHandler(b))},b.prototype.buildArrows=function(){var b=this;b.options.arrows===!0&&(b.$prevArrow=a(b.options.prevArrow).addClass("slick-arrow"),b.$nextArrow=a(b.options.nextArrow).addClass("slick-arrow"),b.slideCount>b.options.slidesToShow?(b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.prependTo(b.options.appendArrows),b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.appendTo(b.options.appendArrows),b.options.infinite!==!0&&b.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},b.prototype.buildDots=function(){var c,d,b=this;if(b.options.dots===!0&&b.slideCount>b.options.slidesToShow){for(b.$slider.addClass("slick-dotted"),d=a("<ul />").addClass(b.options.dotsClass),c=0;c<=b.getDotCount();c+=1)d.append(a("<li />").append(b.options.customPaging.call(this,b,c)));b.$dots=d.appendTo(b.options.appendDots),b.$dots.find("li").first().addClass("slick-active").attr("aria-hidden","false")}},b.prototype.buildOut=function(){var b=this;b.$slides=b.$slider.children(b.options.slide+":not(.slick-cloned)").addClass("slick-slide"),b.slideCount=b.$slides.length,b.$slides.each(function(b,c){a(c).attr("data-slick-index",b).data("originalStyling",a(c).attr("style")||"")}),b.$slider.addClass("slick-slider"),b.$slideTrack=0===b.slideCount?a('<div class="slick-track"/>').appendTo(b.$slider):b.$slides.wrapAll('<div class="slick-track"/>').parent(),b.$list=b.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),b.$slideTrack.css("opacity",0),(b.options.centerMode===!0||b.options.swipeToSlide===!0)&&(b.options.slidesToScroll=1),a("img[data-lazy]",b.$slider).not("[src]").addClass("slick-loading"),b.setupInfinite(),b.buildArrows(),b.buildDots(),b.updateDots(),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.options.draggable===!0&&b.$list.addClass("draggable")},b.prototype.buildRows=function(){var b,c,d,e,f,g,h,a=this;if(e=document.createDocumentFragment(),g=a.$slider.children(),a.options.rows>1){for(h=a.options.slidesPerRow*a.options.rows,f=Math.ceil(g.length/h),b=0;f>b;b++){var i=document.createElement("div");for(c=0;c<a.options.rows;c++){var j=document.createElement("div");for(d=0;d<a.options.slidesPerRow;d++){var k=b*h+(c*a.options.slidesPerRow+d);g.get(k)&&j.appendChild(g.get(k))}i.appendChild(j)}e.appendChild(i)}a.$slider.empty().append(e),a.$slider.children().children().children().css({width:100/a.options.slidesPerRow+"%",display:"inline-block"})}},b.prototype.checkResponsive=function(b,c){var e,f,g,d=this,h=!1,i=d.$slider.width(),j=window.innerWidth||a(window).width();if("window"===d.respondTo?g=j:"slider"===d.respondTo?g=i:"min"===d.respondTo&&(g=Math.min(j,i)),d.options.responsive&&d.options.responsive.length&&null!==d.options.responsive){f=null;for(e in d.breakpoints)d.breakpoints.hasOwnProperty(e)&&(d.originalSettings.mobileFirst===!1?g<d.breakpoints[e]&&(f=d.breakpoints[e]):g>d.breakpoints[e]&&(f=d.breakpoints[e]));null!==f?null!==d.activeBreakpoint?(f!==d.activeBreakpoint||c)&&(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):null!==d.activeBreakpoint&&(d.activeBreakpoint=null,d.options=d.originalSettings,b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b),h=f),b||h===!1||d.$slider.trigger("breakpoint",[d,h])}},b.prototype.changeSlide=function(b,c){var f,g,h,d=this,e=a(b.currentTarget);switch(e.is("a")&&b.preventDefault(),e.is("li")||(e=e.closest("li")),h=d.slideCount%d.options.slidesToScroll!==0,f=h?0:(d.slideCount-d.currentSlide)%d.options.slidesToScroll,b.data.message){case"previous":g=0===f?d.options.slidesToScroll:d.options.slidesToShow-f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide-g,!1,c);break;case"next":g=0===f?d.options.slidesToScroll:f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide+g,!1,c);break;case"index":var i=0===b.data.index?0:b.data.index||e.index()*d.options.slidesToScroll;d.slideHandler(d.checkNavigable(i),!1,c),e.children().trigger("focus");break;default:return}},b.prototype.checkNavigable=function(a){var c,d,b=this;if(c=b.getNavigableIndexes(),d=0,a>c[c.length-1])a=c[c.length-1];else for(var e in c){if(a<c[e]){a=d;break}d=c[e]}return a},b.prototype.cleanUpEvents=function(){var b=this;b.options.dots&&null!==b.$dots&&a("li",b.$dots).off("click.slick",b.changeSlide).off("mouseenter.slick",a.proxy(b.interrupt,b,!0)).off("mouseleave.slick",a.proxy(b.interrupt,b,!1)),b.$slider.off("focus.slick blur.slick"),b.options.arrows===!0&&b.slideCount>b.options.slidesToShow&&(b.$prevArrow&&b.$prevArrow.off("click.slick",b.changeSlide),b.$nextArrow&&b.$nextArrow.off("click.slick",b.changeSlide)),b.$list.off("touchstart.slick mousedown.slick",b.swipeHandler),b.$list.off("touchmove.slick mousemove.slick",b.swipeHandler),b.$list.off("touchend.slick mouseup.slick",b.swipeHandler),b.$list.off("touchcancel.slick mouseleave.slick",b.swipeHandler),b.$list.off("click.slick",b.clickHandler),a(document).off(b.visibilityChange,b.visibility),b.cleanUpSlideEvents(),b.options.accessibility===!0&&b.$list.off("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().off("click.slick",b.selectHandler),a(window).off("orientationchange.slick.slick-"+b.instanceUid,b.orientationChange),a(window).off("resize.slick.slick-"+b.instanceUid,b.resize),a("[draggable!=true]",b.$slideTrack).off("dragstart",b.preventDefault),a(window).off("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).off("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.cleanUpSlideEvents=function(){var b=this;b.$list.off("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.off("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.cleanUpRows=function(){var b,a=this;a.options.rows>1&&(b=a.$slides.children().children(),b.removeAttr("style"),a.$slider.empty().append(b))},b.prototype.clickHandler=function(a){var b=this;b.shouldClick===!1&&(a.stopImmediatePropagation(),a.stopPropagation(),a.preventDefault())},b.prototype.destroy=function(b){var c=this;c.autoPlayClear(),c.touchObject={},c.cleanUpEvents(),a(".slick-cloned",c.$slider).detach(),c.$dots&&c.$dots.remove(),c.$prevArrow&&c.$prevArrow.length&&(c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.prevArrow)&&c.$prevArrow.remove()),c.$nextArrow&&c.$nextArrow.length&&(c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.nextArrow)&&c.$nextArrow.remove()),c.$slides&&(c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){a(this).attr("style",a(this).data("originalStyling"))}),c.$slideTrack.children(this.options.slide).detach(),c.$slideTrack.detach(),c.$list.detach(),c.$slider.append(c.$slides)),c.cleanUpRows(),c.$slider.removeClass("slick-slider"),c.$slider.removeClass("slick-initialized"),c.$slider.removeClass("slick-dotted"),c.unslicked=!0,b||c.$slider.trigger("destroy",[c])},b.prototype.disableTransition=function(a){var b=this,c={};c[b.transitionType]="",b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.fadeSlide=function(a,b){var c=this;c.cssTransitions===!1?(c.$slides.eq(a).css({zIndex:c.options.zIndex}),c.$slides.eq(a).animate({opacity:1},c.options.speed,c.options.easing,b)):(c.applyTransition(a),c.$slides.eq(a).css({opacity:1,zIndex:c.options.zIndex}),b&&setTimeout(function(){c.disableTransition(a),b.call()},c.options.speed))},b.prototype.fadeSlideOut=function(a){var b=this;b.cssTransitions===!1?b.$slides.eq(a).animate({opacity:0,zIndex:b.options.zIndex-2},b.options.speed,b.options.easing):(b.applyTransition(a),b.$slides.eq(a).css({opacity:0,zIndex:b.options.zIndex-2}))},b.prototype.filterSlides=b.prototype.slickFilter=function(a){var b=this;null!==a&&(b.$slidesCache=b.$slides,b.unload(),b.$slideTrack.children(this.options.slide).detach(),b.$slidesCache.filter(a).appendTo(b.$slideTrack),b.reinit())},b.prototype.focusHandler=function(){var b=this;b.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*:not(.slick-arrow)",function(c){c.stopImmediatePropagation();var d=a(this);setTimeout(function(){b.options.pauseOnFocus&&(b.focussed=d.is(":focus"),b.autoPlay())},0)})},b.prototype.getCurrent=b.prototype.slickCurrentSlide=function(){var a=this;return a.currentSlide},b.prototype.getDotCount=function(){var a=this,b=0,c=0,d=0;if(a.options.infinite===!0)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else if(a.options.centerMode===!0)d=a.slideCount;else if(a.options.asNavFor)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else d=1+Math.ceil((a.slideCount-a.options.slidesToShow)/a.options.slidesToScroll);return d-1},b.prototype.getLeft=function(a){var c,d,f,b=this,e=0;return b.slideOffset=0,d=b.$slides.first().outerHeight(!0),b.options.infinite===!0?(b.slideCount>b.options.slidesToShow&&(b.slideOffset=b.slideWidth*b.options.slidesToShow*-1,e=d*b.options.slidesToShow*-1),b.slideCount%b.options.slidesToScroll!==0&&a+b.options.slidesToScroll>b.slideCount&&b.slideCount>b.options.slidesToShow&&(a>b.slideCount?(b.slideOffset=(b.options.slidesToShow-(a-b.slideCount))*b.slideWidth*-1,e=(b.options.slidesToShow-(a-b.slideCount))*d*-1):(b.slideOffset=b.slideCount%b.options.slidesToScroll*b.slideWidth*-1,e=b.slideCount%b.options.slidesToScroll*d*-1))):a+b.options.slidesToShow>b.slideCount&&(b.slideOffset=(a+b.options.slidesToShow-b.slideCount)*b.slideWidth,e=(a+b.options.slidesToShow-b.slideCount)*d),b.slideCount<=b.options.slidesToShow&&(b.slideOffset=0,e=0),b.options.centerMode===!0&&b.options.infinite===!0?b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)-b.slideWidth:b.options.centerMode===!0&&(b.slideOffset=0,b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)),c=b.options.vertical===!1?a*b.slideWidth*-1+b.slideOffset:a*d*-1+e,b.options.variableWidth===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,b.options.centerMode===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow+1),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,c+=(b.$list.width()-f.outerWidth())/2)),c},b.prototype.getOption=b.prototype.slickGetOption=function(a){var b=this;return b.options[a]},b.prototype.getNavigableIndexes=function(){var e,a=this,b=0,c=0,d=[];for(a.options.infinite===!1?e=a.slideCount:(b=-1*a.options.slidesToScroll,c=-1*a.options.slidesToScroll,e=2*a.slideCount);e>b;)d.push(b),b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;return d},b.prototype.getSlick=function(){return this},b.prototype.getSlideCount=function(){var c,d,e,b=this;return e=b.options.centerMode===!0?b.slideWidth*Math.floor(b.options.slidesToShow/2):0,b.options.swipeToSlide===!0?(b.$slideTrack.find(".slick-slide").each(function(c,f){return f.offsetLeft-e+a(f).outerWidth()/2>-1*b.swipeLeft?(d=f,!1):void 0}),c=Math.abs(a(d).attr("data-slick-index")-b.currentSlide)||1):b.options.slidesToScroll},b.prototype.goTo=b.prototype.slickGoTo=function(a,b){var c=this;c.changeSlide({data:{message:"index",index:parseInt(a)}},b)},b.prototype.init=function(b){var c=this;a(c.$slider).hasClass("slick-initialized")||(a(c.$slider).addClass("slick-initialized"),c.buildRows(),c.buildOut(),c.setProps(),c.startLoad(),c.loadSlider(),c.initializeEvents(),c.updateArrows(),c.updateDots(),c.checkResponsive(!0),c.focusHandler()),b&&c.$slider.trigger("init",[c]),c.options.accessibility===!0&&c.initADA(),c.options.autoplay&&(c.paused=!1,c.autoPlay())},b.prototype.initADA=function(){var b=this;b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),b.$slideTrack.attr("role","listbox"),b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function(c){a(this).attr({role:"option","aria-describedby":"slick-slide"+b.instanceUid+c})}),null!==b.$dots&&b.$dots.attr("role","tablist").find("li").each(function(c){a(this).attr({role:"presentation","aria-selected":"false","aria-controls":"navigation"+b.instanceUid+c,id:"slick-slide"+b.instanceUid+c})}).first().attr("aria-selected","true").end().find("button").attr("role","button").end().closest("div").attr("role","toolbar"),b.activateADA()},b.prototype.initArrowEvents=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},a.changeSlide),a.$nextArrow.off("click.slick").on("click.slick",{message:"next"},a.changeSlide))},b.prototype.initDotEvents=function(){var b=this;b.options.dots===!0&&b.slideCount>b.options.slidesToShow&&a("li",b.$dots).on("click.slick",{message:"index"},b.changeSlide),b.options.dots===!0&&b.options.pauseOnDotsHover===!0&&a("li",b.$dots).on("mouseenter.slick",a.proxy(b.interrupt,b,!0)).on("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.initSlideEvents=function(){var b=this;b.options.pauseOnHover&&(b.$list.on("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.on("mouseleave.slick",a.proxy(b.interrupt,b,!1)))},b.prototype.initializeEvents=function(){var b=this;b.initArrowEvents(),b.initDotEvents(),b.initSlideEvents(),b.$list.on("touchstart.slick mousedown.slick",{action:"start"},b.swipeHandler),b.$list.on("touchmove.slick mousemove.slick",{action:"move"},b.swipeHandler),b.$list.on("touchend.slick mouseup.slick",{action:"end"},b.swipeHandler),b.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},b.swipeHandler),b.$list.on("click.slick",b.clickHandler),a(document).on(b.visibilityChange,a.proxy(b.visibility,b)),b.options.accessibility===!0&&b.$list.on("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),a(window).on("orientationchange.slick.slick-"+b.instanceUid,a.proxy(b.orientationChange,b)),a(window).on("resize.slick.slick-"+b.instanceUid,a.proxy(b.resize,b)),a("[draggable!=true]",b.$slideTrack).on("dragstart",b.preventDefault),a(window).on("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).on("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.initUI=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.show(),a.$nextArrow.show()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.show()},b.prototype.keyHandler=function(a){var b=this;a.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===a.keyCode&&b.options.accessibility===!0?b.changeSlide({data:{message:b.options.rtl===!0?"next":"previous"}}):39===a.keyCode&&b.options.accessibility===!0&&b.changeSlide({data:{message:b.options.rtl===!0?"previous":"next"}}))},b.prototype.lazyLoad=function(){function g(c){a("img[data-lazy]",c).each(function(){var c=a(this),d=a(this).attr("data-lazy"),e=document.createElement("img");e.onload=function(){c.animate({opacity:0},100,function(){c.attr("src",d).animate({opacity:1},200,function(){c.removeAttr("data-lazy").removeClass("slick-loading")}),b.$slider.trigger("lazyLoaded",[b,c,d])})},e.onerror=function(){c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),b.$slider.trigger("lazyLoadError",[b,c,d])},e.src=d})}var c,d,e,f,b=this;b.options.centerMode===!0?b.options.infinite===!0?(e=b.currentSlide+(b.options.slidesToShow/2+1),f=e+b.options.slidesToShow+2):(e=Math.max(0,b.currentSlide-(b.options.slidesToShow/2+1)),f=2+(b.options.slidesToShow/2+1)+b.currentSlide):(e=b.options.infinite?b.options.slidesToShow+b.currentSlide:b.currentSlide,f=Math.ceil(e+b.options.slidesToShow),b.options.fade===!0&&(e>0&&e--,f<=b.slideCount&&f++)),c=b.$slider.find(".slick-slide").slice(e,f),g(c),b.slideCount<=b.options.slidesToShow?(d=b.$slider.find(".slick-slide"),g(d)):b.currentSlide>=b.slideCount-b.options.slidesToShow?(d=b.$slider.find(".slick-cloned").slice(0,b.options.slidesToShow),g(d)):0===b.currentSlide&&(d=b.$slider.find(".slick-cloned").slice(-1*b.options.slidesToShow),g(d))},b.prototype.loadSlider=function(){var a=this;a.setPosition(),a.$slideTrack.css({opacity:1}),a.$slider.removeClass("slick-loading"),a.initUI(),"progressive"===a.options.lazyLoad&&a.progressiveLazyLoad()},b.prototype.next=b.prototype.slickNext=function(){var a=this;a.changeSlide({data:{message:"next"}})},b.prototype.orientationChange=function(){var a=this;a.checkResponsive(),a.setPosition()},b.prototype.pause=b.prototype.slickPause=function(){var a=this;a.autoPlayClear(),a.paused=!0},b.prototype.play=b.prototype.slickPlay=function(){var a=this;a.autoPlay(),a.options.autoplay=!0,a.paused=!1,a.focussed=!1,a.interrupted=!1},b.prototype.postSlide=function(a){var b=this;b.unslicked||(b.$slider.trigger("afterChange",[b,a]),b.animating=!1,b.setPosition(),b.swipeLeft=null,b.options.autoplay&&b.autoPlay(),b.options.accessibility===!0&&b.initADA())},b.prototype.prev=b.prototype.slickPrev=function(){var a=this;a.changeSlide({data:{message:"previous"}})},b.prototype.preventDefault=function(a){a.preventDefault()},b.prototype.progressiveLazyLoad=function(b){b=b||1;var e,f,g,c=this,d=a("img[data-lazy]",c.$slider);d.length?(e=d.first(),f=e.attr("data-lazy"),g=document.createElement("img"),g.onload=function(){e.attr("src",f).removeAttr("data-lazy").removeClass("slick-loading"),c.options.adaptiveHeight===!0&&c.setPosition(),c.$slider.trigger("lazyLoaded",[c,e,f]),c.progressiveLazyLoad()},g.onerror=function(){3>b?setTimeout(function(){c.progressiveLazyLoad(b+1)},500):(e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),c.$slider.trigger("lazyLoadError",[c,e,f]),c.progressiveLazyLoad())},g.src=f):c.$slider.trigger("allImagesLoaded",[c])},b.prototype.refresh=function(b){var d,e,c=this;e=c.slideCount-c.options.slidesToShow,!c.options.infinite&&c.currentSlide>e&&(c.currentSlide=e),c.slideCount<=c.options.slidesToShow&&(c.currentSlide=0),d=c.currentSlide,c.destroy(!0),a.extend(c,c.initials,{currentSlide:d}),c.init(),b||c.changeSlide({data:{message:"index",index:d}},!1)},b.prototype.registerBreakpoints=function(){var c,d,e,b=this,f=b.options.responsive||null;if("array"===a.type(f)&&f.length){b.respondTo=b.options.respondTo||"window";for(c in f)if(e=b.breakpoints.length-1,d=f[c].breakpoint,f.hasOwnProperty(c)){for(;e>=0;)b.breakpoints[e]&&b.breakpoints[e]===d&&b.breakpoints.splice(e,1),e--;b.breakpoints.push(d),b.breakpointSettings[d]=f[c].settings}b.breakpoints.sort(function(a,c){return b.options.mobileFirst?a-c:c-a})}},b.prototype.reinit=function(){var b=this;b.$slides=b.$slideTrack.children(b.options.slide).addClass("slick-slide"),b.slideCount=b.$slides.length,b.currentSlide>=b.slideCount&&0!==b.currentSlide&&(b.currentSlide=b.currentSlide-b.options.slidesToScroll),b.slideCount<=b.options.slidesToShow&&(b.currentSlide=0),b.registerBreakpoints(),b.setProps(),b.setupInfinite(),b.buildArrows(),b.updateArrows(),b.initArrowEvents(),b.buildDots(),b.updateDots(),b.initDotEvents(),b.cleanUpSlideEvents(),b.initSlideEvents(),b.checkResponsive(!1,!0),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.setPosition(),b.focusHandler(),b.paused=!b.options.autoplay,b.autoPlay(),b.$slider.trigger("reInit",[b])},b.prototype.resize=function(){var b=this;a(window).width()!==b.windowWidth&&(clearTimeout(b.windowDelay),b.windowDelay=window.setTimeout(function(){b.windowWidth=a(window).width(),b.checkResponsive(),b.unslicked||b.setPosition()},50))},b.prototype.removeSlide=b.prototype.slickRemove=function(a,b,c){var d=this;return"boolean"==typeof a?(b=a,a=b===!0?0:d.slideCount-1):a=b===!0?--a:a,d.slideCount<1||0>a||a>d.slideCount-1?!1:(d.unload(),c===!0?d.$slideTrack.children().remove():d.$slideTrack.children(this.options.slide).eq(a).remove(),d.$slides=d.$slideTrack.children(this.options.slide),d.$slideTrack.children(this.options.slide).detach(),d.$slideTrack.append(d.$slides),d.$slidesCache=d.$slides,void d.reinit())},b.prototype.setCSS=function(a){var d,e,b=this,c={};b.options.rtl===!0&&(a=-a),d="left"==b.positionProp?Math.ceil(a)+"px":"0px",e="top"==b.positionProp?Math.ceil(a)+"px":"0px",c[b.positionProp]=a,b.transformsEnabled===!1?b.$slideTrack.css(c):(c={},b.cssTransitions===!1?(c[b.animType]="translate("+d+", "+e+")",b.$slideTrack.css(c)):(c[b.animType]="translate3d("+d+", "+e+", 0px)",b.$slideTrack.css(c)))},b.prototype.setDimensions=function(){var a=this;a.options.vertical===!1?a.options.centerMode===!0&&a.$list.css({padding:"0px "+a.options.centerPadding}):(a.$list.height(a.$slides.first().outerHeight(!0)*a.options.slidesToShow),a.options.centerMode===!0&&a.$list.css({padding:a.options.centerPadding+" 0px"})),a.listWidth=a.$list.width(),a.listHeight=a.$list.height(),a.options.vertical===!1&&a.options.variableWidth===!1?(a.slideWidth=Math.ceil(a.listWidth/a.options.slidesToShow),a.$slideTrack.width(Math.ceil(a.slideWidth*a.$slideTrack.children(".slick-slide").length))):a.options.variableWidth===!0?a.$slideTrack.width(5e3*a.slideCount):(a.slideWidth=Math.ceil(a.listWidth),a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0)*a.$slideTrack.children(".slick-slide").length)));var b=a.$slides.first().outerWidth(!0)-a.$slides.first().width();a.options.variableWidth===!1&&a.$slideTrack.children(".slick-slide").width(a.slideWidth-b)},b.prototype.setFade=function(){var c,b=this;b.$slides.each(function(d,e){c=b.slideWidth*d*-1,b.options.rtl===!0?a(e).css({position:"relative",right:c,top:0,zIndex:b.options.zIndex-2,opacity:0}):a(e).css({position:"relative",left:c,top:0,zIndex:b.options.zIndex-2,opacity:0})}),b.$slides.eq(b.currentSlide).css({zIndex:b.options.zIndex-1,opacity:1})},b.prototype.setHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.css("height",b)}},b.prototype.setOption=b.prototype.slickSetOption=function(){var c,d,e,f,h,b=this,g=!1;if("object"===a.type(arguments[0])?(e=arguments[0],g=arguments[1],h="multiple"):"string"===a.type(arguments[0])&&(e=arguments[0],f=arguments[1],g=arguments[2],"responsive"===arguments[0]&&"array"===a.type(arguments[1])?h="responsive":"undefined"!=typeof arguments[1]&&(h="single")),"single"===h)b.options[e]=f;else if("multiple"===h)a.each(e,function(a,c){b.options[a]=c});else if("responsive"===h)for(d in f)if("array"!==a.type(b.options.responsive))b.options.responsive=[f[d]];else{for(c=b.options.responsive.length-1;c>=0;)b.options.responsive[c].breakpoint===f[d].breakpoint&&b.options.responsive.splice(c,1),c--;b.options.responsive.push(f[d])}g&&(b.unload(),b.reinit())},b.prototype.setPosition=function(){var a=this;a.setDimensions(),a.setHeight(),a.options.fade===!1?a.setCSS(a.getLeft(a.currentSlide)):a.setFade(),a.$slider.trigger("setPosition",[a])},b.prototype.setProps=function(){var a=this,b=document.body.style;a.positionProp=a.options.vertical===!0?"top":"left","top"===a.positionProp?a.$slider.addClass("slick-vertical"):a.$slider.removeClass("slick-vertical"),(void 0!==b.WebkitTransition||void 0!==b.MozTransition||void 0!==b.msTransition)&&a.options.useCSS===!0&&(a.cssTransitions=!0),a.options.fade&&("number"==typeof a.options.zIndex?a.options.zIndex<3&&(a.options.zIndex=3):a.options.zIndex=a.defaults.zIndex),void 0!==b.OTransform&&(a.animType="OTransform",a.transformType="-o-transform",a.transitionType="OTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.MozTransform&&(a.animType="MozTransform",a.transformType="-moz-transform",a.transitionType="MozTransition",void 0===b.perspectiveProperty&&void 0===b.MozPerspective&&(a.animType=!1)),void 0!==b.webkitTransform&&(a.animType="webkitTransform",a.transformType="-webkit-transform",a.transitionType="webkitTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.msTransform&&(a.animType="msTransform",a.transformType="-ms-transform",a.transitionType="msTransition",void 0===b.msTransform&&(a.animType=!1)),void 0!==b.transform&&a.animType!==!1&&(a.animType="transform",a.transformType="transform",a.transitionType="transition"),a.transformsEnabled=a.options.useTransform&&null!==a.animType&&a.animType!==!1},b.prototype.setSlideClasses=function(a){var c,d,e,f,b=this;d=b.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),b.$slides.eq(a).addClass("slick-current"),b.options.centerMode===!0?(c=Math.floor(b.options.slidesToShow/2),b.options.infinite===!0&&(a>=c&&a<=b.slideCount-1-c?b.$slides.slice(a-c,a+c+1).addClass("slick-active").attr("aria-hidden","false"):(e=b.options.slidesToShow+a,
 	d.slice(e-c+1,e+c+2).addClass("slick-active").attr("aria-hidden","false")),0===a?d.eq(d.length-1-b.options.slidesToShow).addClass("slick-center"):a===b.slideCount-1&&d.eq(b.options.slidesToShow).addClass("slick-center")),b.$slides.eq(a).addClass("slick-center")):a>=0&&a<=b.slideCount-b.options.slidesToShow?b.$slides.slice(a,a+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):d.length<=b.options.slidesToShow?d.addClass("slick-active").attr("aria-hidden","false"):(f=b.slideCount%b.options.slidesToShow,e=b.options.infinite===!0?b.options.slidesToShow+a:a,b.options.slidesToShow==b.options.slidesToScroll&&b.slideCount-a<b.options.slidesToShow?d.slice(e-(b.options.slidesToShow-f),e+f).addClass("slick-active").attr("aria-hidden","false"):d.slice(e,e+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")),"ondemand"===b.options.lazyLoad&&b.lazyLoad()},b.prototype.setupInfinite=function(){var c,d,e,b=this;if(b.options.fade===!0&&(b.options.centerMode=!1),b.options.infinite===!0&&b.options.fade===!1&&(d=null,b.slideCount>b.options.slidesToShow)){for(e=b.options.centerMode===!0?b.options.slidesToShow+1:b.options.slidesToShow,c=b.slideCount;c>b.slideCount-e;c-=1)d=c-1,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d-b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned");for(c=0;e>c;c+=1)d=c,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d+b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned");b.$slideTrack.find(".slick-cloned").find("[id]").each(function(){a(this).attr("id","")})}},b.prototype.interrupt=function(a){var b=this;a||b.autoPlay(),b.interrupted=a},b.prototype.selectHandler=function(b){var c=this,d=a(b.target).is(".slick-slide")?a(b.target):a(b.target).parents(".slick-slide"),e=parseInt(d.attr("data-slick-index"));return e||(e=0),c.slideCount<=c.options.slidesToShow?(c.setSlideClasses(e),void c.asNavFor(e)):void c.slideHandler(e)},b.prototype.slideHandler=function(a,b,c){var d,e,f,g,j,h=null,i=this;return b=b||!1,i.animating===!0&&i.options.waitForAnimate===!0||i.options.fade===!0&&i.currentSlide===a||i.slideCount<=i.options.slidesToShow?void 0:(b===!1&&i.asNavFor(a),d=a,h=i.getLeft(d),g=i.getLeft(i.currentSlide),i.currentLeft=null===i.swipeLeft?g:i.swipeLeft,i.options.infinite===!1&&i.options.centerMode===!1&&(0>a||a>i.getDotCount()*i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):i.options.infinite===!1&&i.options.centerMode===!0&&(0>a||a>i.slideCount-i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):(i.options.autoplay&&clearInterval(i.autoPlayTimer),e=0>d?i.slideCount%i.options.slidesToScroll!==0?i.slideCount-i.slideCount%i.options.slidesToScroll:i.slideCount+d:d>=i.slideCount?i.slideCount%i.options.slidesToScroll!==0?0:d-i.slideCount:d,i.animating=!0,i.$slider.trigger("beforeChange",[i,i.currentSlide,e]),f=i.currentSlide,i.currentSlide=e,i.setSlideClasses(i.currentSlide),i.options.asNavFor&&(j=i.getNavTarget(),j=j.slick("getSlick"),j.slideCount<=j.options.slidesToShow&&j.setSlideClasses(i.currentSlide)),i.updateDots(),i.updateArrows(),i.options.fade===!0?(c!==!0?(i.fadeSlideOut(f),i.fadeSlide(e,function(){i.postSlide(e)})):i.postSlide(e),void i.animateHeight()):void(c!==!0?i.animateSlide(h,function(){i.postSlide(e)}):i.postSlide(e))))},b.prototype.startLoad=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.hide(),a.$nextArrow.hide()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.hide(),a.$slider.addClass("slick-loading")},b.prototype.swipeDirection=function(){var a,b,c,d,e=this;return a=e.touchObject.startX-e.touchObject.curX,b=e.touchObject.startY-e.touchObject.curY,c=Math.atan2(b,a),d=Math.round(180*c/Math.PI),0>d&&(d=360-Math.abs(d)),45>=d&&d>=0?e.options.rtl===!1?"left":"right":360>=d&&d>=315?e.options.rtl===!1?"left":"right":d>=135&&225>=d?e.options.rtl===!1?"right":"left":e.options.verticalSwiping===!0?d>=35&&135>=d?"down":"up":"vertical"},b.prototype.swipeEnd=function(a){var c,d,b=this;if(b.dragging=!1,b.interrupted=!1,b.shouldClick=b.touchObject.swipeLength>10?!1:!0,void 0===b.touchObject.curX)return!1;if(b.touchObject.edgeHit===!0&&b.$slider.trigger("edge",[b,b.swipeDirection()]),b.touchObject.swipeLength>=b.touchObject.minSwipe){switch(d=b.swipeDirection()){case"left":case"down":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide+b.getSlideCount()):b.currentSlide+b.getSlideCount(),b.currentDirection=0;break;case"right":case"up":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide-b.getSlideCount()):b.currentSlide-b.getSlideCount(),b.currentDirection=1}"vertical"!=d&&(b.slideHandler(c),b.touchObject={},b.$slider.trigger("swipe",[b,d]))}else b.touchObject.startX!==b.touchObject.curX&&(b.slideHandler(b.currentSlide),b.touchObject={})},b.prototype.swipeHandler=function(a){var b=this;if(!(b.options.swipe===!1||"ontouchend"in document&&b.options.swipe===!1||b.options.draggable===!1&&-1!==a.type.indexOf("mouse")))switch(b.touchObject.fingerCount=a.originalEvent&&void 0!==a.originalEvent.touches?a.originalEvent.touches.length:1,b.touchObject.minSwipe=b.listWidth/b.options.touchThreshold,b.options.verticalSwiping===!0&&(b.touchObject.minSwipe=b.listHeight/b.options.touchThreshold),a.data.action){case"start":b.swipeStart(a);break;case"move":b.swipeMove(a);break;case"end":b.swipeEnd(a)}},b.prototype.swipeMove=function(a){var d,e,f,g,h,b=this;return h=void 0!==a.originalEvent?a.originalEvent.touches:null,!b.dragging||h&&1!==h.length?!1:(d=b.getLeft(b.currentSlide),b.touchObject.curX=void 0!==h?h[0].pageX:a.clientX,b.touchObject.curY=void 0!==h?h[0].pageY:a.clientY,b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curX-b.touchObject.startX,2))),b.options.verticalSwiping===!0&&(b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curY-b.touchObject.startY,2)))),e=b.swipeDirection(),"vertical"!==e?(void 0!==a.originalEvent&&b.touchObject.swipeLength>4&&a.preventDefault(),g=(b.options.rtl===!1?1:-1)*(b.touchObject.curX>b.touchObject.startX?1:-1),b.options.verticalSwiping===!0&&(g=b.touchObject.curY>b.touchObject.startY?1:-1),f=b.touchObject.swipeLength,b.touchObject.edgeHit=!1,b.options.infinite===!1&&(0===b.currentSlide&&"right"===e||b.currentSlide>=b.getDotCount()&&"left"===e)&&(f=b.touchObject.swipeLength*b.options.edgeFriction,b.touchObject.edgeHit=!0),b.options.vertical===!1?b.swipeLeft=d+f*g:b.swipeLeft=d+f*(b.$list.height()/b.listWidth)*g,b.options.verticalSwiping===!0&&(b.swipeLeft=d+f*g),b.options.fade===!0||b.options.touchMove===!1?!1:b.animating===!0?(b.swipeLeft=null,!1):void b.setCSS(b.swipeLeft)):void 0)},b.prototype.swipeStart=function(a){var c,b=this;return b.interrupted=!0,1!==b.touchObject.fingerCount||b.slideCount<=b.options.slidesToShow?(b.touchObject={},!1):(void 0!==a.originalEvent&&void 0!==a.originalEvent.touches&&(c=a.originalEvent.touches[0]),b.touchObject.startX=b.touchObject.curX=void 0!==c?c.pageX:a.clientX,b.touchObject.startY=b.touchObject.curY=void 0!==c?c.pageY:a.clientY,void(b.dragging=!0))},b.prototype.unfilterSlides=b.prototype.slickUnfilter=function(){var a=this;null!==a.$slidesCache&&(a.unload(),a.$slideTrack.children(this.options.slide).detach(),a.$slidesCache.appendTo(a.$slideTrack),a.reinit())},b.prototype.unload=function(){var b=this;a(".slick-cloned",b.$slider).remove(),b.$dots&&b.$dots.remove(),b.$prevArrow&&b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.remove(),b.$nextArrow&&b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.remove(),b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},b.prototype.unslick=function(a){var b=this;b.$slider.trigger("unslick",[b,a]),b.destroy()},b.prototype.updateArrows=function(){var b,a=this;b=Math.floor(a.options.slidesToShow/2),a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&!a.options.infinite&&(a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===a.currentSlide?(a.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-a.options.slidesToShow&&a.options.centerMode===!1?(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-1&&a.options.centerMode===!0&&(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},b.prototype.updateDots=function(){var a=this;null!==a.$dots&&(a.$dots.find("li").removeClass("slick-active").attr("aria-hidden","true"),a.$dots.find("li").eq(Math.floor(a.currentSlide/a.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden","false"))},b.prototype.visibility=function(){var a=this;a.options.autoplay&&(document[a.hidden]?a.interrupted=!0:a.interrupted=!1)},a.fn.slick=function(){var f,g,a=this,c=arguments[0],d=Array.prototype.slice.call(arguments,1),e=a.length;for(f=0;e>f;f++)if("object"==typeof c||"undefined"==typeof c?a[f].slick=new b(a[f],c):g=a[f].slick[c].apply(a[f].slick,d),"undefined"!=typeof g)return g;return a}});

/*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
;(function(r,G,f,v){var J=f("html"),n=f(r),p=f(G),b=f.fancybox=function(){b.open.apply(this,arguments)},I=navigator.userAgent.match(/msie/i),B=null,s=G.createTouch!==v,t=function(a){return a&&a.hasOwnProperty&&a instanceof f},q=function(a){return a&&"string"===f.type(a)},E=function(a){return q(a)&&0<a.indexOf("%")},l=function(a,d){var e=parseInt(a,10)||0;d&&E(a)&&(e*=b.getViewport()[d]/100);return Math.ceil(e)},w=function(a,b){return l(a,b)+"px"};f.extend(b,{version:"2.1.5",defaults:{padding:15,margin:20,width:800,height:600,minWidth:100,minHeight:100,maxWidth:9999,maxHeight:9999,pixelRatio:1,autoSize:!0,autoHeight:!1,autoWidth:!1,autoResize:!0,autoCenter:!s,fitToView:!0,aspectRatio:!1,topRatio:0.5,leftRatio:0.5,scrolling:"auto",wrapCSS:"",arrows:!0,closeBtn:!0,closeClick:!1,nextClick:!1,mouseWheel:!0,autoPlay:!1,playSpeed:3E3,preload:3,modal:!1,loop:!0,ajax:{dataType:"html",headers:{"X-fancyBox":!0}},iframe:{scrolling:"auto",preload:!0},swf:{wmode:"transparent",allowfullscreen:"true",allowscriptaccess:"always"},keys:{next:{13:"left",34:"up",39:"left",40:"up"},prev:{8:"right",33:"down",37:"right",38:"down"},close:[27],play:[32],toggle:[70]},direction:{next:"left",prev:"right"},scrollOutside:!0,index:0,type:null,href:null,content:null,title:null,tpl:{wrap:'<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',image:'<img class="fancybox-image" src="{href}" alt="" />',iframe:'<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen'+(I?' allowtransparency="true"':"")+"></iframe>",error:'<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',closeBtn:'<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',next:'<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',prev:'<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'},openEffect:"fade",openSpeed:250,openEasing:"swing",openOpacity:!0,openMethod:"zoomIn",closeEffect:"fade",closeSpeed:250,closeEasing:"swing",closeOpacity:!0,closeMethod:"zoomOut",nextEffect:"none",nextSpeed:1,nextEasing:"swing",nextMethod:"changeIn",prevEffect:"none",prevSpeed:250,prevEasing:"swing",prevMethod:"changeOut",helpers:{overlay:!0,title:!0},onCancel:f.noop,beforeLoad:f.noop,afterLoad:f.noop,beforeShow:f.noop,afterShow:f.noop,beforeChange:f.noop,beforeClose:f.noop,afterClose:f.noop},group:{},opts:{},previous:null,coming:null,current:null,isActive:!1,isOpen:!1,isOpened:!1,wrap:null,skin:null,outer:null,inner:null,player:{timer:null,isActive:!1},ajaxLoad:null,imgPreload:null,transitions:{},helpers:{},open:function(a,d){if(a&&(f.isPlainObject(d)||(d={}),!1!==b.close(!0)))return f.isArray(a)||(a=t(a)?f(a).get():[a]),f.each(a,function(e,c){var k={},g,h,j,m,l;"object"===f.type(c)&&(c.nodeType&&(c=f(c)),t(c)?(k={href:c.data("fancybox-href")||c.attr("href"),title:c.data("fancybox-title")||c.attr("title"),isDom:!0,element:c},f.metadata&&f.extend(!0,k,c.metadata())):k=c);g=d.href||k.href||(q(c)?c:null);h=d.title!==v?d.title:k.title||"";m=(j=d.content||k.content)?"html":d.type||k.type;!m&&k.isDom&&(m=c.data("fancybox-type"),m||(m=(m=c.prop("class").match(/fancybox\.(\w+)/))?m[1]:null));q(g)&&(m||(b.isImage(g)?m="image":b.isSWF(g)?m="swf":"#"===g.charAt(0)?m="inline":q(c)&&(m="html",j=c)),"ajax"===m&&(l=g.split(/\s+/,2),g=l.shift(),l=l.shift()));j||("inline"===m?g?j=f(q(g)?g.replace(/.*(?=#[^\s]+$)/,""):g):k.isDom&&(j=c):"html"===m?j=g:!m&&(!g&&k.isDom)&&(m="inline",j=c));f.extend(k,{href:g,type:m,content:j,title:h,selector:l});a[e]=k}),b.opts=f.extend(!0,{},b.defaults,d),d.keys!==v&&(b.opts.keys=d.keys?f.extend({},b.defaults.keys,d.keys):!1),b.group=a,b._start(b.opts.index)},cancel:function(){var a=b.coming;a&&!1!==b.trigger("onCancel")&&(b.hideLoading(),b.ajaxLoad&&b.ajaxLoad.abort(),b.ajaxLoad=null,b.imgPreload&&(b.imgPreload.onload=b.imgPreload.onerror=null),a.wrap&&a.wrap.stop(!0,!0).trigger("onReset").remove(),b.coming=null,b.current||b._afterZoomOut(a))},close:function(a){b.cancel();!1!==b.trigger("beforeClose")&&(b.unbindEvents(),b.isActive&&(!b.isOpen||!0===a?(f(".fancybox-wrap").stop(!0).trigger("onReset").remove(),b._afterZoomOut()):(b.isOpen=b.isOpened=!1,b.isClosing=!0,f(".fancybox-item, .fancybox-nav").remove(),b.wrap.stop(!0,!0).removeClass("fancybox-opened"),b.transitions[b.current.closeMethod]())))},play:function(a){var d=function(){clearTimeout(b.player.timer)},e=function(){d();b.current&&b.player.isActive&&(b.player.timer=setTimeout(b.next,b.current.playSpeed))},c=function(){d();p.unbind(".player");b.player.isActive=!1;b.trigger("onPlayEnd")};if(!0===a||!b.player.isActive&&!1!==a){if(b.current&&(b.current.loop||b.current.index<b.group.length-1))b.player.isActive=!0,p.bind({"onCancel.player beforeClose.player":c,"onUpdate.player":e,"beforeLoad.player":d}),e(),b.trigger("onPlayStart")}else c()},next:function(a){var d=b.current;d&&(q(a)||(a=d.direction.next),b.jumpto(d.index+1,a,"next"))},prev:function(a){var d=b.current;d&&(q(a)||(a=d.direction.prev),b.jumpto(d.index-1,a,"prev"))},jumpto:function(a,d,e){var c=b.current;c&&(a=l(a),b.direction=d||c.direction[a>=c.index?"next":"prev"],b.router=e||"jumpto",c.loop&&(0>a&&(a=c.group.length+a%c.group.length),a%=c.group.length),c.group[a]!==v&&(b.cancel(),b._start(a)))},reposition:function(a,d){var e=b.current,c=e?e.wrap:null,k;c&&(k=b._getPosition(d),a&&"scroll"===a.type?(delete k.position,c.stop(!0,!0).animate(k,200)):(c.css(k),e.pos=f.extend({},e.dim,k)))},update:function(a){var d=a&&a.type,e=!d||"orientationchange"===d;e&&(clearTimeout(B),B=null);b.isOpen&&!B&&(B=setTimeout(function(){var c=b.current;c&&!b.isClosing&&(b.wrap.removeClass("fancybox-tmp"),(e||"load"===d||"resize"===d&&c.autoResize)&&b._setDimension(),"scroll"===d&&c.canShrink||b.reposition(a),b.trigger("onUpdate"),B=null)},e&&!s?0:300))},toggle:function(a){b.isOpen&&(b.current.fitToView="boolean"===f.type(a)?a:!b.current.fitToView,s&&(b.wrap.removeAttr("style").addClass("fancybox-tmp"),b.trigger("onUpdate")),b.update())},hideLoading:function(){p.unbind(".loading");f("#fancybox-loading").remove()},showLoading:function(){var a,d;b.hideLoading();a=f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo("body");p.bind("keydown.loading",function(a){if(27===(a.which||a.keyCode))a.preventDefault(),b.cancel()});b.defaults.fixed||(d=b.getViewport(),a.css({position:"absolute",top:0.5*d.h+d.y,left:0.5*d.w+d.x}))},getViewport:function(){var a=b.current&&b.current.locked||!1,d={x:n.scrollLeft(),y:n.scrollTop()};a?(d.w=a[0].clientWidth,d.h=a[0].clientHeight):(d.w=s&&r.innerWidth?r.innerWidth:n.width(),d.h=s&&r.innerHeight?r.innerHeight:n.height());return d},unbindEvents:function(){b.wrap&&t(b.wrap)&&b.wrap.unbind(".fb");p.unbind(".fb");n.unbind(".fb")},bindEvents:function(){var a=b.current,d;a&&(n.bind("orientationchange.fb"+(s?"":" resize.fb")+(a.autoCenter&&!a.locked?" scroll.fb":""),b.update),(d=a.keys)&&p.bind("keydown.fb",function(e){var c=e.which||e.keyCode,k=e.target||e.srcElement;if(27===c&&b.coming)return!1;!e.ctrlKey&&(!e.altKey&&!e.shiftKey&&!e.metaKey&&(!k||!k.type&&!f(k).is("[contenteditable]")))&&f.each(d,function(d,k){if(1<a.group.length&&k[c]!==v)return b[d](k[c]),e.preventDefault(),!1;if(-1<f.inArray(c,k))return b[d](),e.preventDefault(),!1})}),f.fn.mousewheel&&a.mouseWheel&&b.wrap.bind("mousewheel.fb",function(d,c,k,g){for(var h=f(d.target||null),j=!1;h.length&&!j&&!h.is(".fancybox-skin")&&!h.is(".fancybox-wrap");)j=h[0]&&!(h[0].style.overflow&&"hidden"===h[0].style.overflow)&&(h[0].clientWidth&&h[0].scrollWidth>h[0].clientWidth||h[0].clientHeight&&h[0].scrollHeight>h[0].clientHeight),h=f(h).parent();if(0!==c&&!j&&1<b.group.length&&!a.canShrink){if(0<g||0<k)b.prev(0<g?"down":"left");else if(0>g||0>k)b.next(0>g?"up":"right");d.preventDefault()}}))},trigger:function(a,d){var e,c=d||b.coming||b.current;if(c){f.isFunction(c[a])&&(e=c[a].apply(c,Array.prototype.slice.call(arguments,1)));if(!1===e)return!1;c.helpers&&f.each(c.helpers,function(d,e){if(e&&b.helpers[d]&&f.isFunction(b.helpers[d][a]))b.helpers[d][a](f.extend(!0,{},b.helpers[d].defaults,e),c)});p.trigger(a)}},isImage:function(a){return q(a)&&a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)},isSWF:function(a){return q(a)&&a.match(/\.(swf)((\?|#).*)?$/i)},_start:function(a){var d={},e,c;a=l(a);e=b.group[a]||null;if(!e)return!1;d=f.extend(!0,{},b.opts,e);e=d.margin;c=d.padding;"number"===f.type(e)&&(d.margin=[e,e,e,e]);"number"===f.type(c)&&(d.padding=[c,c,c,c]);d.modal&&f.extend(!0,d,{closeBtn:!1,closeClick:!1,nextClick:!1,arrows:!1,mouseWheel:!1,keys:null,helpers:{overlay:{closeClick:!1}}});d.autoSize&&(d.autoWidth=d.autoHeight=!0);"auto"===d.width&&(d.autoWidth=!0);"auto"===d.height&&(d.autoHeight=!0);d.group=b.group;d.index=a;b.coming=d;if(!1===b.trigger("beforeLoad"))b.coming=null;else{c=d.type;e=d.href;if(!c)return b.coming=null,b.current&&b.router&&"jumpto"!==b.router?(b.current.index=a,b[b.router](b.direction)):!1;b.isActive=!0;if("image"===c||"swf"===c)d.autoHeight=d.autoWidth=!1,d.scrolling="visible";"image"===c&&(d.aspectRatio=!0);"iframe"===c&&s&&(d.scrolling="scroll");d.wrap=f(d.tpl.wrap).addClass("fancybox-"+(s?"mobile":"desktop")+" fancybox-type-"+c+" fancybox-tmp "+d.wrapCSS).appendTo(d.parent||"body");f.extend(d,{skin:f(".fancybox-skin",d.wrap),outer:f(".fancybox-outer",d.wrap),inner:f(".fancybox-inner",d.wrap)});f.each(["Top","Right","Bottom","Left"],function(a,b){d.skin.css("padding"+b,w(d.padding[a]))});b.trigger("onReady");if("inline"===c||"html"===c){if(!d.content||!d.content.length)return b._error("content")}else if(!e)return b._error("href");"image"===c?b._loadImage():"ajax"===c?b._loadAjax():"iframe"===c?b._loadIframe():b._afterLoad()}},_error:function(a){f.extend(b.coming,{type:"html",autoWidth:!0,autoHeight:!0,minWidth:0,minHeight:0,scrolling:"no",hasError:a,content:b.coming.tpl.error});b._afterLoad()},_loadImage:function(){var a=b.imgPreload=new Image;a.onload=function(){this.onload=this.onerror=null;b.coming.width=this.width/b.opts.pixelRatio;b.coming.height=this.height/b.opts.pixelRatio;b._afterLoad()};a.onerror=function(){this.onload=this.onerror=null;b._error("image")};a.src=b.coming.href;!0!==a.complete&&b.showLoading()},_loadAjax:function(){var a=b.coming;b.showLoading();b.ajaxLoad=f.ajax(f.extend({},a.ajax,{url:a.href,error:function(a,e){b.coming&&"abort"!==e?b._error("ajax",a):b.hideLoading()},success:function(d,e){"success"===e&&(a.content=d,b._afterLoad())}}))},_loadIframe:function(){var a=b.coming,d=f(a.tpl.iframe.replace(/\{rnd\}/g,(new Date).getTime())).attr("scrolling",s?"auto":a.iframe.scrolling).attr("src",a.href);f(a.wrap).bind("onReset",function(){try{f(this).find("iframe").hide().attr("src","//about:blank").end().empty()}catch(a){}});a.iframe.preload&&(b.showLoading(),d.one("load",function(){f(this).data("ready",1);s||f(this).bind("load.fb",b.update);f(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show();b._afterLoad()}));a.content=d.appendTo(a.inner);a.iframe.preload||b._afterLoad()},_preloadImages:function(){var a=b.group,d=b.current,e=a.length,c=d.preload?Math.min(d.preload,e-1):0,f,g;for(g=1;g<=c;g+=1)f=a[(d.index+g)%e],"image"===f.type&&f.href&&((new Image).src=f.href)},_afterLoad:function(){var a=b.coming,d=b.current,e,c,k,g,h;b.hideLoading();if(a&&!1!==b.isActive)if(!1===b.trigger("afterLoad",a,d))a.wrap.stop(!0).trigger("onReset").remove(),b.coming=null;else{d&&(b.trigger("beforeChange",d),d.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove());b.unbindEvents();e=a.content;c=a.type;k=a.scrolling;f.extend(b,{wrap:a.wrap,skin:a.skin,outer:a.outer,inner:a.inner,current:a,previous:d});g=a.href;switch(c){case "inline":case "ajax":case "html":a.selector?e=f("<div>").html(e).find(a.selector):t(e)&&(e.data("fancybox-placeholder")||e.data("fancybox-placeholder",f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()),e=e.show().detach(),a.wrap.bind("onReset",function(){f(this).find(e).length&&e.hide().replaceAll(e.data("fancybox-placeholder")).data("fancybox-placeholder",!1)}));break;case "image":e=a.tpl.image.replace("{href}",g);break;case "swf":e='<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="'+g+'"></param>',h="",f.each(a.swf,function(a,b){e+='<param name="'+a+'" value="'+b+'"></param>';h+=" "+a+'="'+b+'"'}),e+='<embed src="'+g+'" type="application/x-shockwave-flash" width="100%" height="100%"'+h+"></embed></object>"}(!t(e)||!e.parent().is(a.inner))&&a.inner.append(e);b.trigger("beforeShow");a.inner.css("overflow","yes"===k?"scroll":"no"===k?"hidden":k);b._setDimension();b.reposition();b.isOpen=!1;b.coming=null;b.bindEvents();if(b.isOpened){if(d.prevMethod)b.transitions[d.prevMethod]()}else f(".fancybox-wrap").not(a.wrap).stop(!0).trigger("onReset").remove();b.transitions[b.isOpened?a.nextMethod:a.openMethod]();b._preloadImages()}},_setDimension:function(){var a=b.getViewport(),d=0,e=!1,c=!1,e=b.wrap,k=b.skin,g=b.inner,h=b.current,c=h.width,j=h.height,m=h.minWidth,u=h.minHeight,n=h.maxWidth,p=h.maxHeight,s=h.scrolling,q=h.scrollOutside?h.scrollbarWidth:0,x=h.margin,y=l(x[1]+x[3]),r=l(x[0]+x[2]),v,z,t,C,A,F,B,D,H;e.add(k).add(g).width("auto").height("auto").removeClass("fancybox-tmp");x=l(k.outerWidth(!0)-k.width());v=l(k.outerHeight(!0)-k.height());z=y+x;t=r+v;C=E(c)?(a.w-z)*l(c)/100:c;A=E(j)?(a.h-t)*l(j)/100:j;if("iframe"===h.type){if(H=h.content,h.autoHeight&&1===H.data("ready"))try{H[0].contentWindow.document.location&&(g.width(C).height(9999),F=H.contents().find("body"),q&&F.css("overflow-x","hidden"),A=F.outerHeight(!0))}catch(G){}}else if(h.autoWidth||h.autoHeight)g.addClass("fancybox-tmp"),h.autoWidth||g.width(C),h.autoHeight||g.height(A),h.autoWidth&&(C=g.width()),h.autoHeight&&(A=g.height()),g.removeClass("fancybox-tmp");c=l(C);j=l(A);D=C/A;m=l(E(m)?l(m,"w")-z:m);n=l(E(n)?l(n,"w")-z:n);u=l(E(u)?l(u,"h")-t:u);p=l(E(p)?l(p,"h")-t:p);F=n;B=p;h.fitToView&&(n=Math.min(a.w-z,n),p=Math.min(a.h-t,p));z=a.w-y;r=a.h-r;h.aspectRatio?(c>n&&(c=n,j=l(c/D)),j>p&&(j=p,c=l(j*D)),c<m&&(c=m,j=l(c/D)),j<u&&(j=u,c=l(j*D))):(c=Math.max(m,Math.min(c,n)),h.autoHeight&&"iframe"!==h.type&&(g.width(c),j=g.height()),j=Math.max(u,Math.min(j,p)));if(h.fitToView)if(g.width(c).height(j),e.width(c+x),a=e.width(),y=e.height(),h.aspectRatio)for(;(a>z||y>r)&&(c>m&&j>u)&&!(19<d++);)j=Math.max(u,Math.min(p,j-10)),c=l(j*D),c<m&&(c=m,j=l(c/D)),c>n&&(c=n,j=l(c/D)),g.width(c).height(j),e.width(c+x),a=e.width(),y=e.height();else c=Math.max(m,Math.min(c,c-(a-z))),j=Math.max(u,Math.min(j,j-(y-r)));q&&("auto"===s&&j<A&&c+x+q<z)&&(c+=q);g.width(c).height(j);e.width(c+x);a=e.width();y=e.height();e=(a>z||y>r)&&c>m&&j>u;c=h.aspectRatio?c<F&&j<B&&c<C&&j<A:(c<F||j<B)&&(c<C||j<A);f.extend(h,{dim:{width:w(a),height:w(y)},origWidth:C,origHeight:A,canShrink:e,canExpand:c,wPadding:x,hPadding:v,wrapSpace:y-k.outerHeight(!0),skinSpace:k.height()-j});!H&&(h.autoHeight&&j>u&&j<p&&!c)&&g.height("auto")},_getPosition:function(a){var d=b.current,e=b.getViewport(),c=d.margin,f=b.wrap.width()+c[1]+c[3],g=b.wrap.height()+c[0]+c[2],c={position:"absolute",top:c[0],left:c[3]};d.autoCenter&&d.fixed&&!a&&g<=e.h&&f<=e.w?c.position="fixed":d.locked||(c.top+=e.y,c.left+=e.x);c.top=w(Math.max(c.top,c.top+(e.h-g)*d.topRatio));c.left=w(Math.max(c.left,c.left+(e.w-f)*d.leftRatio));return c},_afterZoomIn:function(){var a=b.current;a&&(b.isOpen=b.isOpened=!0,b.wrap.css("overflow","visible").addClass("fancybox-opened"),b.update(),(a.closeClick||a.nextClick&&1<b.group.length)&&b.inner.css("cursor","pointer").bind("click.fb",function(d){!f(d.target).is("a")&&!f(d.target).parent().is("a")&&(d.preventDefault(),b[a.closeClick?"close":"next"]())}),a.closeBtn&&f(a.tpl.closeBtn).appendTo(b.skin).bind("click.fb",function(a){a.preventDefault();b.close()}),a.arrows&&1<b.group.length&&((a.loop||0<a.index)&&f(a.tpl.prev).appendTo(b.outer).bind("click.fb",b.prev),(a.loop||a.index<b.group.length-1)&&f(a.tpl.next).appendTo(b.outer).bind("click.fb",b.next)),b.trigger("afterShow"),!a.loop&&a.index===a.group.length-1?b.play(!1):b.opts.autoPlay&&!b.player.isActive&&(b.opts.autoPlay=!1,b.play()))},_afterZoomOut:function(a){a=a||b.current;f(".fancybox-wrap").trigger("onReset").remove();f.extend(b,{group:{},opts:{},router:!1,current:null,isActive:!1,isOpened:!1,isOpen:!1,isClosing:!1,wrap:null,skin:null,outer:null,inner:null});b.trigger("afterClose",a)}});b.transitions={getOrigPosition:function(){var a=b.current,d=a.element,e=a.orig,c={},f=50,g=50,h=a.hPadding,j=a.wPadding,m=b.getViewport();!e&&(a.isDom&&d.is(":visible"))&&(e=d.find("img:first"),e.length||(e=d));t(e)?(c=e.offset(),e.is("img")&&(f=e.outerWidth(),g=e.outerHeight())):(c.top=m.y+(m.h-g)*a.topRatio,c.left=m.x+(m.w-f)*a.leftRatio);if("fixed"===b.wrap.css("position")||a.locked)c.top-=m.y,c.left-=m.x;return c={top:w(c.top-h*a.topRatio),left:w(c.left-j*a.leftRatio),width:w(f+j),height:w(g+h)}},step:function(a,d){var e,c,f=d.prop;c=b.current;var g=c.wrapSpace,h=c.skinSpace;if("width"===f||"height"===f)e=d.end===d.start?1:(a-d.start)/(d.end-d.start),b.isClosing&&(e=1-e),c="width"===f?c.wPadding:c.hPadding,c=a-c,b.skin[f](l("width"===f?c:c-g*e)),b.inner[f](l("width"===f?c:c-g*e-h*e))},zoomIn:function(){var a=b.current,d=a.pos,e=a.openEffect,c="elastic"===e,k=f.extend({opacity:1},d);delete k.position;c?(d=this.getOrigPosition(),a.openOpacity&&(d.opacity=0.1)):"fade"===e&&(d.opacity=0.1);b.wrap.css(d).animate(k,{duration:"none"===e?0:a.openSpeed,easing:a.openEasing,step:c?this.step:null,complete:b._afterZoomIn})},zoomOut:function(){var a=b.current,d=a.closeEffect,e="elastic"===d,c={opacity:0.1};e&&(c=this.getOrigPosition(),a.closeOpacity&&(c.opacity=0.1));b.wrap.animate(c,{duration:"none"===d?0:a.closeSpeed,easing:a.closeEasing,step:e?this.step:null,complete:b._afterZoomOut})},changeIn:function(){var a=b.current,d=a.nextEffect,e=a.pos,c={opacity:1},f=b.direction,g;e.opacity=0.1;"elastic"===d&&(g="down"===f||"up"===f?"top":"left","down"===f||"right"===f?(e[g]=w(l(e[g])-200),c[g]="+=200px"):(e[g]=w(l(e[g])+200),c[g]="-=200px"));"none"===d?b._afterZoomIn():b.wrap.css(e).animate(c,{duration:a.nextSpeed,easing:a.nextEasing,complete:b._afterZoomIn})},changeOut:function(){var a=b.previous,d=a.prevEffect,e={opacity:0.1},c=b.direction;"elastic"===d&&(e["down"===c||"up"===c?"top":"left"]=("up"===c||"left"===c?"-":"+")+"=200px");a.wrap.animate(e,{duration:"none"===d?0:a.prevSpeed,easing:a.prevEasing,complete:function(){f(this).trigger("onReset").remove()}})}};b.helpers.overlay={defaults:{closeClick:!0,speedOut:200,showEarly:!0,css:{},locked:!s,fixed:!0},overlay:null,fixed:!1,el:f("html"),create:function(a){a=f.extend({},this.defaults,a);this.overlay&&this.close();this.overlay=f('<div class="fancybox-overlay"></div>').appendTo(b.coming?b.coming.parent:a.parent);this.fixed=!1;a.fixed&&b.defaults.fixed&&(this.overlay.addClass("fancybox-overlay-fixed"),this.fixed=!0)},open:function(a){var d=this;a=f.extend({},this.defaults,a);this.overlay?this.overlay.unbind(".overlay").width("auto").height("auto"):this.create(a);this.fixed||(n.bind("resize.overlay",f.proxy(this.update,this)),this.update());a.closeClick&&this.overlay.bind("click.overlay",function(a){if(f(a.target).hasClass("fancybox-overlay"))return b.isActive?b.close():d.close(),!1});this.overlay.css(a.css).show()},close:function(){var a,b;n.unbind("resize.overlay");this.el.hasClass("fancybox-lock")&&(f(".fancybox-margin").removeClass("fancybox-margin"),a=n.scrollTop(),b=n.scrollLeft(),this.el.removeClass("fancybox-lock"),n.scrollTop(a).scrollLeft(b));f(".fancybox-overlay").remove().hide();f.extend(this,{overlay:null,fixed:!1})},update:function(){var a="100%",b;this.overlay.width(a).height("100%");I?(b=Math.max(G.documentElement.offsetWidth,G.body.offsetWidth),p.width()>b&&(a=p.width())):p.width()>n.width()&&(a=p.width());this.overlay.width(a).height(p.height())},onReady:function(a,b){var e=this.overlay;f(".fancybox-overlay").stop(!0,!0);e||this.create(a);a.locked&&(this.fixed&&b.fixed)&&(e||(this.margin=p.height()>n.height()?f("html").css("margin-right").replace("px",""):!1),b.locked=this.overlay.append(b.wrap),b.fixed=!1);!0===a.showEarly&&this.beforeShow.apply(this,arguments)},beforeShow:function(a,b){var e,c;b.locked&&(!1!==this.margin&&(f("*").filter(function(){return"fixed"===f(this).css("position")&&!f(this).hasClass("fancybox-overlay")&&!f(this).hasClass("fancybox-wrap")}).addClass("fancybox-margin"),this.el.addClass("fancybox-margin")),e=n.scrollTop(),c=n.scrollLeft(),this.el.addClass("fancybox-lock"),n.scrollTop(e).scrollLeft(c));this.open(a)},onUpdate:function(){this.fixed||this.update()},afterClose:function(a){this.overlay&&!b.coming&&this.overlay.fadeOut(a.speedOut,f.proxy(this.close,this))}};b.helpers.title={defaults:{type:"float",position:"bottom"},beforeShow:function(a){var d=b.current,e=d.title,c=a.type;f.isFunction(e)&&(e=e.call(d.element,d));if(q(e)&&""!==f.trim(e)){d=f('<div class="fancybox-title fancybox-title-'+c+'-wrap">'+e+"</div>");switch(c){case "inside":c=b.skin;break;case "outside":c=b.wrap;break;case "over":c=b.inner;break;default:c=b.skin,d.appendTo("body"),I&&d.width(d.width()),d.wrapInner('<span class="child"></span>'),b.current.margin[2]+=Math.abs(l(d.css("margin-bottom")))}d["top"===a.position?"prependTo":"appendTo"](c)}}};f.fn.fancybox=function(a){var d,e=f(this),c=this.selector||"",k=function(g){var h=f(this).blur(),j=d,k,l;!g.ctrlKey&&(!g.altKey&&!g.shiftKey&&!g.metaKey)&&!h.is(".fancybox-wrap")&&(k=a.groupAttr||"data-fancybox-group",l=h.attr(k),l||(k="rel",l=h.get(0)[k]),l&&(""!==l&&"nofollow"!==l)&&(h=c.length?f(c):e,h=h.filter("["+k+'="'+l+'"]'),j=h.index(this)),a.index=j,!1!==b.open(h,a)&&g.preventDefault())};a=a||{};d=a.index||0;!c||!1===a.live?e.unbind("click.fb-start").bind("click.fb-start",k):p.undelegate(c,"click.fb-start").delegate(c+":not('.fancybox-item, .fancybox-nav')","click.fb-start",k);this.filter("[data-fancybox-start=1]").trigger("click");return this};p.ready(function(){var a,d;f.scrollbarWidth===v&&(f.scrollbarWidth=function(){var a=f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),b=a.children(),b=b.innerWidth()-b.height(99).innerWidth();a.remove();return b});if(f.support.fixedPosition===v){a=f.support;d=f('<div style="position:fixed;top:20px;"></div>').appendTo("body");var e=20===d[0].offsetTop||15===d[0].offsetTop;d.remove();a.fixedPosition=e}f.extend(b.defaults,{scrollbarWidth:f.scrollbarWidth(),fixed:f.support.fixedPosition,parent:f("body")});a=f(r).width();J.addClass("fancybox-lock-test");d=f(r).width();J.removeClass("fancybox-lock-test");f("<style type='text/css'>.fancybox-margin{margin-right:"+(d-a)+"px;}</style>").appendTo("head")})})(window,document,jQuery);

 // blink twice twice
$(document).ready(function() {
$('.blink')
   .delay(1500)
   .fadeOut(50)
   .delay(30)
   .fadeIn(50)
   .delay(200)
   .fadeOut(50)
   .delay(30)
   .fadeIn(50)
   .delay(10000)
   .fadeOut(50)
   .delay(30)
   .fadeIn(50)
   .delay(200)
   .fadeOut(50)
   .delay(30)
   .fadeIn(50);
});


// Links on mobileShow

(function ($) {
        if ($(window).width() < 481) {
          $(".personel-block").click(function(){
            window.location = $(this).attr("data-href");
            return false;
          });
        }
})(jQuery);

function smoothScrollToSelector(selector) {
	//poor man's sync
	if(window.isOngoingSmoothScroll != true) {
		window.isOngoingSmoothScroll = true;
		$('html, body').animate({
			scrollTop: $(selector).offset().top
	    }, 900, function() {
	    	// not necessary to reflect scroll in window.location, as that is managed by angular anyway
	        // window.location.hash = selector;
	    	
	    	//poor man's sync
	    	window.isOngoingSmoothScroll = false;
	    });	
	}
};

(function ($) {
    // Add smooth scrolling to jetzt Termin buchen
    $("a.smooth-scroll").on('click', function(event) {
        event.preventDefault();
        var hash = this.hash;
        smoothScrollToSelector(hash);
    });
})(jQuery);

function initializeSmoothScrolling() {
	//initialize poor man's sync
	window.isOngoingSmoothScroll = false;
    // Add smooth scrolling to arrow-down on landing-page
    $("a.smooth-scroll").on('click', function(event) {
        event.preventDefault();
        var hash = this.hash;
        smoothScrollToSelector(hash);
    });
}

$('.ls-modal').on('click', function(e){
  e.preventDefault();
  $('.modal-title').text($(this).text());
  $('.modal-body').attr('style', '');
  $('#myModal').modal('show').find('.modal-body').load($(this).attr('href'));
});

$('.ls-modal-inline').on('click', function(e){
  e.preventDefault();
  $('.modal-title').text($(this).text());
  $('.modal-body').attr('style', 'white-space: pre-wrap;');
  $('#myModal').modal('show').find('.modal-body').text($(this).attr('data-text'));
});

function initializeSafariLinkFix() {
    $('a.external-link').click( function (event) {
        var target = $(event.currentTarget).attr('data-href') ? $(event.currentTarget).attr('data-href') : $(event.currentTarget).attr('href');
        window.location.href = target;
        return;
    });
}

initializeSafariLinkFix();


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find?v=example
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}

//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex?v=example
//https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    }
  });
}

/*
	Load more content with jQuery - May 21, 2013
	(c) 2013 @ElmahdiMahmoud
*/

$(function () {
    $(".hiddendiv").slice(0, 4).show();
    $("#loadMore").on('click', function (e) {
        e.preventDefault();
        $(".hiddendiv:hidden").slice(0, 4).slideDown();
        if ($(".hiddendiv:hidden").length == 0) {
            $("#load").fadeOut('slow');
        }
        $('html,body').animate({
            scrollTop: $(this).offset().top
        }, 1500);
    });
});
$(function () {
    $(".hiddendiv2").slice(0, 4).show();
    $("#loadMore2").on('click', function (e) {
        e.preventDefault();
        $(".hiddendiv2:hidden").slice(0, 4).slideDown();
        if ($(".hiddendiv2:hidden").length == 0) {
            $("#load").fadeOut('slow');
        }
        $('html,body').animate({
            scrollTop: $(this).offset().top
        }, 1500);
    });
});

// This function will be executed when the user scrolls the page.
$(window).scroll(function(e) {
    // Get the position of the location where the scroller starts.
    var offset = $(".scroller_anchor").offset();
    if (offset == undefined) {
    	return;
    }

    var scroller_anchor = offset.top;

    // Check if the user has scrolled and the current position is after the scroller start location and if its not already fixed at the top
    if ($(this).scrollTop() >= scroller_anchor && $('.scroller').css('position') != 'fixed')
    {    // Change the CSS of the scroller to hilight it and fix it at the top of the screen.
        $('.scroller').css({
            'background': '#26A8E1',
          //  'border': '3px solid #ababab',
            'position': 'fixed',
            'top': '0px',
			'margin-top': '15px'
			//'width': '263px'
        });
        // Changing the height of the scroller anchor to that of scroller so that there is no change in the overall height of the page.
        $('.scroller_anchor').css('height', '50px');
    }
    else if ($(this).scrollTop() < scroller_anchor && $('.scroller').css('position') != 'relative')
    {    // If the user has scrolled back to the location above the scroller anchor place it back into the content.

        // Change the height of the scroller anchor to 0 and now we will be adding the scroller back to the content.
        $('.scroller_anchor').css('height', '0px');

        // Change the CSS and put it back to its original position.
        $('.scroller').css({
            'background': '#26A8E1',
            //'border': '1px solid #ababab',
            'position': 'relative'
        });
    }
});


//forms
$(function() {

    $('#login-form-link').click(function(e) {
		$("#login-form").delay(100).fadeIn(100);
 		$("#register-form").fadeOut(100);
		$('#register-form-link').removeClass('active');
		$(this).addClass('active');
		e.preventDefault();
	});
	$('#register-form-link').click(function(e) {
		$("#register-form").delay(100).fadeIn(100);
 		$("#login-form").fadeOut(100);
		$('#login-form-link').removeClass('active');
		$(this).addClass('active');
		e.preventDefault();
	});

});

/// <reference path="scripts/angular.min.js" />
/// <reference path="scripts/angular-route.min.js" />

angular.module("dentist", ['ui.router', 'pascalprecht.translate', 'smoothScroll', 'angular.filter', 'ngAnimate'])
.run(function ($rootScope, $http) {
    $rootScope.isLoading = true;
    //$rootScope.ServerUrl = "";

})
.config(['$httpProvider', '$translateProvider', '$animateProvider', function ($httpProvider, $translateProvider, $animateProvider) {

    // restrict animation to elements with the zum-animate css class with a regexp.
    $animateProvider.classNameFilter(/zum-animate/);

    $translateProvider.useSanitizeValueStrategy('escapeParameters');
    $translateProvider.translations('en', {
        "EMERGENCY_NEW": 'emergency new',
        NOAPPOINTMENT: 'No available appointments',
        from: 'from ',
        to:'to ',
        TITLE: 'Select appointment',
        DETAIL: 'Enter details',
        "done.Confirmation": 'Confirmation',
        SHOWMOREP: 'Show more practioners',
        SHOWLESSP: 'Show less practioners',
        SHOWMORES: 'Show more services',
        SHOWLESSS: 'Show less services',
        PWEEK: 'Previous Week',
        NWEEK: 'Next Week',
        APPOINTMENT: 'Your Appointment',
        MAKEAPP: 'Please make an appointment!',
        WANT: 'I want this',
        WITH: 'with',
        ON: 'on',
        AT: 'at',
        ENTER: 'Please enter your details',
        "detail.Comment": 'Your message for the practice (optional)',
        PleaseConfirm: 'Please confirm.',
        ALREADY: 'Already a customer',
        EMAIL: 'e-mail',
        CONFIRM: 'Confirm e-mail',
        Info: 'Information must be indicated',
        Salutation: 'Salutation',
        Salutation_MR: 'MR',
        Salutation_MS: 'MS',
        Fname: 'First Name',
        Lname: 'Last Name',
        Address: 'Address (Street, no.)',
        StreetNo: 'Street number',
        PostalCode: 'Postal Code',
        City: 'City',
        CBooking: 'Confirm Booking',
        Password: 'Password',
        Login: 'Login',
        Thanks: 'Thank you, your appointment is now confirmed',
        EmailSent: 'A confirmation with the details of your appointment has been sent to your email address',
        Hello: 'Hello',
        ChangeData: 'If you want, you can change your data here:',
        Change:'Change',
        Welcome: 'Welcome back!',
        Choose:'Select Period',
        SelectService: 'Select service first',
        ShowMore: 'Show more',
        TeimframeNoFree: 'No free appointments in this period.',
        NextFree: 'Next free appointments on',
        FirstFree: 'Last free appointments on',
        SelectServicePlz: 'Please select a service',
        SelectDateTime: 'Please select a date and time',
        ShowThisWeek: 'Show this week',
        CopyRight: 'Copyright and Powered by',
        PrivacyStatement: 'Privacy Statement',
        ChooseService: 'Select a service',
        ChoosePractitioner: 'Select a practitioner (Optional)',
        Agreement: 'I agree with the ',
        Praxisbestimmungen: 'practice terms',
        Datenschutzerkl: 'privacy policy',
        Agb: 'general terms and conditions',
        "detail.PayNow": 'Pay now',
        "detail.PayLater": 'Pay later',
        "detail.UseVoucher": 'apply',
        "detail.showVoucher": 'use voucher',
        "detail.Price": 'Price',
        "detail.VoucherIncorrect": 'No corresponding coupon available',
        "detail.RemoveVoucher": 'Remove',
        "disclaimer.onlyForNewPatients":'for new patients',
        "DR": 'Dr.',
        "DR_MED": 'Dr. med.',
        "DR_MED_DENT": 'Dr. med. dent.',
        "MED_DENT": 'med. dent.'
    })
         .translations('de', {
             "EMERGENCY_NEW": "Notfall",
             "EMERGENCY_EXISTING": "Notfall oder Zahnschmerzen wiederkehrender Patient",
             "DENTAL_HYGIENE": "Dentalhygiene",
             "DENTAL_HYGIENE_DH": "Dentalhygiene bei DH",
             "CHECK_UP": "Zahnärztliche Kontrolle",
             "CHECK_UP_NEW": "Zahn-Check / Kontrolle",
             "CHECK_UP_EXISTING": "Kontrolle wiederkehrender Patient",
             "ZUMEDO_DEMO_ZH": "Vorführung Zumedo Portal ZÜRICH",
             "ZUMEDO_DEMO_BE": "Vorführung Zumedo Portal BERN",
             "ZUMEDO_CONSULTING_ZH": "Beratung online Akquise ZÜRICH",
             "DENTIST_MR": "Zahnarzt",
             "DENTIST_MS": "Zahnärztin",
             "DENTAL_HYGIENIST_MR": "Dentalhygieniker",
             "DENTAL_HYGIENIST_MS": "Dentalhygienikerin",
             "PROPHYLAXIS_ASSISTANT_MR": "Prophylaxeassistent",
             "PROPHYLAXIS_ASSISTANT_MS": "Prophylaxeassistentin",
             "DENTAL_ASSISTANT_MR": "Dentalassistent",
             "DENTAL_ASSISTANT_MS": "Dentalassistentin",
             "ORTHODONTIST_MR": "Kieferorthopäde",
             "ORTHODONTIST_MS": "Kieferorthopädin",
             "ZUMEDO_MR": "Zumedo",
             "ZUMEDO_MS": "Zumedo",
             "CHECK_UP_HYGIENE": "Kontrolle und Dentalhygiene",
             "CHECK_UP_HYGIENE_PA": "Kontrolle und Dentalhygiene bei PA",
             "APPOINTMENT": "Termin",
             "CONSULT_BRACE": "Erstberatung Zahnspange / Invisalign",
             "CONSULT_IMPLANT": "Erstberatung Implantat",
             "CONSULT_BRIDGE": "Erstberatung Brücke",
             "TOOTH_BROKEN": "Abgebrochener Zahn",
             "BLEACHING": "Bleaching In-Office",
             "BLEACHING_HOME": "Bleaching Home",
             "VENEER": "Erstberatung Veneer",
             "CROWN": "Erstberatung Krone / Brücke",
             "EMERGENCY": "Notfall oder Zahnschmerzen",
             "FILLING": "Problem mit Füllung",
             "ROOT": "Erstberatung Wurzelbehandlung",
             "PAIN": "Zahnschmerzen",
             "SECOND_OPINION": "Zweitmeinung",
             "GUM_PROBLEM": "Zahnfleischproblem",
             "WISDOM_TOOTH": "Erstberatung Weisheitszahn",
             "OTHER": "Anderes / Beratung",
             "SECOND_OPINION_ORTHODONTICS": "Zweitmeinung Kieferorthopädie",
             "CONSULT_ORTHODONTICS": "Erstberatung Kieferorthopädie",
             NOAPPOINTMENT: 'Keine Termine verfügbar. Wählen Sie eine andere Behandlung oder Praktizierende/n.',
             "zuerich": "Zürich",
             "bern": "Bern",
             "basel": "Basel",
             "luzern": "Luzern",
             "winterthur": "Winterthur",
             "zug": "Zug",
             "chur": "Chur",
             "st-gallen": "St. Gallen",
             "schaffhausen": "Schaffhausen",
             "thun": "Thun",
             "nidwalden": "Nidwalden",
             "aargau": "Aargau",
             "biel": "Biel",
             "appenzellerland": "Appenzellerland",
             "solothurn": "Solothurn",
             from: 'ab ',
             to: 'bis ',
             TITLE: 'Termin wählen',
             DETAIL: 'Details eingeben',
             "done.Confirmation": 'Bestätigung',
             SHOWMOREP: 'Mehr Praktizierende anzeigen',
             SHOWLESSP: 'Weniger anzeigen',
             SHOWMORES: 'Mehr Behandlungen anzeigen',
             SHOWLESSS: 'Weniger Behandlungen anzeigen',
             PWEEK: 'letzte Woche',
             NWEEK: 'nächste Woche',
             APPOINTMENT: 'Ihr Termin',
             MAKEAPP: 'Bitte vereinbaren Sie einen Termin!',
             WANT: 'Weiter',
             WITH: 'bei',
             ON: 'am',
             AT: 'um',
             ENTER: 'Bitte tragen Sie Ihre Angaben ein',
             PleaseConfirm: 'Bitte bestätigen.',
             ALREADY: 'Bereits Patient',
             EMAIL: 'E-Mail',
             CONFIRM: 'E-Mail bestätigen',
             "detail.Comment" : 'Ihre Nachricht an die Praxis (optional)',
             Info: 'Informationen müssen angegeben werden',
             Salutation: 'Anrede',
             Salutation_MR: 'Herr',
             Salutation_MS: 'Frau',
             Fname: 'Vorname',
             Lname: 'Nachname',
             Address: 'Adresse (Strasse, Nr.)',
             StreetNo: 'Hausnummer',
             PostalCode: 'Postleitzahl',
             City: 'Stadt',
             CBooking: 'Ich bestätige diese Buchung',
             Password: 'Passwort',
             Login: 'Anmeldung',
             Thanks: 'Vielen Dank, Ihre Termin-Buchung ist jetzt abgeschlossen.',
             EmailSent: 'Eine Bestätigung mit den Details Ihres Termins wurde an Ihre E-Mail-Adresse gesendet.',
             Hello: 'Hallo',
             ChangeData: 'Wenn Sie möchten, können Sie hier Ihre Daten ändern:',
             Welcome: 'Willkommen zurück!',
             Change:'Ändern',
             Choose: 'Zeitraum ändern',
             SelectService: 'Wählen Sie zuerst eine Dienstleistung aus',
             ShowMore: 'Mehr anzeigen',
             TeimframeNoFree: 'Keine freien Termine in diesem Zeitraum.',
             NextFree: 'Zum nächsten freien Termin',
             FirstFree: 'Zum vorherigen freien Termin',
             SelectServicePlz: 'Bitte wählen Sie zuerst eine Behandlung bei Schritt 1.',
             SelectDateTime: 'Bitte wählen Sie ein Datum und eine Uhrzeit',
             ShowThisWeek: 'Aktuelle Woche anzeigen',
             CopyRight: 'Copyright ',
             PrivacyStatement: 'Datenschutzerklärung',
             ChooseService: 'Wählen Sie eine Behandlung',
             ChoosePractitioner: 'Wählen Sie einen Praktizierenden (Optional)',
             Agreement: 'Ich bestätige, die ',
             Praxisbestimmungen: 'Praxisbestimmungen',
             Datenschutzerkl: 'Datenschutzerklärungen',
             Agb: 'Allgemeinen Geschäftsbedingungen',
             "detail.PayNow": 'Jetzt bezahlen',
             "detail.PayLater": 'Später bezahlen',
             "detail.UseVoucher": 'Anwenden',
             "detail.showVoucher": 'Gutschein einlösen',
             "detail.Price": 'Preis',
             "detail.VoucherIncorrect": 'Kein entsprechender Gutschein vorhanden',
             "detail.RemoveVoucher": 'Entfernen',
             "disclaimer.onlyForNewPatients":'für Neupatienten',
             "DR": 'Dr.',
             "DR_MED": 'Dr. med.',
             "DR_MED_DENT": 'Dr. med. dent.',
             "MED_DENT": 'med. dent.'
         });
    var language = localStorage.getItem("lang");
    if(language==null)
        $translateProvider.preferredLanguage('de');
    else
        $translateProvider.preferredLanguage(language);

}])


.directive('ngMatch', ['$parse', function ($parse) {

    var directive = {
        link: link,
        restrict: 'A',
        require: '?ngModel'
    };
    return directive;

    function link(scope, elem, attrs, ctrl) {
        // if ngModel is not defined, we don't need to do anything
        if (!ctrl) return;
        if (!attrs['ngMatch']) return;

        var firstPassword = $parse(attrs['ngMatch']);

        var validator = function (value) {
            var temp = firstPassword(scope),
            v = value === temp;
            ctrl.$setValidity('match', v);
            return value;
        }

        ctrl.$parsers.unshift(validator);
        ctrl.$formatters.push(validator);
        attrs.$observe('ngMatch', function () {
            validator(ctrl.$viewValue);
        });

    }
}])

.directive('datePicker', ['$parse', function ($parse) {

    var directive = {
        link: link,
        restrict: 'A',
    };
    return directive;

    function link(scope, elem, attrs, ctrl) {
        // if ngModel is not defined, we don't need to do anything

        $(elem).datepicker({
            format: 'dd.mm.yyyy',
            autoclose: true,
            startDate: new Date(),
            todayBtn: "linked",
            todayHighlight: true,
            language: 'de'
        }).on('changeDate', function (ev) {
            scope.$emit("UpdatingDate", ev.date);
        });
    }
}]);

angular.module('dentist').filter('showDate', function () {
    return function (timeObj, format) {
        var Language = localStorage.getItem("lang");
        if (timeObj != null)
            if (Language == "de")
                return moment(timeObj, "dddd MM/DD/YYYY", "de").lang("de").format(format);
            else
                return moment(timeObj, "dddd MM/DD/YYYY", "en").lang("en").format(format);
        else
            return null;
    };
});
angular.module('dentist').filter('showTime', function () {
    return function (timeObj, format) {
        var Language = localStorage.getItem("lang");
        if (timeObj != null)
            if (Language == "de")
                return moment.utc(timeObj, "dddd MM/DD/YYYY HH:mm:ss", "de").lang("de").local().format(format);
            else
                return moment.utc(timeObj, "dddd MM/DD/YYYY HH:mm:ss", "en").lang("en").local().format(format);
        else
            return null;
    };
});
function uiBlock(msg, el, loaderOnTop) {
    lastBlockedUI = el;
    if (msg == '' || msg == null || msg == "") {
        msg = "LOADING";
    }
    if (el) {
        jQuery(el).block({
            //class="loading-message loading-message-boxed"  style="margin-top:38%" <span>&nbsp;&nbsp;' + msg + '...</span>
            message: '<div  style="z-index:999999 !important"><img src="img/loader.gif" align="absmiddle"></div>',
            baseZ: 2000,
            css: {
                border: 'none',
                padding: '2px',
                backgroundColor: 'none',
            },
            overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.05,
                cursor: 'wait'
            }
        });
    } else {
        if (msg == '' || msg == null || msg == "") {
            msg = "LOADING";
        }
        $.blockUI({
            //class="loading-message loading-message-boxed"  style="margin-top:38%;"  <span>&nbsp;&nbsp;' + msg + '...</span>
            message: '<div style="z-index:999999 !important"><img src="img/loader.gif" align="absmiddle"></div>',
            baseZ: 2000,
            css: {
                border: 'none',
                padding: '2px',
                backgroundColor: 'none'
            },
            overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.05,
                cursor: 'wait'
            }
        });
    }
}

function uiUnBlock(msg, el) {
    if (msg == '' || msg == null || msg == "") {
        msg = "LOADING";
    }
    if (el) {
        jQuery(el).unblock({
            onUnblock: function () {
                jQuery(el).removeAttr("style");
            }
        });
    }
    else {
        $.unblockUI();
    }
}

(function() {
    'use strict';

    angular
        .module('dentist')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

    function stateConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        
       $stateProvider
       .state('businesscards', {
           url: "/{region}/suche?treatment&highlight&scroll",
           params: {
               landingTexts: null,
               scroll: null
           },
           templateUrl: "templates/businesscards.html",
           controller: 'businesscardsController',
           controllerAs: 'ctrl'
       });
       
       window.businesscardsLandingPages.forEach(function(landing) {
           if (landing.isDedicatedLandingPage) {
               return;
           }

           $urlRouterProvider.when(landing.path, function ($match, $state) {
               $state.go('businesscards', {region: $match.region, treatment: landing.treatment, landingTexts: landing, scroll: null}, {location: false});
           });
       });

       //$urlRouterProvider.otherwise("/suche");
       
       $locationProvider.html5Mode({enabled: true, rewriteLinks: false});

    }

})();

(function (angular) {
    'use strict';

    angular
     .module('dentist')
     .factory('dentistService', ['$http', '$rootScope', '$interpolate', dentistServiceFactory]);

    function dentistServiceFactory($http, $rootScope, $interpolate) {

        var dentistService = {
            getAllPracticeBusinessCards: getAllPracticeBusinessCards,
            getAllServicesAndPractitionersInPractice: getAllServicesAndPractitionersInPractice,
            getCoupon: getCoupon,
            insertBookingInformation: insertBookingInformation,
            getPracticeProfileWithPublishedTreatmentExperiencesAndPublishedReponses: getPracticeProfileWithPublishedTreatmentExperiencesAndPublishedReponses
        };

        return dentistService;

        function getAllPracticeBusinessCards(region) {
            var config = { params: { region: region } };
//        	var url = "http://env-5650710.appengine.flow.ch/api/practices/withGroupedTreatmentsAndFreeTimeSlots";
            var url = "/api/practices/withGroupedTreatmentsAndFreeTimeSlots";
            return $http.get(url, config)
            .then(getAllComplete)
            .catch(getAllError);
            
            function getAllComplete(response) {
                return response;
            }
            
            function getAllError(error) {
                // any error logging goes here
                console.log(error);
                
                throw error;
            }
        };
        function getAllServicesAndPractitionersInPractice(practiceParam, standalone) {
        	var config = { params: { standalone: standalone } };
//        	var url = "http://env-5650710.appengine.flow.ch/api/practices/withPractitionersAndGroupedTreatments/{{practiceId}}";
        	var url = "/api/practices/withPractitionersAndGroupedTreatments/{{practiceId}}";
            return $http.get($interpolate(url)(practiceParam), config)
                .then(getAllComplete)
				    .catch(getAllError);

            function getAllComplete(response) {
                return response;
            }

            function getAllError(error) {
                // any error logging goes here
                console.log(error);
                
                if(error.status == 404) {
                	return { data: { practitioners: {} } };
                }

                throw error;
            }
        };

        function getCoupon(couponCode) {
//        	var url = "http://env-5650710.appengine.flow.ch/api/coupons/byCode/{{couponCode}}";
            var url = "/api/coupons/byCode/{{couponCode}}";
            return $http.get($interpolate(url)({couponCode: couponCode}))
            .then(getAllComplete)
            .catch(getAllError);
            
            function getAllComplete(response) {
                return response;
            }
            
            function getAllError(error) {
                // any error logging goes here
                console.log(error);
                
                throw error;
            }
        };

        function insertBookingInformation(obj) {
//            return $http.post("http://env-5650710.appengine.flow.ch/api/insertBookingInformation", obj)
            return $http.post("/api/insertBookingInformation", obj)
                .then(getAllComplete)
				    .catch(getAllError);

            function getAllComplete(response) {
                return response;
            }

            function getAllError(error) {
                // any error logging goes here
                console.log(error);

                throw error;
            }
        };
        
        function getPracticeProfileWithPublishedTreatmentExperiencesAndPublishedReponses(id) {
        	var url = "/api/practices/withProfileAndPublishedTreatmentExperiences/{{id}}";
            return $http.get($interpolate(url)({ id: id }))
                .then(getAllComplete)
				    .catch(getAllError);

            function getAllComplete(response) {
                return response;
            }

            function getAllError(error) {
                // any error logging goes here
                console.log(error);

                throw error;
            }
      };

    }
})(window.angular);
(function (angular) {
    'use strict';

    angular
     .module('dentist')
     .factory('appointmentService', ['$http','$rootScope', '$interpolate', appointmentServiceFactory]);

    function appointmentServiceFactory($http, $rootScope, $interpolate) {

        var appointmentService = {
            getAllAppointmentsOfPractitioner: getAllAppointmentsOfPractitioner
        };

        return appointmentService;

        function getAllAppointmentsOfPractitioner(practiceParam, practitionerIds, startDate, endDate) {
        	var config = { params: { practitionerIds: practitionerIds, startDate: startDate, endDate: endDate } };
//        	var url = "http://env-5650710.appengine.flow.ch/api/practices/{{practiceId}}/freeTimeSlotsForPractitioners";
        	var url = "/api/practices/{{practiceId}}/freeTimeSlotsForPractitioners";
            return $http.get($interpolate(url)(practiceParam), config)
                .then(getAllComplete)
				    .catch(getAllError);

            function getAllComplete(response) {
                return response;
            }

            function getAllError(error) {
                // any error logging goes here
                console.log(error);

                throw error;
            }
        };

    }
})(window.angular);
function mobileMapFunction(event, id) {
    angular.element(document.getElementById('map-anchor-top-mobile')).scope().ctrl.changeBusinessCard(event,id);
    angular.element(document.getElementById('map-anchor-top-mobile')).scope().$apply();
};

function clickOnMarkerOpenThenScroll(id) {
	angular.element(document.getElementById('map-anchor-top-mobile')).scope().ctrl.showClickedBusinessCardIfHidden(id);
	if(!angular.element(document.getElementById('map-anchor-top-mobile')).scope().$$phase) {
		angular.element(document.getElementById('map-anchor-top-mobile')).scope().$apply();
	}
	//possible timing malfunction when showing new businesscards could happen here 
	smoothScrollToSelector('#'+id);
}

(function (angular) {
    'use strict';
    angular.module("dentist").controller('businesscardsController', businesscardsController);

    function businesscardsController(appointmentService, dentistService, $translate, $filter, $scope, $stateParams, $state, $location, $rootScope, $anchorScroll) {
        
        //jQuery functions initialization
        jQuery(function() {
            initSlickCarousel();
            initSameHeight();
            initItemsZindex();
            initLightbox();
//            initCustomMap();
            initLoadMore();
            initLightboxOpener();
            initFixedBlock();
//            initNavigationSelect();
//            initCustomForms();
//            initFixedMap();
            initializeSmoothScrolling();
        });

        $scope.addCssClassToMapMarkerWithPracticeId = function(cssClass, elementId) {
            angular.element(elementId).addClass(cssClass);
        }
        
        $scope.removeCssClassFromMapMarkerWithPracticeId = function(cssClass, elementId) {
            angular.element(elementId).removeClass(cssClass);
        }

        window.onpopstate = function(event) {
            // support for back button from map: if there is no URL query param for 'view', but we are in mapView, reload the page
            if (!$location.search().view && ctrl.mapView) {
                 window.location.reload();
            }
        };

        //controller initialization
        var ctrl = this;
       
        ctrl.mapDataMarkers = {};
        ctrl.filterDate = new Date();
        ctrl.filterTreatment;
        ctrl.clickedOnMarker;
        ctrl.pageH1;
        ctrl.pageTextParagraph;
        ctrl.updateFilterDate = updateFilterDate;
        ctrl.changeLanguage = changeLanguage;
        ctrl.updateRegionState = updateRegionState;
        ctrl.getPriceDisplayString = getPriceDisplayString;
        ctrl.displayNiceDateString = displayNiceDateString;
        ctrl.isAfterFilterDate = isAfterFilterDate;
        ctrl.sliceTimeSlots = sliceTimeSlots;
        ctrl.updateFilteredTreatments = updateFilteredTreatments;
        ctrl.updateFilteredTimeSlots = updateFilteredTimeSlots;
        ctrl.filterTreatmentTimeSlots = filterTreatmentTimeSlots;
        ctrl.sortOrderPracticeIds = window.sortOrderPracticeIds;
        ctrl.prioritySortOrderPracticeIds = window.prioritySortOrderPracticeIds;
        ctrl.mapPositionPerRegion = window.mapPositionPerRegion;
        ctrl.changeBusinessCard = changeBusinessCard;
        ctrl.isSpecialFakeTimeSlotCase = isSpecialFakeTimeSlotCase;
        ctrl.regionOptions = ['appenzellerland', 'aargau', 'basel', 'bern', 'biel', 'chur', 'luzern', 'nidwalden', 'schaffhausen', 'solothurn', 'st-gallen', 'thun', 'winterthur', 'zug', 'zuerich']; // mostly alphabetically
        ctrl.regionExtensions = { 'zuerich': ['winterthur', 'aargau'],
                             'winterthur': ['zuerich'],
                             'schaffhausen' : ['winterthur'],
                             'zug': ['zuerich'],
                             'luzern': ['nidwalden'],
                             'nidwalden': ['luzern'],
                              'bern': ['thun'],
                              'thun': ['bern'],
                               'appenzellerland': ['st-gallen'],
                               'st-gallen': ['appenzellerland']
                               };
        ctrl.treatmentOptions = ['CHECK_UP_NEW', 'CHECK_UP_HYGIENE', 'DENTAL_HYGIENE', 'EMERGENCY_NEW', 'PAIN', 'TOOTH_BROKEN', 'GUM_PROBLEM', 'FILLING', 'BLEACHING', 'BLEACHING_HOME', 'VENEER', 'WISDOM_TOOTH', 'CONSULT_IMPLANT', 'ROOT', 'CONSULT_BRACE', 'CROWN', 'OTHER','SECOND_OPINION_ORTHODONTICS','CONSULT_ORTHODONTICS'];
        ctrl.treatmentOptionsDividerIndices = [0, 3, 8, 10];
        ctrl.isCurrentFilterTreatmentKoVo = isCurrentFilterTreatmentKoVo;
        ctrl.isLandingPage = true;
        ctrl.mapView = false;
        ctrl.mobileMapSlotsCounter = 2;
        ctrl.changeMobileMapView = changeMobileMapView;
        ctrl.mapClick = mapClick;
        ctrl.currentPracticeMobileMap = -1;
        ctrl.getTimeSlotsOfExternalPractices = getTimeSlotsOfExternalPractices;
        ctrl.clickOnProduct = clickOnProduct;
        ctrl.clickOnTimeslotVariant = clickOnTimeslotVariant;
        ctrl.setTreatmentCallFunctions = setTreatmentCallFunctions;
        ctrl.nameOfTreatmentDropdownSync = nameOfTreatmentDropdownSync;
        ctrl.hideNewDropdown = hideNewDropdown;
        ctrl.orderBySpecialLocationRules = orderBySpecialLocationRules;
        ctrl.highlightBusinesscard = '';
        ctrl.goToProfileMiniBcard = goToProfileMiniBcard;
        ctrl.profileViewGA = profileViewGA;

        ctrl.showClickedBusinessCardIfHidden = showClickedBusinessCardIfHidden;
        ctrl.practicesCount = 7;
        ctrl.practicesCountStep = 5;
        ctrl.showMore = showMore;

        ctrl.sortOptions = [
                {
                    name : 'Vorschlag',
                    getter : function(e) {
                        return ctrl.sortOrderPracticeIds.indexOf(e.id);
                    },
                    getter_2 : function(e) {
                        var filteredTimeSlotsAvailable = (e.filteredTimeSlots !== undefined);
                        var slots;
                        var startTimeAttribute;
                        if (filteredTimeSlotsAvailable) {
                            slots = e.filteredTimeSlots;
                            startTimeAttribute = '$key';
                        } else {
                            slots = e.timeSlots.sort(function (a,b) { return a.startTime.localeCompare(b.startTime); });
                            startTimeAttribute = 'startTime';
                        }
                        return slots.length > 0 ? new Date(slots[0][startTimeAttribute]) : new Date(2999, 12, 31);
                    }
                },
                {
                    name : 'Verfügbarkeit',
                    getter : function(e) {
                        return e.filteredTimeSlots.length > 0 ? new Date(e.filteredTimeSlots[0].$key) : new Date(2999, 12, 31);
                    }
                },
                /*{
                    name : 'Distanz',
                    getter : function(e) {
                        var coords = e.coordinates.split(",");
                        var yDiff = 47.376895 - Number(coords[0]); // coords of Zurich Bahnhofplatz
                        var xDiff = 8.541869 - Number(coords[1]); // coords of Zurich Bahnhofplatz
                        return Math.sqrt((yDiff*yDiff) + (xDiff*xDiff));
                    }
                },*/
                {
                    name : 'Preis',
                    getter : function(e) {
                        if (treatmentHasNoPrice(ctrl.filterTreatment)) {
                            return e.taxpunktwert;
                        }
                        
                        var lowestPrice = 999999;
                        $.each(e.filteredTreatments, function(index, treat) {
                            var price = treat.fixedPriceReduced != null ? treat.fixedPriceReduced : (treat.fixedPrice != null ? treat.fixedPrice : (treat.minPrice != null ? treat.minPrice : treat.maxPrice));
                            if (price < lowestPrice) {
                                lowestPrice = price;
                            }
                        });
                        return lowestPrice;
                    }
                }
//                {
//                    name : 'Taxpunktwert',
//                    getter : 'taxpunktwert'
//                }
        ];
        ctrl.currentSorting = ctrl.sortOptions[0];

        init();

        function init() {
            if (regionIsSupported($stateParams.region)) {
                ctrl.region = $stateParams.region;
            } else {
                ctrl.region = ctrl.regionOptions[0];
            }

            // TODO no special handling necessary anymore, could be integrated directly into ctrl.sortOptions
           	//if (ctrl.region == 'zuerich') {
           	    var availabilityGetter = ctrl.sortOptions[findSortOptionIndex('Verfügbarkeit')].getter;
           		ctrl.sortOptions[ctrl.sortOptions.length] = { name: 'Besuchserlebnis', getter: ['-averageRating', availabilityGetter] };
           	//}
           	
            initializeLandingPageBehaviour($stateParams.landingTexts);
            
        	ctrl.clickedOnMarker = false;

            if ($stateParams.treatment) {
                ctrl.filterTreatment = $stateParams.treatment;
            }
            
            var urlParamIsPresent = true; // !angular.equals($location.search(), {});
            if (urlParamIsPresent) {
                hideNewDropdown();
            } else {
                $(window).click(function() {
                    hideNewDropdown();
                });
            }
            
            if ($stateParams.highlight) {
            	ctrl.highlightBusinesscard = $stateParams.highlight;
            }

            // TODO [dom] replace with REST-call that supports multiple regions
            ctrl.practices = [];
            var allRegions = [ctrl.region].concat(ctrl.regionExtensions[ctrl.region] || []);
            addPracticesForRegion(allRegions, function() {
                initializationByPractices();
                setNumberOfReviews();
            });
        }

        function addPracticesForRegion(regions, practicesInitializer) {
            if (regions.length == 0) {
                practicesInitializer();
            } else {
                dentistService.getAllPracticeBusinessCards(regions[0]).then(function (res) {
                    var result = res.data;

                    result.forEach(function(practice) {
                        practice.filteredTimeSlots = [];
                        practice.filteredTreatments = [];
                    });
                    ctrl.practices.push.apply(ctrl.practices, result);

                    addPracticesForRegion(regions.slice(1), practicesInitializer);
                }, function (error) {
                    // TODO [dom] error handling
                    addPracticesForRegion(regions.slice(1), practicesInitializer);
                    console.log(error);
                });
            }
        }

        function addPracticesForRegions_experimental(regions) {
            ctrl.practices = [];
            regions.forEach(function(region) {
                dentistService.getAllPracticeBusinessCards(region).then(function (res) {
                    var result = res.data;

                    result.forEach(function(practice) {
                        practice.filteredTimeSlots = [];
                        practice.filteredTreatments = [];
                    });
                    ctrl.practices.push.apply(ctrl.practices, result);

                    initializationByPractices(result);
                    setNumberOfReviews();

                }, function (error) {
                    // TODO [dom] error handling
                    console.log(error);
                });
            });
        }

        function profileViewGA(practice) {
        	var dataLayer = window.dataLayer || [];
        	
        	var data = {
        		'ecommerce': {
	          	    'currencyCode': 'CHF',
	          	    'click': {
	          	        'actionField': {'list': 'Bcards list' + (ctrl.currentSorting ? ' - ' + ctrl.currentSorting.name : '')},
	          	        'products': [{
	          	          'name': 'BcardsProfileClick',
	          	          'brand': practice.name
	          	         }]
	          	       }
	          	  }
            };
      	
        	dataLayer.push(data);
        	
        	dataLayer.push({
                'event':'businesscardClick'
            });
        }
        
        function goToProfileMiniBcard() {
        	if(ctrl.clickedOnMarker) {
        		profileViewGA(ctrl.currentPracticeMobileMap);
        	}
        	
        	var index = getFilteredAndOrderedPractices().indexOf(ctrl.currentPracticeMobileMap);
        	
        	var treatment = $filter('orderBy')(ctrl.currentPracticeMobileMap.filteredTreatments, 'noTimeSlotsAvailable')[0];
        	
        	var data = {
                	  'ecommerce': {
                	    'currencyCode': 'CHF',
                	    'click': {
                	        'actionField': {'list': 'Bcards list' + ' mobile-map'},
                	        'products': [{
                	          'name': String(treatment.type),                      // Name or ID is required.
                	          //'id': String(practice.name+treatment.type),
                	          'brand': String(ctrl.currentPracticeMobileMap.name),
                	          'coupon': treatment.fixedPriceReduced ? (treatment.reductionCoupon.description ? treatment.reductionCoupon.description : treatment.reductionCoupon.code) : '',
                	          //'variant': String(variant),
                	          'position': Number(index + 1)
                	         }]
                	       }
                	  }
                	};
        	
        	if (treatment.fixedPrice) {
        		data.ecommerce.click.products[0].price = Number(treatment.fixedPrice); 
        	}
        	
          	var dataLayer = window.dataLayer || [];        	
          	dataLayer.push(data);
          	
          	dataLayer.push({
                'event':'businesscardClick'
            });
          	
          	localStorage.setItem("ecommerceObject", JSON.stringify(data));
        }
        
        function showMore() {
        	ctrl.practicesCount = ctrl.practicesCount+ctrl.practicesCountStep;
        	getProductsImpressions(true);
        }
        
        function initializationByPractices() {
            getTimeSlotsOfExternalPractices(ctrl.practices);
            
            handleSpecialTreatmentCases(ctrl.practices);

            handleSpecialFakeTimeSlotCases(ctrl.practices);
            
            ctrl.updateFilteredTreatments(ctrl.practices);
            ctrl.updateFilteredTimeSlots(ctrl.practices);
            
            /* if (!$stateParams.treatment) {
            	setActiveSortOption('Vorschlag');
            } */
            
            // init Google map
            var mapDataMarkers = buildMapDataMarkers(ctrl.practices, true);
            $('.js-map-fixed').data('markers', mapDataMarkers);
            
            var mapPositionAndZoom = ctrl.mapPositionPerRegion[ctrl.region] || [];
            initCustomDesktopMap(mapPositionAndZoom[0], mapPositionAndZoom[1]);
            initFixedMap();
            
            if (isBot()) {
            	ctrl.practicesCount = ctrl.practices.length;
            }
            
            if($stateParams.scroll) {
            	//TODO find a nice way to scroll to practice
//            	console.log("scrolling..?");
//            	showClickedBusinessCardIfHidden($stateParams.scroll);
//            	
//            	$location.hash($stateParams.scroll);
//            	$anchorScroll();
        	}
        }
        
        function setNumberOfReviews() {
	        for(var i=0; i<ctrl.practices.length; i++) {
           		if(ctrl.practices[i].averageRating >= 0 && ctrl.practices[i].averageRating < 7) {
           			ctrl.practices[i].ratingText = 'Besuchserlebnis';
    			} else if(ctrl.practices[i].averageRating >= 7 && ctrl.practices[i].averageRating < 8) {
    				ctrl.practices[i].ratingText = 'Gut';
    			} else if(ctrl.practices[i].averageRating >= 8 && ctrl.practices[i].averageRating < 8.5) {
    				ctrl.practices[i].ratingText = 'Sehr Gut';
    			} else if(ctrl.practices[i].averageRating >= 8.5 && ctrl.practices[i].averageRating < 9) {
    				ctrl.practices[i].ratingText = 'Fabelhaft';
    			} else if(ctrl.practices[i].averageRating >= 9 && ctrl.practices[i].averageRating < 9.5) {
    				ctrl.practices[i].ratingText = 'Hervorragend';
    			} else if(ctrl.practices[i].averageRating >= 9.5 && ctrl.practices[i].averageRating <= 10) {
    				ctrl.practices[i].ratingText = 'Aussergewöhnlich';
    			}
    			ctrl.practices[i].averageRating = Number($filter('number')(ctrl.practices[i].averageRating, 1));
           	}
        }
        
        function orderBySpecialLocationRules(item) {
        	// TODO see about performance optimization possibility (the practices are filtered two times if the region is not winterthur -> try solving it in html with double filters
        	var order = $filter('orderBy')(ctrl.practices, ctrl.currentSorting.getter).findIndex(function (el) { return el.id == item.id});
            if (ctrl.prioritySortOrderPracticeIds[item.id] != null) {
                order = ctrl.prioritySortOrderPracticeIds[item.id] - 0.1;
            }

            // if having practices from other regions in list, and region not zuerich, then we move the foreign ones down
        	if ((ctrl.region != item.location) && !(ctrl.region == 'zuerich' && item.location == 'winterthur')) {
    			order = order + (ctrl.practices.length * ( ctrl.regionExtensions[ctrl.region].indexOf(item.location)+1 ));
        	}

    		return order;
        }
        
        function initializeLandingPageBehaviour(landingTexts) {
            var replaceRegionPlaceholderWithTranslation = function (text, noTranslate) {
                var region = noTranslate ? ctrl.region : $filter('translate')(ctrl.region);
                return text ? text.replace(/{region}/g, region) : null;
            };
            if (landingTexts) {
                ctrl.isLandingPage = true;
                $rootScope.pageTitle = replaceRegionPlaceholderWithTranslation(landingTexts.title);
                $rootScope.pageDescription = replaceRegionPlaceholderWithTranslation(landingTexts.description);
                $rootScope.canonicalLink = null;
                ctrl.pageH1 = replaceRegionPlaceholderWithTranslation(landingTexts.h1);
                ctrl.pageTextParagraph = replaceRegionPlaceholderWithTranslation(landingTexts.p);
            } else {
                ctrl.isLandingPage = false;

                // TODO [dom] generic title per treatment
                var treatmentTranslation = $filter('translate')(ctrl.filterTreatment);
                if (!treatmentTranslation) {
                    treatmentTranslation = 'Zahnarzt & DH';
                }
                $rootScope.pageTitle = replaceRegionPlaceholderWithTranslation(treatmentTranslation + " in {region} online buchen | Zumedo.ch");

                $rootScope.pageDescription = null;
                $rootScope.canonicalLink = replaceRegionPlaceholderWithTranslation(findCanonicalLinkForCurrentTreatment(), true);
                ctrl.pageH1 = null;
                ctrl.pageTextParagraph = null;
            }
        }
        
        function findCanonicalLinkForCurrentTreatment() {
            if (!ctrl.filterTreatment) {
                return '/zahnarzt/{region}/';
            }

            var page = window.businesscardsLandingPages.find(function(page) { return page.treatment == ctrl.filterTreatment; });
            if (!page) {
                console.log("WARN: businesscardsLandingPage for canonical link not found for treatment: " + ctrl.filterTreatment);
                return null;
            }
            
            return page.isDedicatedLandingPage ? page.path : '/zahnarzt' + page.path; 
        }
        
        function isBot(){
        	var botPattern = "(googlebot\/|Google Page Speed Insights|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
	        var re = new RegExp(botPattern, 'i');
	        return re.test(navigator.userAgent);
        }
        
        function setTreatmentCallFunctions(event){
        	var element = $(event.currentTarget);
        	var treatment = element.attr('data-original');
        	ctrl.filterTreatment = treatment;
        	
        	ctrl.updateFilteredTreatments(ctrl.practices); 
        	ctrl.updateFilteredTimeSlots(ctrl.practices);
        	
        	$('.jcf-select-text').filter(":contains('Behandlung')").text(element.text());
        	ctrl.hideNewDropdown();
        }
        
        function nameOfTreatmentDropdownSync() {
        	var name;
        	if(ctrl.filterTreatment) {
        		name = $filter('translate')(ctrl.filterTreatment);
        	} else {
        		name = "Behandlung wählen:";
        	}
        	$('.jcf-select-text').eq(0).text(name);
        }
        
        function hideNewDropdown() {
        	$('#treatment-popup-dropdown').hide();
        }
        
        function showClickedBusinessCardIfHidden(id) {
        	var	sorted = getFilteredAndOrderedPractices();
        	var index = sorted.findIndex(function (element) {
        			return parseInt(element.id) == parseInt(id); 
        	});

        	if((index != -1) && (index+1) > ctrl.practicesCount - 1) {
    			ctrl.practicesCount = index+2;
    			if(ctrl.practicesCount%ctrl.practicesCountStep != 0) {
    				ctrl.practicesCount = ctrl.practicesCount - ctrl.practicesCount%ctrl.practicesCountStep + ctrl.practicesCountStep;
    			}
    		}
        }

        function getFilteredAndOrderedPractices() {
            var filteredPractices = $filter('filter')(ctrl.practices, ctrl.filterTreatment);
            return $filter('orderBy')(filteredPractices, ctrl.orderBySpecialLocationRules);
        }
        
        // PRODUCTS IMPRESSIONS when clicked on treatment filtering on top of page
        function getProductsImpressions(showMore) {
        	var data = {
          		  'ecommerce': {
          		    //'currencyCode': 'CHF',                       // Local currency is optional.
          		    'impressions': []
          		  }
          		};
        	
        	var treatmentName = ctrl.filterTreatment ? ctrl.filterTreatment : 'ALL';
        	
        	getFilteredAndOrderedPractices().forEach(function(p, i) {
        		if((i < ctrl.practicesCount && !showMore) || (showMore && (i < ctrl.practicesCount) && (i >= (ctrl.practicesCount - ctrl.practicesCountStep)))) { 
        			
        			var treatment = $filter('orderBy')(p.filteredTreatments, 'noTimeSlotsAvailable')[0];
        			
        			data.ecommerce.impressions[i] = 
        			{
        					'name': treatmentName, // Name or ID is required.
        					//'id': String(p.name+ctrl.filterTreatment),
        					'brand': p.name,
        					//'category': treatment.fixedPriceReduced ? (treatment.reductionCoupon.description ? treatment.reductionCoupon.description : '') : '',
        					'variant': treatment.noTimeSlotsAvailable  ? 'unavailable' : null,
        					'list': 'Bcards list' + (ctrl.currentSorting ? ' - ' + ctrl.currentSorting.name : ''),
        					'position': Number(i + 1)
        			}
        		}
            });
        	
        	var dataLayer = window.dataLayer || [];        	
        	dataLayer.push(data);
        	
        	//console.log("product impressions: " + JSON.stringify(data));
        }
        
        // PRODUCT CLICK when clicked on treatment in the bcard
        function clickOnProduct(treatment, practice) {
        	clickDataPush(practice, treatment, true);
        }
        
        function calculateTimeVariant(timeString) {
        	var time = moment(timeString);
        	
        	if (time.isBefore(moment().add(1, 'days'))) {
        		return "24h";
        	} else if(time.isBefore(moment().add(2, 'days'))) {
        		return "24h-48h";
        	} else if(time.isBefore(moment().add(7, 'days'))) {
        		return "2d-1week";
        	} else if(time.isBefore(moment().add(14, 'days'))) {
        		return "1week-2weeks";
        	} else if(time.isBefore(moment().add(1, 'months'))) {
        		return "2weeks-1month";
        	} else if(time.isBefore(moment().add(2, 'months'))) {
        		return "1month-2months";
        	} else if(time.isBefore(moment().add(6, 'months'))) {
        		return "2months-6months";
        	} else if(time.isBefore(moment().add(12, 'months'))) {
        		return "1year";
        	} else {
        		return "over1year";
        	}
        }
        
        // PRODUCT CLICK when clicked on timeslot in the bcard
        function clickOnTimeslotVariant(practice, timeString, treatmentId, isInList) {
            var treatment = practice.filteredTreatments.find(function(treat) { return treat.originalIds.indexOf(treatmentId) >= 0; } );
            
        	var variant = calculateTimeVariant(timeString);
        	
        	clickDataPush(practice, treatment, isInList, variant);
        }
        
        function clickDataPush(practice, treatment, isInList, variant) {
        	var index = getFilteredAndOrderedPractices().indexOf(practice);
        	
        	var data = {
                	  'ecommerce': {
                	    'currencyCode': 'CHF',
                	    'click': {
                	        'actionField': {'list': 'Bcards list' + (ctrl.currentSorting ? ' - ' + ctrl.currentSorting.name : '')},      // Optional list property.
                	        'products': [{
                	          'name': String(treatment.type),                      // Name or ID is required.
                	          //'id': String(practice.name+treatment.type),
                	          'brand': String(practice.name),
                	          'coupon': treatment.fixedPriceReduced ? (treatment.reductionCoupon.description ? treatment.reductionCoupon.description : treatment.reductionCoupon.code) : '',
                	          //'variant': String(variant),
                	          'position': Number(index + 1)
                	         }]
                	       }
                	  }
                	};
        	
        	if (isInList) {
        	    data.ecommerce.click.actionField = {'list': 'Bcards list'  + (ctrl.currentSorting ? ' - ' + ctrl.currentSorting.name : '')};
        	    data.ecommerce.click.products[0].position = Number(index + 1);
        	}
        	
        	if (variant) {
        		data.ecommerce.click.products[0].variant = String(variant);
        	}
        	
        	if (treatment.fixedPrice) {
        		data.ecommerce.click.products[0].price = Number(treatment.fixedPrice); 
        	}
        	
        	var dataLayer = window.dataLayer || [];
        	dataLayer.push(data);
        	
        	localStorage.setItem("ecommerceObject", JSON.stringify(data));
//        	console.log(localStorage.getItem("ecommerceObject"));
        	
        	dataLayer.push({
                'event':'businesscardClick'
            });
        	
        	//console.log("bcard click data: " + JSON.stringify(data));
        }

        function getTimeSlotsOfExternalPractices(practices) {
            practices.forEach(function(practice) {
            	if(practice.useExternalCalendar) {
            		//initiate loading gif
            		practice.isLoading = true;
            		
            		//practice id
            		var data = { practiceId: practice.id };
            		
            		//start and end date
            		var startDate = moment().format("YYYY-MM-DD");
		            var endDate = moment().add(3, 'M').format("YYYY-MM-DD");
            		
            		//practitioners
	                var practitionerIdsTemp = practice.groupedTreatments.reduce(function(total, treatment) {
	                    return total.concat(treatment.practitionerIds);
	                }, []);
	                
	                var uniquePractitionerIds = new Set();
	                
	                practitionerIdsTemp.forEach(function(element) {
	                    uniquePractitionerIds.add(element);
	                });
	                
	                var practitionerIds = Array.from(uniquePractitionerIds);
	                
	                //service call for getting external time slots
	                appointmentService.getAllAppointmentsOfPractitioner(data,practitionerIds, startDate, endDate).then(function (res) {
	                    var result = res.data;
	                    
	                	practice.timeSlots = result;
	                	
	                    updateFilteredTimeSlots([practice]);
	                    
	                    //hide loading gif
	            		practice.isLoading = false;
	                }, function (error) {
	                    // TODO [dom] error handling
	                    console.log("error in businesscards.js when additionally getting external time slots"+error);
	                });
            	}	
            });
        }
        
        function treatmentHasNoPrice(treat) {
            return ['CHECK_UP_NEW', 'CHECK_UP_HYGIENE', 'DENTAL_HYGIENE', 'EMERGENCY_NEW', 'BLEACHING', 'BLEACHING_HOME'].indexOf(treat) === -1;
        }
        
        function isCurrentFilterTreatmentKoVo() {
            return ['CROWN', 'CONSULT_BRACE', 'ROOT', 'CONSULT_IMPLANT', 'WISDOM_TOOTH', 'VENEER', 'OTHER'].indexOf(ctrl.filterTreatment) !== -1;
        }

        function regionIsSupported(region) {
            return ctrl.regionOptions.indexOf(region) !== -1;
        }
        
        function updateRegionState() {
            if ($stateParams.region !== ctrl.region) {
                $state.go("businesscards", {region: ctrl.region, treatment: ctrl.filterTreatment, landingTexts: null});
            }
        }
        
        function updateFilteredTreatments(practices) {
            if (!ctrl.isLandingPage || ($stateParams.landingTexts && ($stateParams.landingTexts.treatment != ctrl.filterTreatment))) {
                initializeLandingPageBehaviour(null);
            }
            
            practices.forEach(function(practice) {
                practice.filteredTreatments = $filter('filter')(practice.groupedTreatments, ctrl.filterTreatment);
                addUpSellingTreatments(practice);
            });
            
            getProductsImpressions(false);
            
            var treatmentName = ctrl.filterTreatment ? ctrl.filterTreatment : '';
            
                dataLayer.push({
                    'event':'VirtualPageview',
                'virtualPageURL': 'https://www.zumedo.ch/zahnarzt/' + ctrl.region + '/suche?treatment=' + treatmentName
                });
        }

        /**
            if filtered for DH or Kontrolle, also show DH&Kontrolle
        */
        function addUpSellingTreatments(practice) {
            if (['DENTAL_HYGIENE', 'CHECK_UP_NEW'].indexOf(ctrl.filterTreatment) >= 0) {
                var checkUpHygiene = practice.groupedTreatments.find(function(treat) { return treat.type == 'CHECK_UP_HYGIENE'; });
                if (checkUpHygiene) {
                    practice.filteredTreatments.push(checkUpHygiene);
                }
            }
        }

        function updateFilteredTreatmentsTimeAvailability(practices) {
            practices.forEach(function(practice) {
                practice.filteredTreatments.forEach(function(treatment) {
                    if (practice.isLoading || practice.filteredTimeSlots.some(function(slot) { return slot.some(function(time) { return time.treatmentIds.indexOf(treatment.originalIds[0]) !== -1; }); })) {
                        treatment.noTimeSlotsAvailable = false;
                    } else {
                        treatment.noTimeSlotsAvailable = true;
                    }
                });
                
                updateMarkerState(practice);
            });
        }
        
        function updateMarkerState(practice) {
            if (isTheMapMarkerGrey(practice)) {
                $scope.addCssClassToMapMarkerWithPracticeId("custom-marker-grey", '#marker-'+practice.id);
                $scope.addCssClassToMapMarkerWithPracticeId("custom-marker-grey", '#marker-mobile-id-'+practice.id);
            } else {
                $scope.removeCssClassFromMapMarkerWithPracticeId("custom-marker-grey", '#marker-'+practice.id);
                $scope.removeCssClassFromMapMarkerWithPracticeId("custom-marker-grey", '#marker-mobile-id-'+practice.id);
            }
        }
        
        function isTheMapMarkerGrey(practice) {
        	return practice.filteredTreatments.length == 0 || practice.filteredTimeSlots.length == 0;
        }
        
        function isSpecialTreatmentCase(practice) {
            return practice.id == 30682; // swiss smile
        }

        function sortTreatmentsNewlyByOptionsOrdering(treatments) {
            return treatments.sort(function (a,b) { return ctrl.treatmentOptions.indexOf(a.type) - ctrl.treatmentOptions.indexOf(b.type); });
        }

        function handleSpecialTreatmentCases(practices) {
            practices.forEach(function(practice) {
                practice.groupedTreatments = sortTreatmentsNewlyByOptionsOrdering(practice.groupedTreatments);
                if (isSpecialTreatmentCase(practice)) {
                    practice.groupedTreatments.forEach(function(treat) {
                        if (treat.originalIds.indexOf(34027) >= 0) { // swiss smile Kontrolle und Dentalhygiene
                            treat.type = treat.type + '_PA';
                        }
                        if (treat.originalIds.indexOf(34026) >= 0) { // swiss smile Dentalhygiene
                            treat.type = treat.type + '_DH';
                        }
                    });
                }
            });
        }
        
        function isSpecialFakeTimeSlotCase(practice) {
            return practice.id == 4006;
        }

        function handleSpecialFakeTimeSlotCases(practices) {
            practices.forEach(function(practice) {
                if (isSpecialFakeTimeSlotCase(practice) && practice.timeSlots.length == 0) {
                    var targetDate = moment().add(3, 'months').date(11).format("YYYY-MM-DD"); // the 11th of the month that is 3 months from now
                    practice.timeSlots.push({
                        "practitionerIds" : [4512, 6055, 4501, 4502, 4503, 4504, 4505, 4506, 4507, 4508, 4509, 4510, 4511],
                        "startTime" : targetDate + "T10:00:00+01:00",
                        "endTime" : targetDate + "T11:00:00+01:00"
                      });
                }
            });
        }
        
        function updateFilteredTimeSlots(practices) {
            practices.forEach(function(practice) {
                var filtered = $filter('filter')(practice.timeSlots, ctrl.filterTreatmentTimeSlots(practice));
                filtered = $filter('map')(filtered, ctrl.sliceTimeSlots(practice));
                filtered = $filter('flatten')(filtered, true);
                filtered = $filter('filter')(filtered, ctrl.isAfterFilterDate);
                filtered = $filter('groupBy')(filtered, 'startTime');
                filtered = $filter('toArray')(filtered, true);
                filtered = $filter('orderBy')(filtered, '$key');
                practice.filteredTimeSlots = filtered;
                
                practice.filteredTimeSlotPagingIndex = 0;
                practice.filteredTimeSlotsDisplayCount = 4;
            });
            
            updateFilteredTreatmentsTimeAvailability(practices);
            
            setActiveSortOption('Verfügbarkeit');
        }

        function findSortOptionIndex(optionName) {
            return ctrl.sortOptions.findIndex(function (element) { return element.name === optionName; });
        }
        
        function setActiveSortOption(optionName) {
            var index = findSortOptionIndex(optionName);
            ctrl.currentSorting = ctrl.sortOptions[index];
            $('#option-link-list-' + index).prop('selected', 'selected');
            $('.jcf-option-opt-level-1').text(ctrl.currentSorting.name);
        }

        function manipulateURLAndSetMapViewParam(paramValue) {
            var url = new URL(window.location);
            if (paramValue) {
                url.searchParams.set('view', paramValue);
                window.history.pushState({}, '', url);
            } else {
                url.searchParams.delete('view');
                window.history.replaceState({}, '', url);
            }
        }
        
        function changeMobileMapView() {
        	ctrl.mapView = !ctrl.mapView;
        	
        	if (ctrl.mapView) {
        	    manipulateURLAndSetMapViewParam('map'); // to support back-button, back to the list

            	document.getElementById("mapswitch").setAttribute("style", "position: fixed; bottom: auto; top: 10px; z-index:99999999999;");
            	document.getElementsByTagName("body")[0].setAttribute("style", "overflow: hidden;");
            	
            	$('#map-anchor-top-mobile').css('position', ''); // unhide
            	
            	$('#map-anchor-bottom').hide();
            	
            	$('#header').hide();
            	
            	/* GOOGLE TRANSLATE UGLY REMOVAL - START */
	            	$("[id=':1.container']").hide();
	                var frame = $("[id=':1.container']");
	            	frame.contents().find("[id=':1.promptSection']").css({display:"none"});
	            	$("div[class='skiptranslate']").css({display:"block", position:"fixed", right:"-1000px"});
            	/* GOOGLE TRANSLATE UGLY REMOVAL - END */
            	
            	initializeMapMobile();
        	} else {
            	manipulateURLAndSetMapViewParam(null); // reset view param to normal list view

            	document.getElementById("mapswitch").setAttribute("style", "position: fixed; bottom: 10px; top: auto;");
            	document.getElementsByTagName("body")[0].setAttribute("style", "overflow: scroll;");
            	
            	$('#map-anchor-top-mobile').css('position', 'absolute'); // hide
            	
            	$('#map-anchor-bottom').show();
            	
            	$('#header').show();
        	}
        	
        	$(window).scroll(); // to address some problem with the Google-Map-initialization
        }
        
        function initializeMapMobile() {
            var mapDataMarkersMobile = buildMapDataMarkers(ctrl.practices, false);
            $('.js-map-mobile').data('markers', mapDataMarkersMobile);
            
            initCustomMobileMap();
        }
        
        function changeLanguage(langKey) {
            $translate.use(langKey);
            localStorage.setItem("lang", langKey);
        }
        
        function displayNiceDateString(dateString) {
        	var dateMoment = moment(dateString);
        	var today = moment();
        	
        	if (today.isSame(dateMoment, 'day')) {
        		return "heute um\n" + $filter('date')(dateString, "HH:mm");
        	} else if (today.add(1, 'days').isSame(dateMoment, 'day')) {
        		return "morgen um\n" + $filter('date')(dateString, "HH:mm");
        	} else {
        		return $filter('date')(dateString, "EEE, d.M. 'um'") + "\n" + $filter('date')(dateString, "HH:mm");
        	}
        }
        
        function getPriceDisplayString(treatment) {
            var priceCalculated = "";
            if (treatment.fixedPrice != null) {
                priceCalculated += $filter('currency')(treatment.fixedPrice);
            }
            else if (treatment.minPrice != null && treatment.maxPrice == null) {
                priceCalculated += $filter('translate')('from') + $filter('currency')(treatment.minPrice);
            }
            else if (treatment.minPrice == null && treatment.maxPrice != null) {
                priceCalculated += $filter('translate')('to') + $filter('currency')(treatment.maxPrice);
            }
            else if (treatment.minPrice != null && treatment.maxPrice != null) {
                priceCalculated += treatment.currency + ' ' + treatment.minPrice + ' - ' + treatment.maxPrice;
            }
            return priceCalculated;
        }
        
        function mapClick() {
        	ctrl.clickedOnMarker = false;
        	$scope.removeCssClassFromMapMarkerWithPracticeId('custom-marker-active', '#marker-mobile-id-' + ctrl.currentPracticeMobileMap.id);
        }
        
        function changeBusinessCard(event, id) {
	        	var currentPractice;
	        	
	        	$scope.removeCssClassFromMapMarkerWithPracticeId('custom-marker-active', '#marker-mobile-id-' + ctrl.currentPracticeMobileMap.id);
	        	
	        	event.stopPropagation();
	        	
	        	for (var i = 0; i < ctrl.practices.length; i++) {
	        		currentPractice = ctrl.practices[i];
	        		if(currentPractice.id == parseInt(id)) {
	        			ctrl.currentPracticeMobileMap = currentPractice;
	        		}
	        	}
	        	ctrl.clickedOnMarker = true;
	        	$scope.addCssClassToMapMarkerWithPracticeId('custom-marker-active', '#marker-mobile-id-' + id);
        }
        
        function buildMapDataMarkers(practices, isDesktop) {
            var mapDataMarkers = [];
            var practicesLength = practices.length;
            var currentPractice;
            var currentMarker;
            var currentCoordinates;
            var additionalClass;
            var funcStringInjection = "";
            var markerId = "";
            
            for (var i = 0; i < practicesLength; i++) {
                currentPractice = practices[i];
                currentMarker = { "location": [] };
                currentCoordinates = currentPractice.coordinates.split(",");
                
                currentMarker.location.push(Number(currentCoordinates[0]));
                currentMarker.location.push(Number(currentCoordinates[1]));
                currentMarker.extraClass = "";
                additionalClass = !isTheMapMarkerGrey(currentPractice) || currentPractice.useExternalCalendar ? "" : " custom-marker-grey";
               
                if(isDesktop) {
                	funcStringInjection="onclick=clickOnMarkerOpenThenScroll('";
                	markerId = "marker-";
                } else {
                	funcStringInjection="onclick=mobileMapFunction(event,'";
                	markerId = "marker-mobile-id-";
                }
                currentMarker.popupHTML = "<a href='javascript:void(0);'><span title='" + currentPractice.name + "' id='" + markerId + currentPractice.id + "' class='map-marker " + additionalClass + "' " + funcStringInjection + currentPractice.id+"') ><span class='icon-marker'></span></span></a>";
                mapDataMarkers.push(currentMarker);
            }
            return mapDataMarkers;
        }
        
        function filterTreatmentTimeSlots (practice) {
            var matchingTreatments = $filter('filter')(practice.groupedTreatments, ctrl.filterTreatment);

            var practitionerIds = matchingTreatments.reduce(function(total, treatment) {
                return total.concat(treatment.practitionerIds);
            }, []);
            var uniquePractitionerIds = new Set();
            practitionerIds.forEach(function(element) {
                uniquePractitionerIds.add(element);
            });

            return function (timeSlot, index, array) {
                return timeSlot.practitionerIds.some(function(id) {
                    return uniquePractitionerIds.has(id);
                });
            };
        }

        // TODO move values into new, dedicated fields on the practice
        ctrl.earliestBookingTimes = {
            '200052': 48, // practice "Ort Hirzel"
            '200051': 48, // practice "Ort Bülach"
            '30675': 20, // practice "Diener"
            '31581': 24, // practice "Ruffo"
            '202229': 48 // practice "Smile&Co"
        };
        function getEarliestBookingTime(practice) {
            var minimumHoursBetweenNowAndBookableAppointment = ctrl.earliestBookingTimes[practice.id] ?
                                                                  ctrl.earliestBookingTimes[practice.id] : 2;
            return moment().add(minimumHoursBetweenNowAndBookableAppointment, 'hours');
        }

        function sliceTimeSlots (practice) {
            var duration = 120; //max treatment
            var earliestBookingTime = getEarliestBookingTime(practice);

            return function (timeSlot) {
                var treatmentIds = [];
                practice.filteredTreatments.forEach(function(element) {
                    if (element.practitionerIds.some(function(id) { return timeSlot.practitionerIds.indexOf(id) !== -1; })) {
                        treatmentIds.push(element.originalIds[0]);
                        if(element.duration < duration) {
                        	duration = element.duration;
                        }
                    }
                });

                var startMoment = moment(timeSlot.startTime);
                var endMoment = moment(timeSlot.endTime);

                var slices = [];
                while (startMoment.clone().add(duration, 'm').isSameOrBefore(endMoment)) {
                	if (startMoment.isSameOrAfter(earliestBookingTime)) {
                        slices.push({ practitionerIds: timeSlot.practitionerIds, treatmentIds: treatmentIds, startTime: startMoment.toDate().toISOString() });
                	}
                    startMoment.add(duration, 'm');
                }
                return slices;
            };
        }
        
        function updateFilterDate(filterDateString) {
            var now = moment();
            var filterDateMoment = filterDateString ? moment(filterDateString, 'DD.MM.YYYY') : now;
            var isToday = now.isSame(filterDateMoment, 'day');
            ctrl.filterDate = isToday ? now.toDate() : filterDateMoment.toDate(); // if it is today, we want to keep the time (i.e. hours and minutes)
            ctrl.updateFilteredTimeSlots(ctrl.practices);
            return isToday ? null : ctrl.filterDate;
        }

        function isAfterFilterDate(timeSlot) {
            return new Date(timeSlot.startTime) > ctrl.filterDate;
        }
        
      
    }

    businesscardsController.$inject = ['appointmentService','dentistService', '$translate', '$filter', '$scope', '$stateParams', '$state', '$location', '$rootScope', '$anchorScroll'];

})(window.angular);

(function (angular) {
    'use strict';

    angular.module("dentist").directive('navigationSelectWrapper', function() {
    return {
        link: function($scope, element, attrs) {
            // Trigger when number of children changes,
            // including by directives like ng-repeat
            // optimization: this could also be done with event broadcasting and catching (https://stackoverflow.com/questions/16935766/run-jquery-code-after-angularjs-completes-rendering-html)
            var watch = $scope.$watch(function() {
                return element.children().length;
            }, function() {
                // Wait for templates to render
                $scope.$evalAsync(function() {
                    // Finally, directives are evaluated
                    // and templates are renderer here
//                    var children = element.children();
//                    console.log(children);
                    initNavigationSelect();
                    initCustomForms();
                });
            });
        },
    };
});

})(window.angular);

(function (angular) {
    'use strict';

    angular.module("dentist").directive('businesscardTooltipWrapper', ['$timeout', function($timeout) {
    return {
        link: function($scope, element, attrs) {
        	$timeout(function () { // We might need this timeout to be sure its run after DOM render.
        	    element.tooltip({ placement: "top" });
            }, 0, false);
        },
    };
}]);

})(window.angular);
(function(){angular.module('dentist').run(['$templateCache', function($templateCache) {$templateCache.put('templates/businesscards.html','<!-- form block --><div id="first-element-nomap" class="form-block" ng-show="!ctrl.mapView"><div class="container"><!-- serch form --><form action="#" class="search-form"><div class="form-group"><div id="open-close-menu-switch" class="btn-group" style="width:100%"><select class="form-control dropdown-toggle" data-toggle="dropdown" ng-click="ctrl.hideNewDropdown();" ng-model="ctrl.filterTreatment" ng-options="treat | translate for treat in ctrl.treatmentOptions" ng-change="ctrl.nameOfTreatmentDropdownSync();ctrl.updateFilteredTreatments(ctrl.practices); ctrl.updateFilteredTimeSlots(ctrl.practices);"><option value="">Behandlung w\xE4hlen:</option></select><ul id="treatment-popup-dropdown" class="dropdown-menu dropdown-menu-temporary"><li><a href="javascript:void(0);" ng-click="ctrl.hideNewDropdown();">Behandlung w\xE4hlen:</a></li><li ng-repeat-start="treat in ctrl.treatmentOptions" ng-show="ctrl.treatmentOptionsDividerIndices.indexOf($index) >= 0" role="separator" class="divider"></li><li ng-repeat-end><a href="javascript:void(0);" data-original="{{treat}}" ng-click="ctrl.setTreatmentCallFunctions($event);" ng-bind="treat | translate"></a></li></ul></div></div><div class="form-group"><select class="form-control" ng-model="ctrl.region" ng-options="region | translate for region in ctrl.regionOptions" ng-change="ctrl.updateRegionState();"><!-- \t          <option value="">Stadt w\xE4hlen:</option> --></select></div><div class="form-group"><div class="input-group date" date-picker><input ng-model="filterDate" ng-change="filterDate = ctrl.updateFilterDate(filterDate)" class="hiddendiv" style="padding: 0"> <span ng-bind="\'Termine ab: \' + (filterDate ? (filterDate | date:\'EEE, dd.MM.\') : \'heute\')" class="btn form-control dateleft customdate"></span><div class="input-group-addon dateright"><span class="fa fa-calendar"></span></div></div></div><!-- <div class="form-group last">\n            <select>\n              <option>Sprachen</option>\n              <option>Sprachen</option>\n              <option>Sprachen</option>\n              <option>Sprachen</option>\n            </select>\n          </div>\n          <button type="submit"><i class="fa fa-search hidden-xs"></i><span class="hidden-sm hidden-md hidden-lg">Suchen</span></button>\n        <div class="visible-xs">\n\t  \t\t<a ng-show="!ctrl.mapView" class="btn btn-success btn-map-list-view" ng-click="ctrl.changeMobileMapView()">Map View</a>\n\t   \t</div>\n\t   \t--></form></div></div><div id="map-anchor-top-mobile" class="mobileShow" style="left: -100%; position: absolute" ng-click="ctrl.closeBusinessCard()"><!--\n\t   \t<a ng-show="ctrl.mapView" class="btn btn-success btn-map-view" ng-click="ctrl.changeMobileMapView()">Back to list</a>\n\t   --><div class="col-xs-12"><div class="map map-view js-map-mobile" data-markers="{}" data-styles="json/styles.json" data-top-block="map-anchor-top-mobile" data-bottom-block="map-anchor-bottom" ng-click="ctrl.mapClick()"><div class="map-canvas"></div></div></div><div class="container mini-bcard-container" ng-show="ctrl.clickedOnMarker"><div style="padding: 10px 10px; margin-bottom: 0; border-radius: 25px; background: rgba(243, 243, 243, 0.81)"><div class="row"><div class="head mini-bcard-head"><a ng-click="ctrl.goToProfileMiniBcard()" ng-href="{{ctrl.currentPracticeMobileMap.location + \'/\' + ctrl.currentPracticeMobileMap.profilePath}}"><custom class="mini-bcard-title"><strong ng-bind="ctrl.currentPracticeMobileMap.name"></strong></custom></a></div></div><br><div class="row mini-bcard-2nd-row"><div class="col-xs-4"><a ng-click="ctrl.goToProfileMiniBcard()" ng-href="{{ctrl.currentPracticeMobileMap.location + \'/\' + ctrl.currentPracticeMobileMap.profilePath}}"><div class="img-block"><div class="hold"><div class="img-wrap"><img class="mini-bcard-2nd-row-img" ng-src="https://static.zumedo.ch/resources/{{ctrl.currentPracticeMobileMap.id}}/img_businesscard_1.jpg" alt="{{ctrl.currentPracticeMobileMap.name}}"></div></div></div></a></div><div class="col-xs-8"><div ng-repeat="treatment in ctrl.currentPracticeMobileMap.filteredTreatments | orderBy:\'noTimeSlotsAvailable\' | limitTo:2"><div class="row mini-bcard-treatment-row"><custom ng-bind="treatment.customName != null && treatment.customName != \'\' ? treatment.customName : treatment.type | translate"></custom>&nbsp;<custom ng-show="!treatment.fixedPriceReduced" ng-bind="ctrl.getPriceDisplayString(treatment)"></custom><custom ng-show="treatment.fixedPriceReduced" ng-bind="ctrl.getPriceDisplayString(treatment)" style="text-decoration:line-through; font-weight:300"></custom><br><custom ng-show="treatment.fixedPriceReduced" ng-bind="treatment.reductionCoupon.description + \': \' + (treatment.fixedPriceReduced | currency)"></custom></div><br ng-show="$first"></div><custom ng-repeat="treatment in ctrl.currentPracticeMobileMap.filteredTreatments | orderBy:\'noTimeSlotsAvailable\' | limitTo:1" ng-show="treatment.noTimeSlotsAvailable" class="mini-bcard-treatment-row"><br>&nbsp;&nbsp;&nbsp;&nbsp;<a class="btn mobileShow mini-bcard-show-more-less-btn" href="javascript:void(0);"> Alle Termine vergeben</a></custom><div style="padding: 20px 0px 0px 5px; margin-bottom: 0px" class="personel-block"><div class="details"><div class="schedule"><div class="row-time"><div ng-show="ctrl.currentPracticeMobileMap.isLoading" style="width:100%"><img src="img/loader.gif"></div><div style="margin: 0px" class="col-xs-6 mini-bcard-freetime-col colm zum-animate swap-animation" ng-repeat="freeTime in ctrl.currentPracticeMobileMap.filteredTimeSlots | limitTo:ctrl.mobileMapSlotsCounter:ctrl.currentPracticeMobileMap.filteredTimeSlotPagingIndex" ng-click="ctrl.clickOnTimeslotVariant(ctrl.currentPracticeMobileMap, freeTime.$key, freeTime[0].treatmentIds[0], false);"><a class="time-only mobileShow" ng-click="ctrl.goToProfileMiniBcard()" ng-href="{{ctrl.isSpecialFakeTimeSlotCase(ctrl.currentPracticeMobileMap) ? \'\' : \'/platformBooking/#/?practiceId=\' + ctrl.currentPracticeMobileMap.id + \'&treatmentId=\' + freeTime[0].treatmentIds[0] + \'&date=\' + freeTime.$key}}"><button class="btn mini-bcard-freetime-btn"><span class="title mini-bcard-freetime-btn-title">{{ctrl.displayNiceDateString(freeTime.$key)}}</span></button></a></div></div></div></div></div><div class="row"><div class="col-xs-6 text-center"><a class="btn mobileShow mini-bcard-show-more-less-btn" ng-show="ctrl.currentPracticeMobileMap.filteredTimeSlots.length > ctrl.mobileMapSlotsCounter" ng-click="ctrl.mobileMapSlotsCounter = ctrl.mobileMapSlotsCounter + 2" style="padding-left:0px">Mehr&nbsp;<i class="fa fa-angle-down"></i></a></div><div class="col-xs-6 text-center"><a class="btn mobileShow mini-bcard-show-more-less-btn" ng-show="ctrl.mobileMapSlotsCounter > 2 && (ctrl.currentPracticeMobileMap.filteredTimeSlots.length > 2)" ng-click="ctrl.mobileMapSlotsCounter = ctrl.mobileMapSlotsCounter - 2">Weniger&nbsp;<i class="fa fa-angle-up"></i></a></div></div></div></div></div></div></div><div id="second-element-nomap" class="two-col" ng-show="!ctrl.mapView"><div class="container businesscards"><div class="row"><div class="col-sm-8"><div class="hidden-xs" style="margin-top:15px"></div><div class="link-block"><h1 class="title" ng-bind="ctrl.pageH1" ng-show="ctrl.pageH1"></h1><!--\n\t             <div class="row">\n\t             \t<div class="col-xs-7">\n\t             \t\t <span class="title">Sortieren nach:</span>\n\t              \t</div>\n\t              \t<div class="col-xs-5">\n\t              \t\t\t<table style="margin-left:3px;margin-right:3px;background-color: white;border-radius: 50px; width: 140px; height:30px; margin-bottom: 10px;">\n\t              \t\t\t<tr>\n\t              \t\t\t\t<td class="table-cell" style="padding-bottom:15px; padding-left: 10px;width:30px;">\n\t              \t\t\t\t\t<i class="fa fa-list" aria-hidden="true"></i>\n\t              \t\t\t\t</td>\n\t              \t\t\t\t<td class="table-cell" style="padding-bottom:10px; width:65px;">\n\t\t              \t\t\t\t<label class="switch">\n\n\t\t\t\t\t\t\t\t  \t<input type="checkbox">\n\t\t\t\t\t\t\t\t  \t<span class="slider round"></span>\n\t\t\t\t\t\t\t\t\t</label>\n\t              \t\t\t\t</td>\n\t              \t\t\t\t<td class="table-cell" style="padding-bottom:15px;">\n\t              \t\t\t\t\t<i class="fa fa-globe" aria-hidden="true"></i>\n\t              \t\t\t\t</td>\n\t              \t\t\t</tr>\n\t              \t\t\t</table>\n\t              \t</div>\n\t              </div>\n\t          --><!-- link tags --><ul class="link-list" navigation-select-wrapper><li ng-repeat="sort in ctrl.sortOptions" id="link-list-{{$index}}" ng-class="ctrl.currentSorting.name === sort.name ? \'nav-active active\' : \'\'" ng-click="ctrl.currentSorting = sort"><a data-href="link-list-{{$index}}">{{sort.name}}</a></li><!--                 <li ng-class="ctrl.currentSorting.name === sort.name ? \'active\' : \'\'" ng-repeat="sort in ctrl.sortOptions"><a ng-click="ctrl.currentSorting = sort">{{sort.name}}</a></li> --></ul></div><!-- NEXT --><div ng-repeat="practice in (filteredPractices = (ctrl.practices | filter:ctrl.filterTreatment)) | orderBy:ctrl.orderBySpecialLocationRules | limitTo:ctrl.practicesCount"><!-- old : ctrl.currentSorting.getter new: ctrl.orderBySpecialLocationRules --><div ng-show="$index != 0 && (filteredPractices[$index - 1].location != filteredPractices[$index].location) && !(ctrl.region == \'zuerich\' && filteredPractices[$index].location == \'winterthur\')" style="padding-bottom: 20px; text-align: center"><hr style="border-top: 3px solid black"><strong class="category" ng-bind="filteredPractices[$index].location | translate" style="font-size: 25px"></strong></div><div ng-show="!$last || $first || filteredPractices.length<=ctrl.practicesCount" id="{{practice.id}}" class="personel-block" data-href="{{practice.location + \'/\' + practice.profilePath}}" ng-mouseover="addCssClassToMapMarkerWithPracticeId(\'custom-marker-active\', \'#marker-\'+practice.id)" ng-mouseout="removeCssClassFromMapMarkerWithPracticeId(\'custom-marker-active\', \'#marker-\'+practice.id)"><div class="head"><a ng-click="ctrl.profileViewGA(practice)" ng-href="{{practice.location + \'/\' + practice.profilePath}}"><h2 class="title"><strong ng-bind="practice.name.substring(0, practice.name.indexOf(\' \'))">Zahnarztpraxis</strong> {{practice.name.substring(practice.name.indexOf(\' \') + 1)}}</h2></a><ul class="points"><div style="padding-bottom: 12px; margin-top: -5px"><table style="width:100%" class="mobileHide" ng-show="practice.numberOfReviews"><tr ng-if="practice.averageRating == 0"><td class="toright"><a ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=testimonialblock"><span class="num" ng-bind="practice.numberOfReviews"></span>&nbsp;&nbsp;<strong style="word-spacing: 500px" ng-pluralize count="practice.numberOfReviews" when="{1: \'Besuchserlebnis anzeigen\', \'other\': \'Besuchserlebnisse anzeigen\'}">Besuchserlebnisse anzeigen</strong></a>&nbsp;<a businesscard-tooltip-wrapper href="javascript:void(0);" title="Bei Zumedo wird der erlebte Besuch bewertet. Nur Personen, die \xFCber Zumedo gebucht haben und eine Behandlung wahrgenommen haben, k\xF6nnen ein Besuchserlebnis abgeben."><i class="fa fa-info-circle" style="color:#27a9e1"></i></a></td></tr><tr ng-if="practice.averageRating > 0"><td class="toright"></td><td class="toright"><a class="no-text-decoration-a-tag" ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=testimonialblock"><custom ng-bind="practice.ratingText" style="font-weight: 900; font-size:16px; margin-right: 0px; padding-right: 0px"></custom></a><br><a ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=testimonialblock"><custom ng-bind="practice.numberOfReviews + \' Besuchserlebnisse\'" style="font-weight: 400; font-size:12px; margin-right: 0px; padding-right: 4px"></custom></a></td><td><a class="no-text-decoration-a-tag" businesscard-tooltip-wrapper ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=testimonialblock" title="Besuchserlebnis von 10 m\xF6glichen Punkten"><span class="num businesscards-ratings-circle-desktop" ng-bind="(practice.averageRating | number: 1).replace(\'.0\',\'\')"></span></a></td></tr></table></div><!-- \t                  <table style="width:100%" class="mobileHide"> --><!-- \t                    <tr> --><!-- \t                      <td class="toright"><strong>Taxpunktwert</strong></td> --><!-- \t                      <td class="num" ng-bind="practice.taxpunktwert"></td> --><!-- \t                      <td><a businesscard-tooltip-wrapper href="javascript:void(0);" title="Der Taxpunktwert gibt eine Indikation \xFCber die Zahnarzt-Preise - je h\xF6her der Wert, desto h\xF6her die Preise. Er widerspiegelt u.a. die Betriebskosten der Praxis (Miete, Einrichtung, L\xF6hne, etc.), die Fortbildung des Praktizierenden und die Anspr\xFCche des Patienten. * Mit einem Stern markierte Zahnarztpraxen verwenden den alten Zahnarzttarif, welcher auf dem Profil ersichtlich ist. Um einen Vergleich zu erm\xF6glichen, wurde der Taxpunktwert von Zumedo umgerechnet."><i class="fa fa-info-circle" style="color:#27a9e1;"></i></a></td> --><!-- \t                    </tr> --><!-- \t                  </table> --><li class="mobileShow" ng-show="practice.numberOfReviews"><table style="margin: 0px; padding: 0px"><tr ng-if="practice.averageRating > 0"><td><a class="no-text-decoration-a-tag" ng-if="practice.averageRating > 0" businesscard-tooltip-wrapper href="javascript:void(0);" title="Besuchserlebnis von 10 m\xF6glichen Punkten"><span class="num businesscards-ratings-circle-mobile" ng-bind="(practice.averageRating | number: 1).replace(\'.0\',\'\')"></span> </a>&nbsp;</td><td><a class="no-text-decoration-a-tag" ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=testimonialblock"><custom ng-bind="practice.ratingText" style="font-weight: 900; font-size:16px; margin-right: 0px; padding-right: 0px"></custom></a><br><a ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=testimonialblock"><custom ng-bind="practice.numberOfReviews + \' Besuchserlebnisse\'" style="font-weight: 400; font-size:12px; margin-right: 0px; padding-right: 4px"></custom></a></td></tr></table><span ng-if="practice.averageRating == 0" class="num" ng-bind="practice.numberOfReviews + \'  \'"></span> <strong ng-if="practice.averageRating == 0" ng-pluralize count="practice.numberOfReviews" when="{1: \'Besuchserlebnis anzeigen\', \'other\': \'Besuchserlebnisse anzeigen\'}"></strong> <a ng-if="practice.averageRating == 0" businesscard-tooltip-wrapper href="javascript:void(0);" title="Bei Zumedo wird der erlebte Besuch bewertet. Nur Personen, die \xFCber Zumedo gebucht haben und eine Behandlung wahrgenommen haben, k\xF6nnen ein Besuchserlebnis abgeben."><i class="fa fa-info-circle" style="color:#27a9e1"></i></a></li><!-- <li class="mobileShow"><strong>Taxpunktwert</strong><span class="num" ng-bind="practice.taxpunktwert">4</span>&nbsp;&nbsp;&nbsp;&nbsp;<a businesscard-tooltip-wrapper href="javascript:void(0);" title="Der Taxpunktwert gibt eine Indikation \xFCber die Zahnarzt-Preise - je h\xF6her der Wert, desto h\xF6her die Preise. Er widerspiegelt u.a. die Betriebskosten der Praxis (Miete, Einrichtung, L\xF6hne, etc.), die Fortbildung des Praktizierenden und die Anspr\xFCche des Patienten."><i class="fa fa-info-circle" style="color:#27a9e1;"></i></a></li> --><!--<li><strong>Besuchererlebnis</strong><span class="num">8.7</span></li>--></ul></div><address class="adr"><strong>Standort: </strong>{{practice.locationDescription}}</address><div class="details"><a ng-click="ctrl.profileViewGA(practice)" ng-href="{{practice.location + \'/\' + practice.profilePath}}?"><div class="img-block"><div class="hold"><div class="img-wrap"><img ng-src="https://static.zumedo.ch/resources/{{practice.id}}/img_businesscard_1.jpg" alt="{{practice.name}}" width="164" height="164"></div></div><div class="hold"><div class="img-wrap" ng-style=\'{"background-image": "url(\\"https://static.zumedo.ch/resources/{{practice.id}}/img_businesscard_2.jpg\\")"}\'><img ng-src="https://static.zumedo.ch/resources/{{practice.id}}/img_businesscard_2.jpg" class="hidden-xs" alt="{{practice.name}}" width="120" height="78"></div><div class="img-wrap" ng-style=\'{"background-image": "url(\\"https://static.zumedo.ch/resources/{{practice.id}}/img_businesscard_3.jpg\\")"}\'><img ng-src="https://static.zumedo.ch/resources/{{practice.id}}/img_businesscard_3.jpg" class="hidden-xs" alt="{{practice.name}}" width="120" height="78"></div></div></div></a><div class="schedule"><div class="row-time"><div class="colm" ng-repeat="treatment in practice.filteredTreatments | orderBy:\'noTimeSlotsAvailable\' | limitTo:2" ng-class="treatment.noTimeSlotsAvailable ? \'greyed-out\' : \'\' " ng-click="ctrl.clickOnProduct(treatment, practice);"><a class="time-wrap mobileHide" ng-href="{{ treatment.noTimeSlotsAvailable ? \'\' : practice.location + \'/\' + practice.profilePath + \'?treatmentId=\' + treatment.originalIds[0] + \'&scroll=bottom-scroll\' }}"><div class="wrap"><span class="title" ng-bind="treatment.customName != null && treatment.customName != \'\' ? treatment.customName : treatment.type | translate">Dentalhygiene</span> <span ng-class="treatment.fixedPriceReduced ? \'strike\' : \'\'" ng-bind="ctrl.getPriceDisplayString(treatment)">CHF 128.-</span> <span class="title" ng-show="treatment.fixedPriceReduced" ng-bind="treatment.reductionCoupon.description + \': \' + (treatment.fixedPriceReduced | currency)"></span> <span class="title" ng-show="treatment.noTimeSlotsAvailable">Alle Termine vergeben</span></div></a><a class="time-wrap mobileShow" ng-href="{{ treatment.noTimeSlotsAvailable ? \'\' : \'/platformBooking/#/?practiceId=\' + practice.id + \'&treatmentId=\' + treatment.originalIds[0] }}"><div class="wrap"><span class="title" ng-bind="treatment.customName != null && treatment.customName != \'\' ? treatment.customName : treatment.type | translate">Dentalhygiene</span> <span ng-class="treatment.fixedPriceReduced ? \'strike\' : \'\'" ng-bind="ctrl.getPriceDisplayString(treatment)">CHF 128.-</span> <span class="title" ng-show="treatment.fixedPriceReduced" ng-bind="treatment.reductionCoupon.description + \': \' + (treatment.fixedPriceReduced | currency)"></span> <span class="title" ng-show="treatment.noTimeSlotsAvailable">Alle Termine vergeben</span></div></a></div></div><a ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=bottom-scroll" class="btn hidden-xs">Alle Behandlungen</a></div><div class="schedule"><a class="btn time-only hidden-xs" ng-show="practice.filteredTimeSlotPagingIndex > 0" ng-click="practice.filteredTimeSlotPagingIndex = practice.filteredTimeSlotPagingIndex - 4"><i class="fa fa-angle-up"></i></a><div class="row-time"><div ng-show="practice.isLoading" class="text-center" style="width: 100%;z-index:999999 !important"><img src="img/loader.gif"></div><div class="colm zum-animate swap-animation" ng-repeat="freeTime in practice.filteredTimeSlots | limitTo:practice.filteredTimeSlotsDisplayCount:practice.filteredTimeSlotPagingIndex" ng-click="ctrl.clickOnTimeslotVariant(practice, freeTime.$key, freeTime[0].treatmentIds[0], true)"><a class="time-wrap time-only mobileHide" ng-href="{{ctrl.isSpecialFakeTimeSlotCase(practice) ? \'\' : practice.location + \'/\' + practice.profilePath + \'?treatmentId=\' + freeTime[0].treatmentIds[0] + \'&date=\' + freeTime.$key + \'&scroll=bottom-scroll\'}}"><span class="wrap"><span class="title">{{ctrl.displayNiceDateString(freeTime.$key)}}</span></span> </a><a class="time-wrap time-only mobileShow" ng-href="{{ctrl.isSpecialFakeTimeSlotCase(practice) ? \'\' : \'/platformBooking/#/?practiceId=\' + practice.id + \'&treatmentId=\' + freeTime[0].treatmentIds[0] + \'&date=\' + freeTime.$key}}"><span class="wrap"><span class="title">{{ctrl.displayNiceDateString(freeTime.$key)}}</span></span></a></div><!-- \t                <div class="colm" ng-show="(practice.filteredTimeSlots.length == 0) && (ctrl.filterTreatment != undefined)"> --></div><a class="btn time-only hidden-xs" ng-show="practice.filteredTimeSlots.length > (practice.filteredTimeSlotPagingIndex + 4) && practice.filteredTimeSlotPagingIndex > 0" ng-click="practice.filteredTimeSlotPagingIndex = practice.filteredTimeSlotPagingIndex + 4"><i class="fa fa-angle-down"></i></a> <a class="btn hidden-xs" ng-show="practice.filteredTimeSlots.length > (practice.filteredTimeSlotPagingIndex + 4) && practice.filteredTimeSlotPagingIndex == 0" ng-click="practice.filteredTimeSlotPagingIndex = practice.filteredTimeSlotPagingIndex + 4">N\xE4chste Termine <i class="fa fa-angle-down"></i></a> <a class="btn mobileShow show-more" ng-show="practice.filteredTimeSlots.length > practice.filteredTimeSlotsDisplayCount" ng-click="practice.filteredTimeSlotsDisplayCount = practice.filteredTimeSlotsDisplayCount + 4">N\xE4chste Termine<i class="fa fa-angle-down"></i></a> <a class="btn mobileShow show-more" ng-show="practice.filteredTimeSlotsDisplayCount > 4" ng-click="practice.filteredTimeSlotsDisplayCount = practice.filteredTimeSlotsDisplayCount - 4">weniger Termine<i class="fa fa-angle-up"></i></a></div></div><a class="foot" ng-href="{{practice.location + \'/\' + practice.profilePath}}" ng-bind="\'Profil ansehen\' + (practice.filteredTimeSlots.length > 0 ? \' & Termin buchen\' : \'\')"></a></div><div class="nofade-background" ng-show="$last && !$first && filteredPractices.length>ctrl.practicesCount" ng-click="ctrl.showMore()"><div class="last-div-in-bcards-with-button"><div id="{{practice.id}}" class="personel-block" data-href="{{practice.location + \'/\' + practice.profilePath}}" ng-mouseover="addCssClassToMapMarkerWithPracticeId(\'custom-marker-active\', \'#marker-\'+practice.id)" ng-mouseout="removeCssClassFromMapMarkerWithPracticeId(\'custom-marker-active\', \'#marker-\'+practice.id)"><div class="head"><a href="javascript:void(0);"><h2 class="title"><strong ng-bind="practice.name.substring(0, practice.name.indexOf(\' \'))">Zahnarztpraxis</strong> {{practice.name.substring(practice.name.indexOf(\' \') + 1)}}</h2></a><ul class="points"><div style="padding-bottom: 12px; margin-top: -5px"><table style="width:100%" class="mobileHide" ng-show="practice.numberOfReviews"><tr ng-if="practice.averageRating == 0"><td class="toright"><a ng-href="javascript:void(0);"><span class="num" ng-bind="practice.numberOfReviews"></span>&nbsp;&nbsp;<strong style="word-spacing: 500px" ng-pluralize count="practice.numberOfReviews" when="{1: \'Besuchserlebnis anzeigen\', \'other\': \'Besuchserlebnisse anzeigen\'}">Besuchserlebnisse anzeigen</strong></a>&nbsp;<a businesscard-tooltip-wrapper href="javascript:void(0);" title="Bei Zumedo wird der erlebte Besuch bewertet. Nur Personen, die \xFCber Zumedo gebucht haben und eine Behandlung wahrgenommen haben, k\xF6nnen ein Besuchserlebnis abgeben."><i class="fa fa-info-circle" style="color:#27a9e1"></i></a></td></tr><tr ng-if="practice.averageRating > 0"><td class="toright"></td><td class="toright"><a class="no-text-decoration-a-tag" ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=testimonialblock"><custom ng-bind="practice.ratingText" style="font-weight: 900; font-size:16px; margin-right: 0px; padding-right: 0px"></custom></a><br><a ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=testimonialblock"><custom ng-bind="practice.numberOfReviews + \' Besuchserlebnisse\'" style="font-weight: 400; font-size:12px; margin-right: 0px; padding-right: 4px"></custom></a></td><td><a class="no-text-decoration-a-tag" businesscard-tooltip-wrapper ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=testimonialblock" title="Besuchserlebnis von 10 m\xF6glichen Punkten"><span class="num businesscards-ratings-circle-desktop" ng-bind="(practice.averageRating | number: 1).replace(\'.0\',\'\')"></span></a></td></tr></table></div><!-- \t\t\t\t                  <table style="width:100%" class="mobileHide"> --><!-- \t\t\t\t                    <tr> --><!-- \t\t\t\t                      <td class="toright"><strong>Taxpunktwert</strong></td> --><!-- \t\t\t\t                      <td class="num" ng-bind="practice.taxpunktwert"></td> --><!-- \t\t\t\t                      <td><a businesscard-tooltip-wrapper href="javascript:void(0);" title="Der Taxpunktwert gibt eine Indikation \xFCber die Zahnarzt-Preise - je h\xF6her der Wert, desto h\xF6her die Preise. Er widerspiegelt u.a. die Betriebskosten der Praxis (Miete, Einrichtung, L\xF6hne, etc.), die Fortbildung des Praktizierenden und die Anspr\xFCche des Patienten. * Mit einem Stern markierte Zahnarztpraxen verwenden den alten Zahnarzttarif, welcher auf dem Profil ersichtlich ist. Um einen Vergleich zu erm\xF6glichen, wurde der Taxpunktwert von Zumedo umgerechnet."><i class="fa fa-info-circle" style="color:#27a9e1;"></i></a></td> --><!-- \t\t\t\t                    </tr> --><!-- \t\t\t\t                  </table> --><li class="mobileShow" ng-show="practice.numberOfReviews"><a class="no-text-decoration-a-tag" ng-href="javascript:void(0);"><table style="margin: 0px; padding: 0px"><tr ng-if="practice.averageRating > 0"><td><a class="no-text-decoration-a-tag" ng-if="practice.averageRating > 0" businesscard-tooltip-wrapper href="javascript:void(0);" title="Besuchserlebnis von 10 m\xF6glichen Punkten"><span class="num businesscards-ratings-circle-mobile" ng-bind="(practice.averageRating | number: 1).replace(\'.0\',\'\')"></span> </a>&nbsp;</td><td><a class="no-text-decoration-a-tag" ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=testimonialblock"><custom ng-bind="practice.ratingText" style="font-weight: 900; font-size:16px; margin-right: 0px; padding-right: 0px"></custom></a><br><a ng-href="{{practice.location + \'/\' + practice.profilePath}}?scroll=testimonialblock"><custom ng-bind="practice.numberOfReviews + \' Besuchserlebnisse\'" style="font-weight: 400; font-size:12px; margin-right: 0px; padding-right: 4px"></custom></a></td></tr></table><span ng-if="practice.averageRating == 0" class="num" ng-bind="practice.numberOfReviews + \'  \'"></span> <strong ng-if="practice.averageRating == 0" ng-pluralize count="practice.numberOfReviews" when="{1: \'Besuchserlebnis anzeigen\', \'other\': \'Besuchserlebnisse anzeigen\'}"></strong> </a><a ng-if="practice.averageRating == 0" businesscard-tooltip-wrapper href="javascript:void(0);" title="Bei Zumedo wird der erlebte Besuch bewertet. Nur Personen, die \xFCber Zumedo gebucht haben und eine Behandlung wahrgenommen haben, k\xF6nnen ein Besuchserlebnis abgeben."><i class="fa fa-info-circle" style="color:#27a9e1"></i></a></li><!-- <li class="mobileShow"><strong>Taxpunktwert</strong><span class="num" ng-bind="practice.taxpunktwert">4</span>&nbsp;&nbsp;&nbsp;&nbsp;<a businesscard-tooltip-wrapper href="javascript:void(0);" title="Der Taxpunktwert gibt eine Indikation \xFCber die Zahnarzt-Preise - je h\xF6her der Wert, desto h\xF6her die Preise. Er widerspiegelt u.a. die Betriebskosten der Praxis (Miete, Einrichtung, L\xF6hne, etc.), die Fortbildung des Praktizierenden und die Anspr\xFCche des Patienten."><i class="fa fa-info-circle" style="color:#27a9e1;"></i></a></li> --><!--<li><strong>Besuchererlebnis</strong><span class="num">8.7</span></li>--></ul></div><address class="adr"><strong>Standort: </strong>{{practice.locationDescription}}</address><div class="details"><a href="javascript:void(0);"><div class="img-block"><div class="hold"><div class="img-wrap"><img ng-src="https://static.zumedo.ch/resources/{{practice.id}}/img_businesscard_1.jpg" alt="{{practice.name}}" width="164" height="164"></div></div><div class="hold"><div class="img-wrap" ng-style=\'{"background-image": "url(\\"https://static.zumedo.ch/resources/{{practice.id}}/img_businesscard_2.jpg\\")"}\'><img ng-src="https://static.zumedo.ch/resources/{{practice.id}}/img_businesscard_2.jpg" class="hidden-xs" alt="{{practice.name}}" width="120" height="78"></div><div class="img-wrap" ng-style=\'{"background-image": "url(\\"https://static.zumedo.ch/resources/{{practice.id}}/img_businesscard_3.jpg\\")"}\'><img ng-src="https://static.zumedo.ch/resources/{{practice.id}}/img_businesscard_3.jpg" class="hidden-xs" alt="{{practice.name}}" width="120" height="78"></div></div></div></a><div class="schedule"><div class="row-time"><div class="colm" ng-repeat="treatment in practice.filteredTreatments | orderBy:\'noTimeSlotsAvailable\' | limitTo:2" ng-class="treatment.noTimeSlotsAvailable ? \'greyed-out\' : \'\' "><a class="time-wrap mobileHide" href="javascript:void(0);"><div class="wrap"><span class="title" ng-bind="treatment.customName != null && treatment.customName != \'\' ? treatment.customName : treatment.type | translate">Dentalhygiene</span> <span ng-class="treatment.fixedPriceReduced ? \'strike\' : \'\'" ng-bind="ctrl.getPriceDisplayString(treatment)">CHF 128.-</span> <span class="title" ng-show="treatment.fixedPriceReduced" ng-bind="treatment.reductionCoupon.description + \': \' + (treatment.fixedPriceReduced | currency)"></span> <span class="title" ng-show="treatment.noTimeSlotsAvailable">Alle Termine vergeben</span></div></a><a class="time-wrap mobileShow" href="javascript:void(0);"><div class="wrap"><span class="title" ng-bind="treatment.customName != null && treatment.customName != \'\' ? treatment.customName : treatment.type | translate">Dentalhygiene</span> <span ng-class="treatment.fixedPriceReduced ? \'strike\' : \'\'" ng-bind="ctrl.getPriceDisplayString(treatment)">CHF 128.-</span> <span class="title" ng-show="treatment.fixedPriceReduced" ng-bind="treatment.reductionCoupon.description + \': \' + (treatment.fixedPriceReduced | currency)"></span> <span class="title" ng-show="treatment.noTimeSlotsAvailable">Alle Termine vergeben</span></div></a></div></div><a href="javascript:void(0);" class="btn hidden-xs">Alle Behandlungen</a></div><div class="schedule"><a class="btn time-only hidden-xs" ng-show="practice.filteredTimeSlotPagingIndex > 0" href="javascript:void(0);"><i class="fa fa-angle-up"></i></a><div class="row-time"><div class="colm zum-animate swap-animation" ng-repeat="freeTime in practice.filteredTimeSlots | limitTo:practice.filteredTimeSlotsDisplayCount:practice.filteredTimeSlotPagingIndex"><a class="time-wrap time-only mobileHide" href="javascript:void(0);"><span class="wrap"><span class="title">{{ctrl.displayNiceDateString(freeTime.$key)}}</span></span> </a><a class="time-wrap time-only mobileShow" href="javascript:void(0);"><span class="wrap"><span class="title">{{ctrl.displayNiceDateString(freeTime.$key)}}</span></span></a></div></div></div></div><a class="foot" href="javascript:void(0);" ng-bind="\'Profil ansehen\' + (practice.filteredTimeSlots.length > 0 ? \' & Termin buchen\' : \'\')"></a></div></div><div class="text-center" style="width:100%"><button class="show-more-less-btn-bcards">Mehr anzeigen</button></div></div></div><!-- end of businesscards --></div><div class="col-sm-4 hidden-xs"><div id="map-anchor-top"><div class="map map-right-side js-map-fixed" data-markers="{}" data-styles="json/styles.json" data-top-block="map-anchor-top" data-bottom-block="map-anchor-bottom"><div class="map-canvas"></div></div></div></div></div></div></div><div id="mapswitch-location" style="position: relative"><div id="mapswitch" class="mobileShow map-list-switch-table js-fixed-block" data-bottom-block="mapswitch-location" ng-click="ctrl.changeMobileMapView()"><a ng-show="ctrl.mapView" class="btn btn-map-list-view"><i class="fa fa-list" aria-hidden="true"></i> </a><a ng-show="!ctrl.mapView" class="btn btn-map-view"><i class="fa fa-map-marker fa-2x" aria-hidden="true"></i></a></div></div><div id="descriptiontext" ng-show="!ctrl.mapView && ctrl.pageTextParagraph"><div class="container"><div class="col-md-8"><p class="description-paragraph" ng-bind="ctrl.pageTextParagraph.split(\'\\n\')[0]">Die <strong>Auswahl an Zahn\xE4rzten in Z\xFCrich</strong> ist sehr gross. Bei Zumedo findest Du <strong>handverlesene Zahn-Spezialisten</strong>, welche sich gerne Deiner Zahngesundheit annehmen. Mit den echten Besuchserlebnissen findest Du Deinen pr\xE4ferierten Praktizierenden und buchst \xFCber die Auswahl an freien Terminen Deinen optimalen Zeitslot gleich hier.</p><p class="description-paragraph" ng-show="secondParagraph = ctrl.pageTextParagraph.split(\'\\n\')[1]" ng-bind="secondParagraph">Hunderte Patienten haben \xFCber Zumedo Ihren pr\xE4ferierten Zahnarzttermin gefunden. Zumedo hilft Dir, Dich im Dschungel der Zahnarzttermine zurechtzufinden.</p></div></div></div>');
$templateCache.put('templates/detail.html','<script>$(document).ready(function () {\n\tvar nav = 0;\n\tif($(\'#bottom-scroll\').length>0)\n\t{\n\t\tnav = $(\'#bottom-scroll\').offset().top\n\t}\n    $(\'html, body\').animate({\n        scrollTop: nav\n    }, \'slow\');\n});</script><div class="forfooter details" ng-controller="detailController as ctrl"><!--         <div class="dropdown pull-right language"> --><!--             <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown"> --><!--                 Language --><!--                 <span class="caret"></span> --><!--             </button> --><!--             <ul class="dropdown-menu"> --><!--                 <li><a href="" ng-click="ctrl.changeLanguage(\'de\')"> German</a></li> --><!--                 <li><a href="" ng-click="ctrl.changeLanguage(\'en\')"> English</a></li> --><!--             </ul> --><!--         </div> --><div class="container"><div class="row" ng-cloak><div class="col-md-12"><div class="panel panel-login details"><div class="inner_block"><h4 ng-bind="\'ENTER\' | translate"></h4><div class="panel-body" ng-cloak><div class="row"><form id="login-form " novalidate="" ng-cloak name="RegisterForm" ng-submit="ctrl.Submit(RegisterForm)" role="form" style="display: block" ng-show="ctrl.showsubmit"><div class="form-group" ng-show="ctrl.loginSuccess==true && ctrl.showsubmit==true"><label><custom ng-bind="\'Hello\' | translate"></custom><custom ng-bind="ctrl.showMessage"></custom>-<custom ng-bind="\'Welcome\' | translate"><custom></custom></custom></label><div class="row"><div class="col-lg-4"><a ng-click="ctrl.SubmitLoggedinBooking()" class="btn btn-info btn-block">{{\'CONFIRM\' | translate}}<i class="fa fa-check"></i></a></div></div><label ng-bind="\'ChangeData\' | translate"></label></div><div class="row"><div class="col-md-4 col-md-offset-2 col-sm-5 col-sm-offset-1 col-xs-6"><div class="form-group"><label for="">{{\'Salutation\' | translate}}</label><select name="Salutation" ng-class="{ \'wrong_info\' : (RegisterForm.Salutation.$invalid && ctrl.RegSubmitted), \'\' :(RegisterForm.Salutation.$valid && ctrl.RegSubmitted)}" ng-model="ctrl.detail.salutation" class="form-control" placeholder="" required><option value="MR">{{\'Salutation_MR\' | translate}}</option><option value="MS">{{\'Salutation_MS\' | translate}}</option></select></div></div><div class="col-md-6 col-sm-2 col-xs-6"></div></div><div class="row"><div class="col-md-4 col-md-offset-2 col-sm-5 col-sm-offset-1 col-xs-6"><div class="form-group"><label for="">{{\'Fname\' | translate}}</label><input type="text" name="Fname" style="text-transform: capitalize" ng-maxlength="50" ng-pattern="/^[a-zA-Z\xE0\xE1\xE2\xE4\xE3\xE5\u0105\u010D\u0107\u0119\xE8\xE9\xEA\xEB\u0117\u012F\xEC\xED\xEE\xEF\u0142\u0144\xF2\xF3\xF4\xF6\xF5\xF8\xF9\xFA\xFB\xFC\u0173\u016B\xFF\xFD\u017C\u017A\xF1\xE7\u010D\u0161\u017E\xC0\xC1\xC2\xC4\xC3\xC5\u0104\u0106\u010C\u0116\u0118\xC8\xC9\xCA\xCB\xCC\xCD\xCE\xCF\u012E\u0141\u0143\xD2\xD3\xD4\xD6\xD5\xD8\xD9\xDA\xDB\xDC\u0172\u016A\u0178\xDD\u017B\u0179\xD1\xDF\xC7\u0152\xC6\u010C\u0160\u017D\u2202\xF0 ,.\'-]+$/u" ng-class="{ \'wrong_info\' : (RegisterForm.Fname.$invalid && ctrl.RegSubmitted), \'\' :(RegisterForm.Fname.$valid && ctrl.RegSubmitted)}" ng-model="ctrl.detail.firstname" class="form-control" placeholder="" required> <span ng-show="RegisterForm.Fname.$error.pattern" class="error-message-detail"><em>Bitte nur Buchstaben verwenden.</em></span> <span ng-show="RegisterForm.Fname.$error.maxlength" class="error-message-detail"><em>Bitte nicht mehr als 50 Zeichen verwenden.</em></span></div></div><div class="col-md-4 col-md-offset-0 col-sm-5 col-sm-offset-1 col-xs-6"><div class="form-group"><label for="">{{\'Lname\' | translate}}</label><input type="text" name="Lname" style="text-transform: capitalize" ng-maxlength="50" ng-pattern="/^[a-zA-Z\xE0\xE1\xE2\xE4\xE3\xE5\u0105\u010D\u0107\u0119\xE8\xE9\xEA\xEB\u0117\u012F\xEC\xED\xEE\xEF\u0142\u0144\xF2\xF3\xF4\xF6\xF5\xF8\xF9\xFA\xFB\xFC\u0173\u016B\xFF\xFD\u017C\u017A\xF1\xE7\u010D\u0161\u017E\xC0\xC1\xC2\xC4\xC3\xC5\u0104\u0106\u010C\u0116\u0118\xC8\xC9\xCA\xCB\xCC\xCD\xCE\xCF\u012E\u0141\u0143\xD2\xD3\xD4\xD6\xD5\xD8\xD9\xDA\xDB\xDC\u0172\u016A\u0178\xDD\u017B\u0179\xD1\xDF\xC7\u0152\xC6\u010C\u0160\u017D\u2202\xF0 ,.\'-]+$/u" ng-class="{ \'wrong_info\' : (RegisterForm.Lname.$invalid && ctrl.RegSubmitted), \'\' :(RegisterForm.Lname.$valid && ctrl.RegSubmitted)}" ng-model="ctrl.detail.lastname" class="form-control" placeholder="" required> <span ng-show="RegisterForm.Lname.$error.pattern" class="error-message-detail"><em>Bitte nur Buchstaben verwenden.</em></span> <span ng-show="RegisterForm.Lname.$error.maxlength" class="error-message-detail"><em>Bitte nicht mehr als 50 Zeichen verwenden.</em></span></div></div><div class="col-md-2"></div></div><div class="row"><div class="col-md-8 col-md-offset-2 col-sm-11 col-sm-offset-1"><div class="form-group"><label for="">{{\'Address\' | translate}}&nbsp;<a businesscard-tooltip-wrapper href="javascript:void(0);" title="Als Kontaktinformation f\xFCr die Praxis."><i class="fa fa-info-circle" style="color:#27a9e1"></i></a></label><input type="text" name="AddSt" ng-maxlength="50" ng-class="{ \'wrong_info\' : (RegisterForm.AddSt.$invalid && ctrl.RegSubmitted), \'\' :(RegisterForm.AddSt.$valid && ctrl.RegSubmitted)}" ng-model="ctrl.detail.addressStreet" class="form-control" placeholder="" required> <span ng-show="RegisterForm.AddSt.$error.maxlength" class="error-message-detail"><em>Bitte nicht mehr als 50 Zeichen verwenden.</em></span></div></div><div class="col-md-4"><div class="col-md-2"></div></div></div><div class="row"><div class="col-md-4 col-md-offset-2 col-sm-5 col-sm-offset-1 col-xs-6"><div class="form-group"><label for="">{{\'PostalCode\' | translate}}</label><input type="text" ng-pattern="/^[0-9]*$/" ng-maxlength="6" name="Pcode" ng-class="{ \'wrong_info\' : (RegisterForm.Pcode.$invalid && ctrl.RegSubmitted), \'\' :(RegisterForm.Pcode.$valid && ctrl.RegSubmitted)}" ng-model="ctrl.detail.addressPostalCode" class="form-control" placeholder="" required> <span ng-show="RegisterForm.Pcode.$error.pattern" class="error-message-detail"><em>Bitte nur Zahlen verwenden.</em></span> <span ng-show="RegisterForm.Pcode.$error.maxlength" class="error-message-detail"><em>Bitte nicht mehr als 6 Zeichen verwenden.</em></span></div></div><div class="col-md-4 col-md-offset-0 col-sm-5 col-sm-offset-1 col-xs-6"><div class="form-group"><label for="">{{\'City\' | translate}}</label><input type="text" name="City" ng-maxlength="40" ng-class="{ \'wrong_info\' : (RegisterForm.City.$invalid && ctrl.RegSubmitted), \'\' :(RegisterForm.City.$valid && ctrl.RegSubmitted)}" ng-model="ctrl.detail.addressCity" class="form-control" placeholder="" required> <span ng-show="RegisterForm.City.$error.maxlength" class="error-message-detail"><em>Bitte nicht mehr als 40 Zeichen verwenden.</em></span></div><div class="col-md-2"></div></div></div><div class="row" ng-if="ctrl.isBirthdateMandatory()"><div class="col-md-4 col-md-offset-2 col-sm-5 col-sm-offset-1 col-xs-6"><div class="form-group"><label for="">Geburtsdatum&nbsp;<a businesscard-tooltip-wrapper href="javascript:void(0);" title="Als Information f\xFCr die Praxis."><i class="fa fa-info-circle" style="color:#27a9e1"></i></a></label><input type="text" birthday-picker name="birthdate" ng-pattern="/^[0-3][0-9]\\.[0-1][0-9]\\.(19|20)[0-9][0-9]$/" ng-class="{ \'wrong_info\' : (RegisterForm.birthdate.$invalid && ctrl.RegSubmitted), \'\' :(RegisterForm.birthdate.$valid && ctrl.RegSubmitted)}" ng-model="ctrl.detail.birthdate" class="form-control" placeholder="TT.MM.JJJJ" required> <span ng-show="RegisterForm.birthdate.$error.pattern && ctrl.RegSubmitted" class="error-message-detail"><em>Bitte ein Datum im Format TT.MM.JJJJ eingeben.</em></span></div></div></div><div class="row"><div class="col-md-4 col-md-offset-2 col-sm-5 col-sm-offset-1 col-xs-6"><div class="form-group"><label for="">{{\'EMAIL\' | translate}}&nbsp;<a businesscard-tooltip-wrapper href="javascript:void(0);" title="Damit wir Ihnen eine Buchungsbest\xE4tigung zustellen k\xF6nnen."><i class="fa fa-info-circle" style="color:#27a9e1"></i></a></label><input type="email" name="emailadd" ng-maxlength="100" ng-pattern="/^(([^<>()\\[\\]\\\\.,;:\\s@\' ]+(\\.[^><>()\\[\\]\\\\.,;:\\s@\']+)*)|(\'.+\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/" ng-class="{ \'wrong_info\' : (RegisterForm.emailadd.$invalid && ctrl.RegSubmitted), \'\' :(RegisterForm.emailadd.$valid && ctrl.RegSubmitted)}" ng-model="ctrl.detail.email" class="form-control" placeholder="" required> <span ng-show="RegisterForm.emailadd.$error.pattern && ctrl.RegSubmitted" class="error-message-detail"><em>Bitte eine g\xFCltige E-Mail-Adresse eintragen, im Format z.B. name@example.com.</em></span> <span ng-show="RegisterForm.emailadd.$error.maxlength" class="error-message-detail"><em>Bitte nicht mehr als 100 Zeichen verwenden.</em></span></div></div><div class="col-md-4 col-md-offset-0 col-sm-5 col-sm-offset-1 col-xs-6"><div class="form-group"><label for="">Mobile&nbsp;<a businesscard-tooltip-wrapper href="javascript:void(0);" title="Damit die Praxis Sie bei R\xFCckfragen erreichen kann."><i class="fa fa-info-circle" style="color:#27a9e1"></i></a></label><input type="text" name="phone" ng-pattern="/^\\+?[0-9 ]*$/" ng-maxlength="25" ng-class="{ \'wrong_info\' : (RegisterForm.phone.$invalid && ctrl.RegSubmitted), \'\' :(RegisterForm.phone.$valid && ctrl.RegSubmitted)}" ng-model="ctrl.detail.phone" class="form-control" placeholder="" required> <span ng-show="RegisterForm.phone.$error.pattern" class="error-message-detail"><em>Bitte nur Zahlen und Plus (+) verwenden, z.B. 044 123 45 67 oder +41 44 123 45 67 .</em></span> <span ng-show="RegisterForm.phone.$error.maxlength" class="error-message-detail"><em>Bitte nicht mehr als 25 Zeichen verwenden.</em></span></div></div><!--   <div class="col-md-4">\n                                   <div class="form-group">\n                                        <label for="">{{\'CONFIRM\' | translate}}</label>\n                                        <input type="email" name="Cemailadd" ng-pattern=\'/^(([^<>()\\[\\]\\\\.,;:\\s@" ]+(\\.[^><>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\'  ng-match="ctrl.detail.email" ng-class="{ \'wrong_info\' : (RegisterForm.Cemailadd.$invalid && ctrl.RegSubmitted), \'\' :(RegisterForm.Cemailadd.$valid && ctrl.RegSubmitted)}"  ng-model="ctrl.detail.confirmEmail"  class="form-control" placeholder="" required>\n                                    </div>\n                                    <div class="col-md-2"></div>\n                                  </div> --></div><div class="row"><div class="col-md-8 col-md-offset-2 col-sm-11 col-sm-offset-1"><div class="form-group"><label for="" ng-bind="(ctrl.isMentorBooking())? \'Ihre Nachricht (Optional)\' : (\'detail.Comment\' | translate)"></label><textarea type="text" name="Comment" ng-maxlength="2000" ng-model="ctrl.detail.comment" class="form-control" placeholder=""></textarea><span ng-show="RegisterForm.Comment.$error.maxlength" class="error-message-detail"><em>Bitte nicht mehr als 2000 Zeichen verwenden.</em></span></div></div></div><div class="row" style="padding-bottom: 0px"><div class="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1"><div id="appointment" class="appointment-form"><div class="scroller-form_anchor"></div><div class="scroller-form" ng-show="(ctrl.serviceName!=null && ctrl.serviceName!=\'\') && (ctrl.dentistName!=null && ctrl.dentistName!=\'\')  && (ctrl.selectedDate!=null && ctrl.selectedDate!=\'\') && (ctrl.dentistName!=\'Show All Appointments\' && ctrl.dentistName!=\'Alle aposments anzeigen\')"><div class="row"><div class="col-md-8 col-xs-7 col-sm-8"><h5 ng-bind="(\'APPOINTMENT\' | translate)+\':\'"></h5></div><div class="col-md-4 col-xs-5 col-sm-4"><a ng-click="ctrl.changedata()" class="btn btn-info confirmation_btn lessimportant">{{\'Change\' | translate}}</a></div></div><div class="row"><div class="col-md-8 col-sm-8"><p style="margin:0px"><custom ng-bind="ctrl.selectedService.customName != null && ctrl.selectedService.customName != \'\' ? ctrl.selectedService.customName : ctrl.serviceName | translate" class="txt_selected"></custom><!-- <custom ng-bind="\'WITH\' | translate"></custom> --><custom ng-bind="ctrl.dentistName" class="txt_selected"></custom><!-- <custom ng-bind="\'ON\' | translate"></custom> --><custom ng-bind="(ctrl.selectedDate | date:\'dd. MMMM yyyy\')+\' \'+(\'AT\' | translate)+\' \'+(ctrl.selectedTime | date:\'H:mm\')" class="txt_selected"></custom><!--\n\t\t\t\t\t\t\t\t                            <custom ng-bind="\'AT\' | translate"> </custom>\n\t\t\t\t\t\t\t\t                            <custom ng-bind="ctrl.selectedTime | date:\'H:mm\'" class="txt_selected"></custom>\n\t\t\t\t\t\t\t\t                            --></p></div></div><div ng-show="!ctrl.isStandaloneBooking && ctrl.servicePrice != \'\'" class="row"><div class="col-md-8 col-sm-8"><div class="col-md-12 col-sm-12 col-xs-12 txt_selected"><table><tr><td><custom class="txt_price_info" style="float: left">{{ \'detail.Price\' | translate }}</custom></td><td>&nbsp;&nbsp;</td><td><custom class="txt_price_info" ng-bind="ctrl.servicePrice"></custom></td></tr><tr ng-show="((ctrl.showVoucherDeduction && ctrl.showVoucherFields && ctrl.payNow) || (ctrl.selectedService.fixedPriceReduced && !ctrl.isStandaloneBooking))"><td><custom class="txt_price_info secondline" ng-bind="ctrl.voucherDeductionDescription" style="display:inline-block">Erm\xE4ssigung</custom><custom ng-show="((ctrl.showVoucherDeduction && ctrl.showVoucherFields && ctrl.payNow) || (ctrl.selectedService.fixedPriceReduced && !ctrl.isStandaloneBooking))" style="border: none; color: grey; font-size: 11px; padding-bottom: 0px">&nbsp;({{ \'disclaimer.onlyForNewPatients\' | translate}})</custom></td><td>&nbsp;&nbsp;</td><td><custom class="txt_price_info secondline" ng-bind="ctrl.voucherDeduction"></custom></td></tr><tr ng-show="((ctrl.showVoucherDeduction && ctrl.showVoucherFields && ctrl.payNow) || (ctrl.selectedService.fixedPriceReduced && !ctrl.isStandaloneBooking))"><td><custom class="txt_price_info">Endpreis</custom></td><td>&nbsp;&nbsp;</td><td><strong class="txt_price_info" ng-bind="ctrl.resultingPrice"></strong></td></tr></table></div><div class="col-md-4 col-sm-4"><div ng-show="ctrl.payNow" class="row"><div ng-show="ctrl.payNow && !ctrl.showVoucherFields" class="col-md-12 col-sm-12 col-xs-12 txt_selected loesen"><a type="button" ng-click="ctrl.showVoucherFields = true" class="link">{{\'detail.showVoucher\' | translate}}</a></div></div></div></div></div><div class="row" ng-show="ctrl.showVoucherFields && ctrl.payNow"><div class="col-md-10 col-sm-10"><div class="col-md-7 col-sm-7 col-xs-12 txt_selected gutschein"><div style="display: box"><input ng-show="ctrl.showVoucherFields && ctrl.payNow" type="text" name="voucher" ng-maxlength="50" ng-model="ctrl.detail.couponCode" class="form-control" placeholder="Gutscheincode eingeben" onkeydown="if (event.keyCode == 13) event.preventDefault();if (event.keyCode == 13) document.getElementById(\'btnApplyVoucher\').click()" style="width:100%"> <span ng-show="RegisterForm.voucher.$error.maxlength" class="error-message-detail"><em>Bitte nicht mehr als 50 Zeichen verwenden.</em></span></div></div><div class="col-md-3 col-sm-3 col-xs-6 txt_selected gutschein"><a id="btnApplyVoucher" ng-show="ctrl.showVoucherFields && ctrl.payNow" href="javascript:void(0);" ng-click="ctrl.applyVoucher()" class="link"><custom>{{\'detail.UseVoucher\' | translate}}</custom></a></div><div class="col-md-2 col-sm-2 col-xs-6 txt_selected gutschein"><a ng-show="ctrl.showVoucherFields && ctrl.payNow" href="javascript:void(0);" ng-click="ctrl.cancelVoucher()" class="link"><custom>{{\'detail.RemoveVoucher\' | translate}}</custom></a></div></div></div><div class="row" ng-show="ctrl.showVoucherErrorMessage && ctrl.showVoucherFields && ctrl.payNow"><div class="col-md-8 col-sm-8"><div style="font-size:smaller; color:#F44336" class="icon ion-alert-circled error" ng-bind="\'detail.VoucherIncorrect\' | translate"></div></div></div><div ng-show="!ctrl.payNow" class="row" style="padding-bottom:10px"><div ng-show="!ctrl.payNow" class="col-md-4 col-sm-4 col-xs-2"><button ng-show="!ctrl.payNow && ctrl.showVoucherFields" type="button" ng-click="ctrl.changePayTime()" class="btn-sm btn-warning btn-pay-now"><strong>{{\'detail.PayNow\' | translate}}</strong></button></div><div class="col-md-4 col-sm-4 col-xs-4"></div><div class="col-md-4 col-sm-4 col-xs-6"></div></div></div></div></div><div class="col-md-2"></div></div><!--                                     <div class="g-recaptcha"  data-sitekey="6LdEnB8UAAAAAGw2iTQ3y9tXxV8CEyXoqhgP4bxQ"></div> --><div class="row"><div class="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1"><div class="form-group row" style="padding:20px; text-align:left"><table><tr><th><label class="checkbox" style="display: inline-block"><input name="terms" required type="checkbox" style="float: left" ng-model="ctrl.checkTerm"></label></th><th><div class="bestimmungen">{{\'Agreement\' | translate}}<a class="ls-modal-inline" href="" data-text="{{ctrl.practiceBookingTerms}}" ng-bind="(ctrl.isMentorBooking()) ? \'Bestimmungen\' : (\'Praxisbestimmungen\' | translate) "></a><custom ng-show="!ctrl.isStandaloneBooking">, die <a class="ls-modal" href="/booking/AllgemeineGB.html">{{\'Agb\' | translate}}</a> und die <a class="ls-modal" href="/booking/Datenschutzerkl.html">{{\'Datenschutzerkl\' | translate}}</a></custom>gelesen und akzeptiert zu haben.</div><span ng-show="RegisterForm.terms.$invalid && ctrl.RegSubmitted" class="error-message-detail"><em ng-bind="\'PleaseConfirm\' | translate"></em></span></th></tr></table></div></div><div class="col-md-2"></div></div><div class="row"><div class="col-md-4 col-md-offset-4 col-sm-8 col-sm-offset-2"><button type="submit" class="btn btn-info btn-block confirmation_btn">{{\'CBooking\' |translate}}</button></div><div class="col-md-4"></div></div><div class="row text-center"><span ng-show="RegisterForm.$invalid && RegisterForm.$submitted" class="error-message-detail"><em>Bitte kontrollieren Sie Ihre Eingaben.</em></span></div></form></div><!-- Modal --><div class="modal fade" id="myModal" tabindex="-1" role="dialog" style="text-align:left" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="myModalLabel"></h4></div><div class="modal-body"></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Schliessen</button></div></div></div></div><form id="register-form" name="LoginForm" novalidate="" ng-submit="ctrl.Login(LoginForm)" role="form" ng-show="!ctrl.showsubmit"><div class="form-group"><label for="">Email</label><input type="email" name="loginEmail" ng-pattern=\'/^(([^<>()\\[\\]\\\\.,;:\\s@" ]+(\\.[^><>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\' ng-class="{ \'wrong_info\' : (LoginForm.loginEmail.$invalid && ctrl.LoginSubmitted), \'\' :(LoginForm.loginEmail.$valid && ctrl.LoginSubmitted)}" ng-model="ctrl.loginDetail.Email" class="form-control" id="loginEmail" placeholder="" required></div><div class="form-group"><label for="">{{\'Password\' | translate}}</label><input type="password" name="password" ng-class="{ \'wrong_info\' : (LoginForm.password.$invalid && ctrl.LoginSubmitted), \'\' :(LoginForm.password.$valid && ctrl.LoginSubmitted)}" ng-model="ctrl.loginDetail.Password" class="form-control" id="loginPassword" placeholder="" required></div><button type="submit" class="btn btn-info btn-block">{{\'Login\' | translate}}<i class="fa fa-sign-in"></i></button></form></div></div></div></div></div></div></div><!-- <script src="https://www.google.com/recaptcha/api.js"></script> -->');
$templateCache.put('templates/done.html','<style class="hide-on-print">.fb-share {\n  vertical-align: top;\n  display: inline-block;\n  height: 18px;\n  padding: 0 4px;\n  border: 1px solid #cad4e7;\n  border-radius: 3px;\n  background: #eceef5;\n  color: #3b5998;\n  font-family: \'Lucida Grande\', Tahoma, Verdana, Arial, sans-serif;\n  font-size: 11px;\n  line-height: 1;\n  text-decoration: none;\n  white-space: nowrap;\n  /* IE7 */\n  *display: inline;\n  *zoom: 1;\n}\n.fb-share:hover {\n  border-color: #9dacce;\n}\n.fb-share-icon {\n  position: relative;\n  top: 2px;\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  margin-right: 1px;\n  background-image: url(https://fbstatic-a.akamaihd.net/rsrc.php/v2/y-/r/tbhIfdAHjXE.png);\n  /* IE7 */\n  *display: inline;\n  *zoom: 1;\n}\n.fb-share-text {\n  position: relative;\n  top: -1px;\n}\n.done-page-image {\n  height: 120px;\n}\n.done-horizontal-lines {\n\tmargin-top:15px; \n\tmargin-bottom: 15px;\n\theight:1px; \n\twidth: 100%; \n\tborder-top: solid 2px #000;\n}\n\n.done-template-container {\n\tbackground:#F3F3F3;\n\twidth: 100%;\n\tjustify-content: center;\n\ttext-align: center;\n\tdisplay: inline-block;\n\tfont-familiy: lato;\n\tfont-size: 22px;\n\tpadding:0;\n\tz-index: 998;\n\tmargin-top: -60px;\n\tposition:relative;\n}\n@media(min-width: 479px) {\n\t.done-booking-info-block {\n\t\tbackground:#ffffff;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 40%;\n\t\tdisplay: inline-block;\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t\tpadding-top: 15px;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 20px;\n\t\tfont-size: 18px;\n\t}\n\t.done-booking-info-block-height {\n\t\theight: 500px;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-booking-info-block {\n\t\tbackground:#ffffff;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 100%;\n\t\tdisplay: inline-block;\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t\tpadding-top: 15px;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 20px;\n\t\tfont-size: 18px;\n\t}\n\t.done-booking-info-block-height {\n\t\theight: 500px;\n\t}\n}\n\n@media(min-width: 479px) {\n\t.done-second-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: center;\n\t\twidth: 60%;\n\t\tdisplay: inline-block;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-second-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: center;\n\t\twidth: 90%;\n\t\tdisplay: inline-block;\n\t\tmargin-bottom: 0px;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(min-width: 479px) {\n\t.done-third-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 60%;\n\t\tdisplay: inline-block;\n\t\tmargin-bottom: 20px;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-third-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 90%;\n\t\tdisplay: inline-block;\n\t\tmargin-bottom: 20px;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(min-width: 479px) {\n\t.done-page-image {\n\t\tposition: absolute;\n\t\topacity: 1;\n\t\tleft: 50%;\n\t\ttop: 395px;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-page-image {\n\t\tposition: absolute;\n\t\topacity: 1;\n\t\tleft: 35%;\n\t\ttop: 390px;\n\t}\n}\n\n.hide-on-print {\n\tdisplay: visible;\n}\n\n.show-on-print {\n\tdisplay: none;\n}\n\n@media print {\n\t@page { margin: 0; }\n\t\n\t#footer { display: none; }\n\n\t.done-template-container {\n\t\tvisibility: visible;\n\t\tdisplay: block;\n\t\tposition:absolute;\n\t\ttop: 0px;\n\t\tleft: 0px;\n\t}\n\t\n\t.done-booking-info-block {\n\t\twidth: 90%;\n\t\tfont-size: 16px;\n\t\theight: 450px;\n\t\tmargin-top:100px;\n\t\t\n\t\tbackground:#ffffff;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\tdisplay: inline-block;\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t\tpadding-top: 15px;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 20px;\n\t}\n\t\n\t.done-second-block {\n\t \twidth: 90%;\n\t \tfont-size: 16px;\n\t \theight: 80px;\n\t}\n\t\n\t.done-third-block {\n\t \twidth: 90%;\n\t \tfont-size: 16px;\n\t}\n\t\n\t.hide-on-print {\n\t    display:none !important;\n\t}\n\t\n\t\n\t.show-on-print {\n\t    display:visible;\n\t}\n\t\n\t\n\t.done-page-image {\n\t\tdisplay: none !important;\n\t}\n\t\n\t#wrapper {\n\t    overflow: inherit;\n\t}\n\t\n\t#wrapper * {\n\t    display: none;\n\t}\n\t\n\t#wrapper #js-bottom-block, #wrapper #js-bottom-block * {\n\t    display: inline-block;\n\t}\n}</style><script>$(document).ready(function () {\n\tvar nav = 0;\n\tif($(\'#bottom-scroll\').length>0)\n\t{\n\t\tnav = $(\'#bottom-scroll\').offset().top\n\t}\n    $(\'html, body\').animate({\n        scrollTop: nav\n    }, \'slow\');\n});</script><div id="print" class="forfooter done-template-container" ng-controller="doneController as ctrl"><div class="done-booking-info-block" ng-class="ctrl.isStandaloneBooking ? \'\' : \'done-booking-info-block-height\'"><custom style="color: black">Ihr Termin ist best\xE4tigt!</custom><br><br><br><custom style="color: black;margin-left:3px">Buchungsreferenz:</custom>&nbsp;<custom ng-bind="ctrl.bookingReference" style="color: black"></custom><div class="done-horizontal-lines"></div><custom ng-bind="ctrl.selectedService.customName != null && ctrl.selectedService.customName != \'\' ? ctrl.selectedService.customName : ctrl.serviceName | translate" style="color: black;margin-left:3px"></custom><div class="done-horizontal-lines"></div><custom ng-bind="ctrl.dentistName" style="color: black; margin-left:3px; display:inline-block"></custom><div class="done-horizontal-lines"></div><custom ng-bind="ctrl.selectedDate | date:\'dd. MMMM yyyy\'" style="color: black; margin-left:3px"></custom>&nbsp;<custom style="color: black">um</custom>&nbsp;<custom ng-bind="ctrl.selectedTime | date:\'H:mm\'" style="color: black"></custom><div class="done-horizontal-lines" ng-show="!ctrl.isStandaloneBooking"></div><custom ng-show="!ctrl.isStandaloneBooking" ng-bind="ctrl.servicePrice" style="color: black; margin-left:3px"></custom><br ng-show="ctrl.voucherDeductionDescription && ctrl.resultingPrice && !ctrl.isStandaloneBooking"><custom ng-show="ctrl.voucherDeductionDescription && ctrl.resultingPrice && !ctrl.isStandaloneBooking" ng-bind="ctrl.voucherDeductionDescription" style="color: black; margin-left:3px"></custom><custom ng-show="ctrl.voucherDeduction && !ctrl.isStandaloneBooking" style="border: none; color: grey; font-size: 11px; padding-bottom: 0px">&nbsp;({{ \'disclaimer.onlyForNewPatients\' | translate}})</custom><br ng-show="ctrl.voucherDeduction && !ctrl.isStandaloneBooking"><custom ng-show="!ctrl.isStandaloneBooking" ng-bind="ctrl.voucherDeduction" style="color: black; margin-left:3px"></custom><br ng-show="ctrl.resultingPrice && !ctrl.isStandaloneBooking"><custom ng-show="!ctrl.isStandaloneBooking" ng-bind="ctrl.resultingPrice" style="color: black; margin-left:3px"></custom><div class="done-horizontal-lines"></div><custom ng-bind="ctrl.practiceName" style="color: black; margin-left:3px"></custom>,<br><custom ng-bind="ctrl.practiceAddress" style="color: black; margin-left:3px"></custom><div class="done-horizontal-lines"></div></div><div class="done-second-block">Eine Best\xE4tigung mit den Details Ihres Termins wurde an Ihre E-Mail-Adresse gesendet.<br><br><p>Bitte \xFCberpr\xFCfen Sie den Erhalt der E-Mail-Best\xE4tigung (auch in Ihrem Spam/Junkmail-Ordner).<custom class="hide-on-print">Bei Nichterhalt machen Sie bitte einen Screenshot der obigen Best\xE4tigung<a href="javascript:void(0);" class="hide-on-print mobileHide links" onclick="window.print()"> oder drucken hier Ihre Best\xE4tigung aus <i class="fa fa-print"></i></a>.</custom></p><br><custom ng-show="!ctrl.isStandaloneBooking">Das Zumedo Team w\xFCnscht Ihnen eine angenehme Behandlung!</custom><br ng-show="!ctrl.isStandaloneBooking"><custom ng-show="!ctrl.isStandaloneBooking" class="hide-on-print">Share auf facebook: &nbsp;<br ng-show="!ctrl.isStandaloneBooking" class="hide-on-print"><a ng-show="!ctrl.isStandaloneBooking" class="hide-on-print" href="https://www.facebook.com/dialog/share?app_id=203460603709463&display=popup&href=https%3A%2F%2Fwww.zumedo.ch%2F&quote=Bei%20Zumedo%20habe%20ich%20online%20meinen%20Zahnarzttermin%20gebucht.%20Probier%27s%20doch%20auch!&hashtag=%23Zumedo" target="_blank"><img src="https://www.zumedo.ch/booking/img/facebook_share.png" style="height:20px;border-radius: 3px"></a><!-- <i class="fa fa-facebook-official" style="color:#3b5998"></i> --></custom><br ng-show="!ctrl.isStandaloneBooking"><br ng-show="!ctrl.isStandaloneBooking"></div><div class="done-third-block">Bitte beachten Sie die<custom ng-bind="(ctrl.isMentorBooking()) ? \'Bestimmungen\' : \'Praxisbestimmungen\'"></custom>-<custom ng-bind="ctrl.practiceName"></custom>:<br><div ng-repeat="term in ctrl.practiceBookingTerms">&nbsp;&nbsp;&nbsp;&nbsp;<custom ng-bind="term"></custom></div><br ng-show="!ctrl.isStandaloneBooking"><br ng-show="!ctrl.isStandaloneBooking"><custom ng-show="!ctrl.isStandaloneBooking">Fragen und Termin-\xC4nderungen:</custom><br ng-show="!ctrl.isStandaloneBooking"><custom ng-show="!ctrl.isStandaloneBooking">Bei Fragen zu Ihrem Termin oder \xC4nderungsw\xFCnschen wenden Sie sich bitte telefonisch an die Praxis. Um eine Stornierung der Termin-Buchung vorzunehmen, kontaktieren Sie uns unter booking@zumedo.ch.</custom></div></div>');
$templateCache.put('templates/error.html','<style class="hide-on-print">.done-template-container {\n\tbackground:#F3F3F3;\n\twidth: 100%;\n\tjustify-content: center;\n\ttext-align: center;\n\tdisplay: inline-block;\n\tfont-familiy: lato;\n\tfont-size: 22px;\n\tpadding:0;\n\tz-index: 998;\n\tmargin-top: -80px;\n\tposition:relative;\n}\n@media(min-width: 479px) {\n\t.done-booking-info-block {\n\t\tbackground:#ffffff;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 40%;\n\t\tdisplay: inline-block;\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t\tpadding-top: 30px;\n\t\tfont-size: 18px;\n\t}\n\t.done-booking-info-block-height {\n\t\theight: 500px;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-booking-info-block {\n\t\tbackground:#ffffff;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 100%;\n\t\tdisplay: inline-block;\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t\tpadding-top: 30px;\n\t\tfont-size: 18px;\n\t}\n\t.done-booking-info-block-height {\n\t\theight: 500px;\n\t}\n}\n\n@media(min-width: 479px) {\n\t.done-second-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: center;\n\t\twidth: 60%;\n\t\tdisplay: inline-block;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-second-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: center;\n\t\twidth: 90%;\n\t\tdisplay: inline-block;\n\t\tmargin-bottom: 0px;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(min-width: 479px) {\n\t.done-third-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 60%;\n\t\tdisplay: inline-block;\n\t\tmargin-bottom: 20px;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-third-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 90%;\n\t\tdisplay: inline-block;\n\t\tmargin-bottom: 20px;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(min-width: 479px) {\n\t.done-page-image {\n\t\tposition: absolute;\n\t\topacity: 1;\n\t\tleft: 50%;\n\t\ttop: 395px;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-page-image {\n\t\tposition: absolute;\n\t\topacity: 1;\n\t\tleft: 35%;\n\t\ttop: 390px;\n\t}\n}\n\n.hide-on-print {\n\tdisplay: visible;\n}\n\n.show-on-print {\n\tdisplay: none;\n}</style><script>$(document).ready(function () {\n\tvar nav = 0;\n\tif($(\'#bottom-scroll\').length>0)\n\t{\n\t\tnav = $(\'#bottom-scroll\').offset().top\n\t}\n    $(\'html, body\').animate({\n        scrollTop: nav\n    }, \'slow\');\n});</script><div id="print" class="forfooter done-template-container" ng-controller="errorController as ctrl"><div class="done-booking-info-block"><custom style="color: black">Achtung:</custom><br><custom style="color: black">Ihr Termin konnte leider <strong>nicht</strong> best\xE4tigt werden.</custom><br><br></div><div class="done-third-block">Bei der \xDCbermittlung der Buchung an das Praxis-System ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es sp\xE4ter noch einmal, oder w\xE4hlen Sie einen anderen Termin.<div ng-show="!ctrl.isStandaloneBooking">Sollte die St\xF6rung bei dieser Praxis weiterhin bestehen, finden Sie viele freie, online buchbare Termine auch in weiteren Praxen auf Zumedo.</div></div><div class="row"><div class="col-md-4 col-md-offset-4 col-sm-8 col-sm-offset-2"><a ng-click="ctrl.gotoHome()" class="btn btn-lg btn-success btn-block">Zur\xFCck zur Termin-Auswahl</a></div></div></div>');
$templateCache.put('templates/footer.html','<!-- THE FOLLOWING PART GETS OVERRIDEN BY GULP BUILD. CHANGE CONTENTS ONLY DIRECTLY IN templates/footer.html !!!! --><div id="map-anchor-bottom" class="footer-area"><div class="container"><aside class="footer-navigation"><div class="row"><div class="col-sm-10 col-sm-offset-1"><div class="row"><div class="col-sm-4"><nav class="footer-nav"><h3>Zumedo</h3><ul><li><a href="/">Zahnarzt finden</a></li><li><a href="/so-funktionierts">So funktioniert\'s</a></li><li><a href="/zahnarzt/kosten">Zahnarzt Kosten</a></li><li><a href="/fragen-und-antworten">FAQ</a></li><li><a href="/blog/">Blog</a></li></ul></nav></div><div class="col-sm-4"><nav class="footer-nav"><h3>F\xFCr Zahn\xE4rzte</h3><ul><li><a href="/zahnarzt/partner-werden">Ihre Vorteile</a></li><li><a href="https://calendar.zumedo.ch/">Webkalender</a></li></ul></nav></div><div class="col-sm-4"><nav class="footer-nav"><h3>\xDCber uns</h3><ul><li><a href="/ueber-uns">Was ist Zumedo?</a></li><li><a href="/partner-praxen">Partnerpraxen</a></li><li><a href="https://static.zumedo.ch/kontakt">Kontakt</a></li><li><a href="https://zumedo.join.com">Jobs</a></li><li><a class="ls-modal" href="/booking/AllgemeineGB.html">AGB</a></li><li><a class="ls-modal" href="/booking/Datenschutzerkl.html">Datenschutzerkl\xE4rung</a></li></ul></nav></div></div></div></div></aside><footer id="footer" class="text-right"><span class="copyright">&copy; 2026 <a href="https://www.zumedo.ch">www.zumedo.ch</a></span></footer></div></div><div class="modal fade" tabindex="-1" role="dialog" id="myModal"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title"><strong></strong></h4></div><div class="modal-body"></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Schliessen</button><!--    <button type="button" class="btn btn-primary">Save changes</button> --></div></div></div></div>');
$templateCache.put('templates/footer_en.html','<!-- THE FOLLOWING PART GETS OVERRIDEN BY GULP BUILD. CHANGE CONTENTS ONLY DIRECTLY IN templates/footer_en.html !!!! --><div id="map-anchor-bottom" class="footer-area"><div class="container"><aside class="footer-navigation"><div class="row"><div class="col-sm-10 col-sm-offset-1"><div class="row"><div class="col-sm-4"><nav class="footer-nav"><h3>Zumedo</h3><ul><li><a href="/">Find dentist</a></li><li><a href="/so-funktionierts">How it works</a></li><li><a href="/zahnarzt/kosten">Dentist prices</a></li><li><a href="/fragen-und-antworten">FAQ</a></li><li><a href="/blog/">Blog</a></li></ul></nav></div><div class="col-sm-4"><nav class="footer-nav"><h3>For dentists</h3><ul><li><a href="/zahnarzt/partner-werden">Your benefits</a></li><li><a href="https://calendar.zumedo.ch/">Webcalendar</a></li></ul></nav></div><div class="col-sm-4"><nav class="footer-nav"><h3>About us</h3><ul><li><a href="/ueber-uns">What is Zumedo?</a></li><li><a href="/partner-praxen">Zumedo partners</a></li><li><a href="https://static.zumedo.ch/kontakt">Contact</a></li><li><a href="https://zumedo.join.com">Jobs</a></li><li><a class="ls-modal" href="/booking/AllgemeineGB.html">Terms of Service</a></li><li><a class="ls-modal" href="/booking/Datenschutzerkl.html">Privacy Policy</a></li></ul></nav></div></div></div></div></aside><footer id="footer" class="text-right"><span class="copyright">&copy; 2026 <a href="https://www.zumedo.ch">www.zumedo.ch</a></span></footer></div></div><div class="modal fade" tabindex="-1" role="dialog" id="myModal"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title"><strong></strong></h4></div><div class="modal-body"></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button><!--    <button type="button" class="btn btn-primary">Save changes</button> --></div></div></div></div>');
$templateCache.put('templates/header.html','<!-- THE FOLLOWING PART GETS OVERRIDEN BY GULP BUILD. CHANGE CONTENTS ONLY DIRECTLY IN templates/header.html !!!! --><div id="languageArea" class="col-xs-12"><div id="google_translate_element"></div><style>#languageArea {\n            display: none;\n            font-size: smaller;\n            background-color: #a8f3e4;\n            padding-bottom: 5px;\n            font-family: \'Lato\', sans-serif;\n        }</style><script type="text/javascript">function googleTranslateElementInit() {\n            new google.translate.TranslateElement({pageLanguage: \'de\', includedLanguages: \'de,en\', layout: google.translate.TranslateElement.InlineLayout.HORIZONTAL, multilanguagePage: true, gaTrack: true, gaId: \'UA-97704838-1\'}, \'google_translate_element\');\n\n            function displayLanguageArea() {\n                var languageArea = $("[id=\'languageArea\']");\n                var frame = $("[id=\':1.container\']");\n                var toolbarPresentButNoTranslation = frame.length && (frame.contents().find("[id=\':1.promptSection\']").css("display") != "none");\n                var toolbarPresentButNotShown = frame.length && ($("div[class=\'skiptranslate\']").css("display") == "none");\n                if (toolbarPresentButNoTranslation || toolbarPresentButNotShown) {\n                    if (languageArea.css("display") != "block") {\n                        languageArea.css("display", "block");\n                    }\n                } else {\n                    if (languageArea.css("display") != "none") {\n                        languageArea.css("display", "none");\n                    }\n                }\n                setTimeout(displayLanguageArea, 500);\n            }\n            displayLanguageArea();\n        }</script><script type="text/javascript" src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"></script>We\'re sorry, this site is currently not available in your language. For your convenience, you may choose an automatically translated English version.</div><header id="header"><div class="container"><!-- page logo --><div class="logo"><a href="/"><img src="/booking/img/logo.svg" alt="Zumedo." width="181" height="34" class="hidden-xs hidden-sm"> <img src="/booking/img/logo01.svg" alt="Zumedo." width="52" height="24" class="visible-xs visible-sm"></a></div><!-- main navigation of the page --><nav class="navbar navbar-default" id="nav"><div class="navbar-header"><button type="button" class="navbar-toggle collapsed visible-xs visible-sm" data-toggle="collapse" data-target="#navigation" aria-expanded="false"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button></div><div class="collapse navbar-collapse navbar-right" id="navigation"><ul class="nav navbar-nav"><li><a href="/">Zahnarzt finden</a></li><li><a href="/so-funktionierts">So funktioniert\'s</a></li><li><a href="/zahnarzt/kosten">Zahnarzt Kosten</a></li><li class="mobileHide"><a href="/fragen-und-antworten">FAQ</a></li><li class="mobileShow"><a href="/fragen-und-antworten">Fragen und Antworten</a></li></ul><ul class="nav navbar-nav last"><li><a href="/zahnarzt/partner-werden">Partner werden</a></li></ul></div></nav></div></header>');
$templateCache.put('templates/header_en.html','<!-- THE FOLLOWING PART GETS OVERRIDEN BY GULP BUILD. CHANGE CONTENTS ONLY DIRECTLY IN templates/header_en.html !!!! --><header id="header"><div class="container"><!-- page logo --><div class="logo"><a href="/"><img src="/booking/img/logo.svg" alt="Zumedo." width="181" height="34" class="hidden-xs hidden-sm"> <img src="/booking/img/logo01.svg" alt="Zumedo." width="52" height="24" class="visible-xs visible-sm"></a></div><!-- main navigation of the page --><nav class="navbar navbar-default" id="nav"><div class="navbar-header"><button type="button" class="navbar-toggle collapsed visible-xs visible-sm" data-toggle="collapse" data-target="#navigation" aria-expanded="false"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button></div><div class="collapse navbar-collapse navbar-right" id="navigation"><ul class="nav navbar-nav"><li><a href="/">Find dentist</a></li><li><a href="/so-funktionierts">How it works</a></li><li><a href="/zahnarzt/kosten">Dentist prices</a></li><li class="mobileHide"><a href="/fragen-und-antworten">FAQ</a></li><li class="mobileShow"><a href="/fragen-und-antworten">FAQ</a></li></ul><ul class="nav navbar-nav last"><li><a href="/zahnarzt/partner-werden">List your practice</a></li></ul></div></nav></div></header>');
$templateCache.put('templates/home.html','<div ng-controller="homeController as ctrl" ng-cloak><!-- switch language links --><!--     <div class="dropdown language"> --><!--         <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown"> --><!--             Language --><!--             <span class="caret"></span> --><!--         </button> --><!--         <ul class="dropdown-menu"> --><!--             <li><a href="" ng-click="ctrl.changeLanguage(\'de\')"> German</a></li> --><!--             <li><a href="" ng-click="ctrl.changeLanguage(\'en\')"> English</a></li> --><!--         </ul> --><!--     </div> --><div class="services-padding services" ng-cloak ng-class=" ctrl.isStandaloneBooking ? \'standalone-background-white\' : \'\'"><div ng-show="ctrl.isStandaloneBooking" class="container hidden-xs" style="background-color: #F3F3F3; height:12px;margin-bottom: 10px;border: 4px solid white"></div><div class="container container-lg" ng-class="ctrl.isStandaloneBooking ? \'standalone-background-grey\' : \'\'"><div class="row"><div ng-class="ctrl.isStandaloneBooking ? \'col-md-12 standalone-width-98\' : \'col-md-9\'"><div class="fordesktop hidden-xs"><div class="inner_block box-holder"><h4 ng-show="!ctrl.isStandaloneBooking" ng-bind="\'ChooseService\' | translate"></h4><div ng-show="!ctrl.isStandaloneBooking" class="row same-height" ng-cloak><div class="col-lg-2 col-sm-3 col-xs-6 pointer forheight" ng-repeat="item in ctrl.Services | orderBy:\'noTimeSlotsAvailable\' | limitTo:ctrl.serviceCount" ng-click="ctrl.GetPractitionersOfService(item);"><div title="{{item.type}}" class="services_inner same-height-ignore" ng-class="ctrl.data.serviceId == item.ID_Service ? \'activated\' : (item.noTimeSlotsAvailable ? \'greyed-out\' : ctrl.setPractitionerClass(item))"><h5 ng-bind="item.customName != null && item.customName != \'\' ? item.customName : item.type | translate">{{item.customName != null && item.customName != \'\' ? item.customName : item.type | translate}}</h5><p class="time" ng-show="item.showDuration==true">{{item.duration}} min</p><p ng-show="item.showDuration==true && item.showPrice==true">/</p><p ng-class="item.fixedPriceReduced ? \'strike\' : \'\'" ng-show="item.showPrice==true && item.priceCalculated!=\'\'" ng-bind="item.priceCalculated"></p><h5 ng-show="item.fixedPriceReduced" ng-bind="item.reductionCoupon.description + \': \' + (item.fixedPriceReduced | currency)"></h5><p class="time" ng-show="item.noTimeSlotsAvailable"><br>Alle Termine vergeben</p></div></div></div><div ng-show="!ctrl.isStandaloneBooking" class="row"><div class="col-md-5"><button class="transparent show_more_btn" ng-if="ctrl.Services.length>=5 && ctrl.Services.length>=ctrl.serviceCount+1" ng-click="ctrl.serviceCount = ctrl.serviceCount+4"><i class="fa fa-plus"></i> {{\'SHOWMORES\' | translate}}</button> <button class="transparent show_more_btn" ng-if="ctrl.serviceCount>=5" ng-click="ctrl.serviceCount = ctrl.serviceCount-4"><i class="fa fa-minus"></i> {{\'SHOWLESSS\' | translate}}</button></div></div><div ng-show="ctrl.isStandaloneBooking" id="standalone-onload-before-booking-button" ng-class="ctrl.isStandaloneBooking ? \'standalone-onload-before-booking-button\' + ((ctrl.serviceName != null && ctrl.serviceName != \'\') ? \' standalone-hide-on-load\' : \'\') : \'\'"><custom class="block1">In wenigen Schritten zu Ihrem Termin</custom><br><br><custom class="block2" ng-bind="(ctrl.isMentorBooking()) ? \'W\xE4hlen Sie einen Grund\': \'W\xE4hlen Sie eine Behandlung\'"></custom></div><div id="bookingbuttonstandalone" ng-class="ctrl.isStandaloneBooking ? \'standalone-booking-transition\' + ((ctrl.serviceName == null || ctrl.serviceName == \'\') ? \' standalone-booking-button-onload-style\' : \' standalone-booking-select-style\')  : \'\'" ng-show="ctrl.isStandaloneBooking"><div class="dropdown" style="width: 50%; left:25%;outline: none;border-radius: 8px;cursor: pointer"><span id="dropdownstandalone" class="standalone-dropdown-opener dropdown-toggle text-center" data-toggle="dropdown" style="padding-top: 15px; font-weight: 400" ng-bind="(ctrl.serviceName != null && ctrl.serviceName != \'\') || (ctrl.selectedServiceObject.customName != null && ctrl.selectedServiceObject.customName != \'\') ? (ctrl.selectedServiceObject.customName != null && ctrl.selectedServiceObject.customName != \'\' ? (ctrl.selectedServiceObject.customName + (ctrl.selectedServiceObject.noTimeSlotsAvailable ? \'| Alle Termine vergeben\' : \'\')) : ((ctrl.serviceName | translate) + (ctrl.selectedServiceObject.noTimeSlotsAvailable ? \'| Alle Termine vergeben\': \'\' ))):(ctrl.isMentorBooking() ? \'Grund w\xE4hlen:\' : \'Behandlung w\xE4hlen:\')"></span><ul class="dropdown-menu" style="width: 100%"><li ng-repeat="item in ctrl.Services"><a id="serviceText{{$index}}" href="javascript:void(0);" ng-click="ctrl.GetPractitionersOfService(item);">{{item.customName != null && item.customName != \'\' ? item.customName : item.type | translate}}&nbsp;<custom ng-show="item.noTimeSlotsAvailable" style="font-weight: 600">| Alle Termine vergeben</custom></a></li></ul></div></div></div><div id="practitionerblock" ng-class="(ctrl.isStandaloneBooking && (ctrl.serviceName == null || ctrl.serviceName == \'\')) ? \'standalone-hide-on-load\' : \'\'" class="inner_block practitioner-holder"><h4 ng-show="!ctrl.isStandaloneBooking" ng-bind="\'ChoosePractitioner\' | translate"></h4><h4 class="standalone-h4" ng-show="ctrl.isStandaloneBooking" ng-bind="(ctrl.isMentorBooking()) ? \'Mentoren\' : \'Praktizierende (Optional)\' "></h4><div class="row same-height" ng-cloak><div class="col-md-4 col-sm-4 col-xs-6 pointer" ng-repeat="item in ctrl.Practitioners | limitTo:ctrl.dentistCount" ng-click="ctrl.GetAppointmentsOfPractitioner(item.id, item)"><div class="services_inner practitioner_inner same-height-ignore" ng-class="ctrl.data.practitionerId == item.id ? \'activated\' : \'\'"><div class="practitioner_avatar"><img ng-show="item.id != 0" class="practitioner_round_img" ng-src="{{item.bookingPictureUrl ? item.bookingPictureUrl : item.pictureUrl}}" onerror="this.src = \'img/no-image.png\'"> <i ng-show="item.id == 0" class="fa fa-users fa-3x" aria-hidden="true"></i></div><div class="practitioner_txt"><h5 class="name">{{(item.title ? item.title + \' \' : \'\') + item.firstname +\' \'+ item.lastname}}</h5><p ng-show="!ctrl.isMentorBooking();">{{(item.profession + \'_\' + item.salutation) | translate}}</p></div></div></div></div><div class="row"><div class="col-md-5"><button class="transparent show_more_btn" ng-if="ctrl.Practitioners.length>=5  && ctrl.Practitioners.length>=ctrl.dentistCount+1" ng-click="ctrl.dentistCount = ctrl.dentistCount+4"><i class="fa fa-plus"></i> {{\'SHOWMOREP\' | translate}}</button> <button class="transparent show_more_btn" ng-if="ctrl.dentistCount>=5 " ng-click="ctrl.dentistCount = ctrl.dentistCount-4"><i class="fa fa-minus"></i> {{\'SHOWLESSP\' | translate}}</button></div></div></div><div ng-class="(ctrl.isStandaloneBooking && (ctrl.serviceName == null || ctrl.serviceName == \'\')) ? \'standalone-hide-on-load\' : \'\'" id="timeblock" class="inner_block"><h4 ng-show="!ctrl.isStandaloneBooking" class="stylenarrow" ng-bind="\'TITLE\' | translate"></h4><h4 class="standalone-h4" ng-show="ctrl.isStandaloneBooking">Termin w\xE4hlen:</h4><div class="row" ng-show="(ctrl.serviceName!=null && ctrl.serviceName!=\'\' && (ctrl.noAppointment!=true || ctrl.nextTime.length != 0 || ctrl.prevTime.length != 0))"><div class="col-md-5 col-sm-6 col-xs-12"><h4 class="selectdate"><p><i class="fa fa-calendar" aria-hidden="true"></i> {{\'Choose\' | translate}}</p><input type="text" ng-model="ctrl.calDate" date-picker value="Choose period" class="btn form-control customdate"></h4></div><div class="col-md-4 col-sm-6 col-xs-12 pull-right" ng-if="ctrl.checkThisWeek()"><a href="" ng-click="ctrl.setWeekDays()" class="btn btn-info btn-block btn-show-link" ng-bind="\'ShowThisWeek\' | translate"></a></div></div><div class="row"><div class="col-md-12"><ul ng-cloak class="date" ng-show="(ctrl.serviceName!=null && ctrl.serviceName!=\'\' && (ctrl.noAppointment!=true || ctrl.nextTime.length != 0 || ctrl.prevTime.length != 0))"><li class="calender_btn"><button class="btn" ng-click="ctrl.setPrevWeek()"><i class="fa fa-angle-left"></i></button></li><li ng-repeat="item in ctrl.currentDays"><div class="date-title" ng-class="ctrl.DayNow.getDate() == item.dayDate.getDate() ? \'today\' : \'\'"><div class="date-holder"><h5>{{item.dayDate | showDate:\'D. MMMM\'}}</h5><p class="day">{{item.dayDate | showDate:\'dddd\'}}</p></div></div><ul class="time" ng-show="ctrl.showCalendar"><li ng-repeat="t in item.timings | limitTo:ctrl.appointmentCount" ng-if="ctrl.days.length>0"><button type="button" class="btn" ng-class="(ctrl.selectedTime== (t.time | date:\'H:mm\') && (ctrl.selectedDate | showDate:\'dd, DD. MMMM\')==(item.dayDate | showDate:\'dd, DD. MMMM\')) ? \'activatedbtn\' : \'\'" ng-click="ctrl.selectTime(t,item.dayDate)">{{t.time | date:\'H:mm\'}}</button></li><li ng-repeat="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30] | limitTo:0"><!-- limitTo: (item.timings.length < ctrl.appointmentCount ? ctrl.appointmentCount - item.timings.length : 0)">  --> <button type="button" class="btn" style="background-color:transparent" disabled="disabled">\u2014</button></li></ul></li><li class="calender_btn RT"><button class="btn" ng-click="ctrl.setNextWeek()"><i class="fa fa-angle-right"></i></button></li></ul><p class="text-center text-select calendartext" ng-if="ctrl.noAppointment==true && ctrl.showCalendar && (ctrl.nextTime.length==0 || ctrl.nextTime==null) && (ctrl.prevTime.length==0||ctrl.prevTime==null)">{{\'NOAPPOINTMENT\' | translate}}</p><p class="text-center text-select calendartext" ng-if="ctrl.mostAppointmentsPerDay==0 && (ctrl.nextTime.length != 0 && ctrl.nextTime!=null || ctrl.prevTime.length != 0 && ctrl.prevTime!=null)">{{\'TeimframeNoFree\' | translate}}</p><p class="text-center text-select calendartext" ng-if="ctrl.mostAppointmentsPerDay==0 && ctrl.nextTime.length != 0 && ctrl.nextTime!=null">{{\'NextFree\' | translate}} <a class="anchor" href="" ng-click="ctrl.setNextAppointment(ctrl.nextTime[0].time)">{{ctrl.nextTime[0].time | showDate:\'dd, DD. MMMM\' }} {{ctrl.nextTime[0].time | showTime:\'H:mm\'}}</a></p><p class="text-center text-select calendartext" ng-if="ctrl.mostAppointmentsPerDay==0 && ctrl.prevTime.length != 0 && ctrl.prevTime!=null">{{\'FirstFree\' | translate}} <a class="anchor" href="" ng-click="ctrl.setNextAppointment(ctrl.prevTime[ctrl.prevTime.length-1].time)">{{ctrl.prevTime[ctrl.prevTime.length-1].time | showDate:\'dd, DD. MMMM\' }} {{ctrl.prevTime[ctrl.prevTime.length-1].time | showTime:\'H:mm\'}}</a></p><p class="text-center text-select calendartext putdown" ng-show="!ctrl.showCalendar && !ctrl.isStandaloneBooking"><span ng-bind="\'SelectServicePlz\' | translate"></span></p><p class="text-center text-select calendartext putdown" ng-show="!ctrl.showCalendar && ctrl.isStandaloneBooking"><span>Bitte w\xE4hlen Sie zuerst eine Behandlung aus dem Dropdown-Men\xFC</span></p></div><div class="" ng-show="ctrl.showCalendar"><div class="col-md-5"><a class="btn btn-info btn-block show_more btn-show-more" ng-show="ctrl.appointmentCount < 9 && ctrl.mostAppointmentsPerDay>8" ng-click="ctrl.appointmentCount = ctrl.mostAppointmentsPerDay" ng-bind="\'ShowMore\' | translate"><i class="fa fa-plus"></i></a></div></div></div></div></div><div id="accordion" class="visible-xs"><div class="heading-holder"><h3 ng-bind="\'ChooseService\' | translate"></h3><span class="box-select box-select-text" ng-show="ctrl.serviceName != null && ctrl.serviceName != \'\' ">{{ctrl.selectedServiceObject != null && ctrl.selectedServiceObject.customName != null && ctrl.selectedServiceObject.customName != \'\' ? ctrl.selectedServiceObject.customName : ctrl.serviceName | translate}}</span> <span class="box-select box-select-padding"></span></div><div><div class="row" ng-cloak><div class="col-md-3 col-sm-3" ng-repeat="item in ctrl.Services | orderBy:\'noTimeSlotsAvailable\' | limitTo:ctrl.serviceCount" ng-click="ctrl.GetPractitionersOfService(item);"><div class="services_inner" ng-class="ctrl.data.serviceId == item.ID_Service ? \'activated\' : (item.noTimeSlotsAvailable ? \'greyed-out\' : ctrl.setPractitionerClass(item))"><h5>{{item.customName != null && item.customName != \'\' ? item.customName : item.type | translate}}</h5><div class="detail"><span class="time" ng-show="item.showDuration==true">{{item.duration}} min</span> <span ng-show="item.showDuration==true && item.showPrice==true && !ctrl.isStandaloneBooking">/</span> <span ng-class="item.fixedPriceReduced && !ctrl.isStandaloneBooking ? \'strike\' : \'\'" ng-show="item.showPrice==true && item.priceCalculated!=\'\' && !ctrl.isStandaloneBooking">{{item.priceCalculated}}</span><h5 class="reduction" ng-show="item.fixedPriceReduced && !ctrl.isStandaloneBooking" ng-bind="item.reductionCoupon.description + \':&nbsp;\' + (item.fixedPriceReduced | currency)"></h5><span class="time" ng-show="item.noTimeSlotsAvailable"><br>Alle Termine vergeben</span></div></div></div></div><div class="row"><div class="col-md-5"><button class="show_more_btn" ng-if="ctrl.Services.length>=5 && ctrl.Services.length>=ctrl.serviceCount+1" ng-click="ctrl.serviceCount = ctrl.serviceCount+4">+ {{\'SHOWMORES\' | translate}}</button> <button class="show_more_btn" ng-if="ctrl.serviceCount>=5" ng-click="ctrl.serviceCount = ctrl.serviceCount-4"><i class="fa fa-minus"></i> {{\'SHOWLESSS\' | translate}}</button></div></div></div><div class="heading-holder"><h3 ng-bind="\'ChoosePractitioner\' | translate"></h3><span class="box-select box-select-text" ng-show="ctrl.dentistName != null && ctrl.dentistName != \'\' ">{{ctrl.dentistName}}</span> <span class="box-select box-select-padding"></span></div><div><div class="row" ng-cloak><div class="col-md-3 col-sm-3 pointer" ng-repeat="item in ctrl.Practitioners | limitTo:ctrl.dentistCount" ng-click="ctrl.GetAppointmentsOfPractitioner(item.id, item)"><div class="services_inner practitioner_inner practitioner{{item.id}}" ng-class="ctrl.data.practitionerId == item.id ? \'activated\' : \'\'"><div class="practitioner_avatar"><img ng-show="item.id != 0" class="practitioner_round_img" ng-src="{{item.bookingPictureUrl ? item.bookingPictureUrl : item.pictureUrl}}" onerror="this.src = \'img/no-image.png\'"> <i ng-show="item.id == 0" class="fa fa-users fa-3x" aria-hidden="true"></i></div><div class="practitioner_txt"><h5 class="name">{{(item.title ? item.title + \' \' : \'\') + item.firstname + \' \' +item.lastname}}</h5><p>{{(item.profession + \'_\' + item.salutation) | translate}}</p></div></div></div></div><div class="row"><div class="col-md-5"><button class="show_more_btn" ng-if="ctrl.Practitioners.length>=5  && ctrl.Practitioners.length>=ctrl.dentistCount+1" ng-click="ctrl.dentistCount = ctrl.dentistCount+4"><i class="fa fa-plus"></i> {{\'SHOWMOREP\' | translate}}</button> <button class="show_more_btn" ng-if="ctrl.dentistCount>=5 " ng-click="ctrl.dentistCount = ctrl.dentistCount-4"><i class="fa fa-minus"></i> {{\'SHOWLESSP\' | translate}}</button></div></div></div><div class="heading-holder"><h3 ng-bind="\'TITLE\' | translate">Section 1</h3><span class="box-select box-select-text" ng-show="ctrl.selectedDate != null && ctrl.selectedDate != \'\' ">{{ctrl.selectedDate | date:\'d. MMMM\'}}<span>{{ctrl.selectedTime | date:\'H:mm\'}}</span></span> <span class="box-select box-select-padding box-select-padding-date"></span></div><div><span class="box-select" ng-show="(ctrl.serviceName==null || ctrl.serviceName==\'\' || (ctrl.noAppointment==true && ctrl.nextTime.length == 0 && ctrl.prevTime.length == 0))"></span><div class="row" ng-show="(ctrl.serviceName!=null && ctrl.serviceName!=\'\' && (ctrl.noAppointment!=true || ctrl.nextTime.length != 0 || ctrl.prevTime.length != 0))"><div class="col-xs-3"><div class="selectdate"><p><i class="fa fa-calendar" aria-hidden="true"></i></p><input type="text" date-picker value="Choose period" class="btn form-control customdate"></div></div><div class="col-md-3 hidden-xs" ng-if="ctrl.checkThisWeek()"><a href="" ng-click="ctrl.setWeekDays()" class="btn btn-info btn-block"><img src="img/currentdate.png" width="20"> {{\'ShowThisWeek\' | translate}}</a></div></div><div class="row" id="selectSlot"><div class="col-md-12"><ul ng-cloak class="date" ng-show="(ctrl.serviceName!=null && ctrl.serviceName!=\'\' && (ctrl.noAppointment!=true || ctrl.nextTime.length != 0 || ctrl.prevTime.length != 0))"><li class="calender_btn"><button class="btn" ng-click="ctrl.setPrevWeek()"><i class="fa fa-angle-left"></i></button></li><li ng-repeat="item in ctrl.currentDays"><div class="date-title" ng-class="ctrl.DayNow.getDate() == item.dayDate.getDate() ? \'today\' : \'\'"><div class="date-holder"><h5>{{item.dayDate | showDate:\'D. MMMM\'}}</h5><p class="day">{{item.dayDate | showDate:\'dddd\'}}</p></div></div><ul class="time" ng-show="ctrl.showCalendar"><li ng-repeat="t in item.timings | limitTo:ctrl.appointmentCount" ng-if="ctrl.days.length>0"><button type="button" class="btn" ng-class="(ctrl.selectedTime== (t.time | date:\'H:mm\') && (ctrl.selectedDate | showDate:\'dd, DD. MMMM\')==(item.dayDate | showDate:\'dd, DD. MMMM\')) ? \'activatedbtn\' : \'\'" ng-click="ctrl.selectTime(t,item.dayDate)">{{t.time | date:\'H:mm\'}}</button></li><li ng-repeat="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30] | limitTo:0"><!-- limitTo: (item.timings.length < ctrl.appointmentCount ? ctrl.appointmentCount - item.timings.length : 0)"> --> <button type="button" class="btn" style="background-color:transparent" disabled="disabled">\u2014</button></li></ul></li><li class="calender_btn RT"><button class="btn" ng-click="ctrl.setNextWeek()"><i class="fa fa-angle-right"></i></button></li></ul><p class="text-center calendartext" ng-if="ctrl.noAppointment==true && ctrl.showCalendar && (ctrl.nextTime.length==0 || ctrl.nextTime==null) && (ctrl.prevTime.length==0||ctrl.prevTime==null)">{{\'NOAPPOINTMENT\' | translate}}</p><p class="text-center calendartext" ng-if="ctrl.mostAppointmentsPerDay==0 && (ctrl.nextTime.length != 0 || ctrl.prevTime.length != 0)">{{\'TeimframeNoFree\' | translate}}</p><p class="text-center calendartext" ng-if="ctrl.mostAppointmentsPerDay==0 && ctrl.nextTime.length != 0">{{\'NextFree\' | translate}} <a class="anchor" href="" ng-click="ctrl.setNextAppointment(ctrl.nextTime[0].time)">{{ctrl.nextTime[0].time | showDate:\'dd, DD. MMMM\' }} {{ctrl.nextTime[0].time | showTime:\'H:mm\'}}</a></p><p class="text-center calendartext" ng-if="ctrl.mostAppointmentsPerDay==0 && ctrl.prevTime.length != 0">{{\'FirstFree\' | translate}} <a class="anchor" href="" ng-click="ctrl.setNextAppointment(ctrl.prevTime[ctrl.prevTime.length-1].time)">{{ctrl.prevTime[ctrl.prevTime.length-1].time | showDate:\'dd, DD. MMMM\' }} {{ctrl.prevTime[ctrl.prevTime.length-1].time | showTime:\'H:mm\'}}</a></p></div><div class="" ng-show="ctrl.showCalendar"><div class="col-md-5"><a class="show_more" ng-show="ctrl.appointmentCount < 9 && ctrl.mostAppointmentsPerDay>8" ng-click="ctrl.appointmentCount = ctrl.mostAppointmentsPerDay" ng-bind="\'ShowMore\' | translate"><i class="fa fa-plus"></i></a></div></div></div><div class="row" ng-show="!ctrl.showCalendar && (ctrl.serviceName==null || ctrl.serviceName==\'\')"><div class="col-md-4"><div class=""><label class="calendartext" ng-bind="\'SelectServicePlz\' | translate"></label></div></div></div></div></div><div class="btn-holder visible-xs" ng-show="ctrl.serviceName==null || ctrl.serviceName==\'\' || ctrl.dentistName==null || ctrl.dentistName==\'\' "><a class="btn btn-lg btn-success btn-block btn-onhold" ng-bind="\'SelectServicePlz\' | translate"></a></div><div class="btn-holder visible-xs" ng-show="(ctrl.noAppointment!=true && ctrl.serviceName!=null && ctrl.serviceName!=\'\' && ctrl.dentistName!=null && ctrl.dentistName!=\'\')  && (ctrl.selectedDate==null || ctrl.selectedDate==\'\')"><a class="btn btn-lg btn-success btn-block btn-onhold" ng-bind="\'SelectDateTime\' | translate"></a></div><div class="btn-holder visible-xs" ng-show="(ctrl.noAppointment==true &&  ((ctrl.nextTime.length==0 || ctrl.nextTime==null) && (ctrl.prevTime.length==0||ctrl.prevTime==null)) && ctrl.serviceName!=null && ctrl.serviceName!=\'\' && ctrl.dentistName!=null && ctrl.dentistName!=\'\')  && (ctrl.selectedDate==null || ctrl.selectedDate==\'\')"><a class="btn btn-lg btn-success btn-block btn-onhold" ng-bind="\'NOAPPOINTMENT\' | translate"></a></div><div class="btn-holder visible-xs" ng-show="(ctrl.noAppointment==true && ((ctrl.nextTime.length!=0 && ctrl.nextTime!=null) || (ctrl.prevTime.length!=0 && ctrl.prevTime!=null)) && ctrl.serviceName!=null && ctrl.serviceName!=\'\' && ctrl.dentistName!=null && ctrl.dentistName!=\'\')  && (ctrl.selectedDate==null || ctrl.selectedDate==\'\')"><a class="btn btn-lg btn-success btn-block btn-onhold" ng-bind="\'TeimframeNoFree\' | translate"></a></div><div class="btn-holder visible-xs" ng-show="(ctrl.serviceName!=null && ctrl.serviceName!=\'\') && (ctrl.dentistName!=null && ctrl.dentistName!=\'\')  && (ctrl.selectedDate!=null && ctrl.selectedDate!=\'\') && (ctrl.dentistName!=\'Show All Appointments\' && ctrl.dentistName!=\'Alle aposments anzeigen\')"><a ng-click="ctrl.gotodetail()" class="btn btn-lg btn-success btn-block">Weiter</a></div></div><div ng-show="ctrl.isStandaloneBooking" class="col-md-2"></div><div id="detailsblock" ng-class="ctrl.isStandaloneBooking ? (\'col-md-8\' + ((ctrl.serviceName == null || ctrl.serviceName == \'\') ? \'standalone-hide-on-load\' : \'\')) : \'col-md-3\'" class="hidden-xs" ng-cloak><div id="appointment" class="appointment"><div class="scroller_anchor"></div><div class="scroller" ng-class=" ctrl.isStandaloneBooking ? \'standalone-scroller\' : \'col-md-9\'" ng-show="(ctrl.serviceName!=null && ctrl.serviceName!=\'\') && (ctrl.dentistName!=null && ctrl.dentistName!=\'\')  && (ctrl.selectedDate!=null && ctrl.selectedDate!=\'\') && (ctrl.dentistName!=\'Show All Appointments\' && ctrl.dentistName!=\'Alle aposments anzeigen\')"><h5 ng-bind="\'APPOINTMENT\' | translate"></h5><p ng-class="ctrl.isStandaloneBooking? \'standalone-width-70\':\'\'"><custom ng-bind="ctrl.selectedServiceObject != null && ctrl.selectedServiceObject.customName != null && ctrl.selectedServiceObject.customName != \'\' ? ctrl.selectedServiceObject.customName : ctrl.serviceName | translate" ng-class=" ctrl.isStandaloneBooking ? \'standalone-txt-selected\' : \'txt_selected front\'"></custom><!-- <custom ng-bind="\'WITH\' | translate"></custom> --><custom ng-bind="ctrl.dentistName" ng-class=" ctrl.isStandaloneBooking ? \'standalone-txt-selected\' : \'txt_selected front\'"></custom><!-- <custom ng-bind="\'ON\' | translate"></custom> --><custom ng-bind="ctrl.selectedDate | date:\'dd. MMMM yyyy\'" ng-class=" ctrl.isStandaloneBooking ? \'standalone-txt-selected\' : \'txt_selected front\'"></custom><!-- <custom ng-bind="\'AT\' | translate"> </custom> --><custom ng-bind="ctrl.selectedTime | date:\'H:mm\'" ng-class=" ctrl.isStandaloneBooking ? \'standalone-txt-selected\' : \'txt_selected front\'"></custom></p><a ng-click="ctrl.gotodetail()" class="btn btn-info confirmation_btn" ng-class="ctrl.isStandaloneBooking ? \'standalone-button-weiter\' : \'\'">{{\'WANT\' | translate}}</a></div><div class="scroller" ng-class=" ctrl.isStandaloneBooking ? \'standalone-scroller\' : \'col-md-9\'" ng-show="(ctrl.serviceName!=null && ctrl.serviceName!=\'\') && (ctrl.dentistName!=null && ctrl.dentistName!=\'\')  && (ctrl.selectedDate!=null && ctrl.selectedDate!=\'\') &&  (ctrl.dentistName==\'Show All Appointments\'  || ctrl.dentistName==\'Alle aposments anzeigen\')"><h5 ng-bind="\'APPOINTMENT\' | translate"></h5><p ng-class="ctrl.isStandaloneBooking? \'standalone-width-70\':\'\'"><custom ng-bind="ctrl.selectedServiceObject != null && ctrl.selectedServiceObject.customName != null && ctrl.selectedServiceObject.customName != \'\' ? ctrl.selectedServiceObject.customName : ctrl.serviceName | translate" ng-class=" ctrl.isStandaloneBooking ? \'standalone-txt-selected\' : \'txt_selected\'"></custom><custom ng-bind="\'ON\' | translate"></custom><custom ng-bind="ctrl.selectedDate | date:\'dd. MMMM yyyy\'" ng-class=" ctrl.isStandaloneBooking ? \'standalone-txt-selected\' : \'txt_selected\'"></custom><custom ng-bind="\'AT\' | translate"></custom><custom ng-bind="ctrl.selectedTime | date:\'H:mm\' " ng-class=" ctrl.isStandaloneBooking ? \'standalone-txt-selected\' : \'txt_selected\'"></custom></p><a ng-click="ctrl.gotodetail()" class="btn btn-info confirmation_btn" ng-class="ctrl.isStandaloneBooking ? \'standalone-button-weiter\' : \'\'">{{\'WANT\' | translate}}</a></div><div class="scroller" ng-class=" ctrl.isStandaloneBooking ? \'standalone-scroller\' + ((ctrl.serviceName == null || ctrl.serviceName == \'\') ? \' standalone-hide-on-load\' : \'\') : \'col-md-9\'" ng-show="ctrl.serviceName==null || ctrl.serviceName==\'\' || ctrl.dentistName==null || ctrl.dentistName==\'\' "><h5 ng-show="!ctrl.isStandaloneBooking" ng-class="ctrl.isStandaloneBooking? \'standalone-center\':\'\'" ng-bind="\'SelectServicePlz\' | translate"></h5><h5 ng-show="ctrl.isStandaloneBooking" ng-class="ctrl.isStandaloneBooking? \'standalone-center\':\'\'">Bitte w\xE4hlen Sie zuerst eine Behandlung aus dem Dropdown-Men\xFC</h5></div><div class="scroller" ng-class=" ctrl.isStandaloneBooking ? \'standalone-scroller \' : \'col-md-9\'" ng-show="(ctrl.noAppointment!=true && ctrl.serviceName!=null && ctrl.serviceName!=\'\' && ctrl.dentistName!=null && ctrl.dentistName!=\'\')  && (ctrl.selectedDate==null || ctrl.selectedDate==\'\')"><h5 ng-class="ctrl.isStandaloneBooking? \'standalone-center\':\'\'" ng-bind="\'SelectDateTime\' | translate"></h5></div><div class="scroller" ng-class=" ctrl.isStandaloneBooking ? \'standalone-scroller \' : \'col-md-9\'" ng-show="(ctrl.noAppointment==true &&  ((ctrl.nextTime.length==0 || ctrl.nextTime==null) && (ctrl.prevTime.length==0||ctrl.prevTime==null)) && ctrl.serviceName!=null && ctrl.serviceName!=\'\' && ctrl.dentistName!=null && ctrl.dentistName!=\'\')  && (ctrl.selectedDate==null || ctrl.selectedDate==\'\')"><h5 ng-class="ctrl.isStandaloneBooking? \'standalone-center\':\'\'" ng-bind="\'NOAPPOINTMENT\' | translate"></h5></div><div class="scroller" ng-class=" ctrl.isStandaloneBooking ? \'standalone-scroller \' : \'col-md-9\'" ng-show="(ctrl.noAppointment==true && ((ctrl.nextTime.length!=0 && ctrl.nextTime!=null) || (ctrl.prevTime.length!=0 && ctrl.prevTime!=null)) && ctrl.serviceName!=null && ctrl.serviceName!=\'\' && ctrl.dentistName!=null && ctrl.dentistName!=\'\')  && (ctrl.selectedDate==null || ctrl.selectedDate==\'\')"><h5 ng-class="ctrl.isStandaloneBooking? \'standalone-center\':\'\'" ng-bind="\'TeimframeNoFree\' | translate"></h5></div></div></div></div></div></div></div><script>$(document).ready(function () {\n\n        var icons = {\n            header: "a",\n            activeHeader: "b"\n        };\n\n        $("#accordion").accordion({\n            icons: icons,\n            collapsible: true,\n            active: false,\n            heightStyle: "content"\n        });\n\n        jQuery(\'.breadcrumb li\').zIndexOrder({\n            startIndex: 0,\n            reverse: true\n        });\n\n        jQuery(\'.inner_block\').sameHeight({\n            elements: \'.services_inner\',\n            flexible: true,\n            multiLine: true\n        });\n\n    });</script>');
$templateCache.put('templates/kovo-booking.html','<script>$(document).ready(function () {\n    var nav = 0;\n    if($(\'#about-us-block\').length>0)\n    {\n        nav = $(\'#about-us-block\').offset().top\n    }\n    $(\'html, body\').animate({\n        scrollTop: nav\n    }, \'slow\');\n});</script><div class="about-us-block backgrey"><section id="offermplantat"><div class="container" style="padding-bottom:50px;margin-top:30px;text-align:left"><div class="row"><div class="col-md-offset-2 col-md-8 howto" style="background:white;border-color:#00b4bf"><p class="green">Der <strong>Kennenlern-Termin</strong></p><p class="green">Sie werden beim ersten Termin den Zahnarzt kennenlernen und sich definitiv f\xFCr das Angebot entscheiden. Dieser Termin ist f\xFCr Sie kostenlos.</p><p class="green">Der Zahnarzt wird bei diesem Treffen eine Einsch\xE4tzung der Situation vornehmen, entscheiden, ob die gew\xE4hlte Behandlung sinnvoll ist und die Kosten best\xE4tigen.</p></div></div><div class="row"><div class="col-md-offset-2 col-md-8 divisionpad whiteedge"><h2 class="ser-title">Ihr gew\xFCnschtes Produkt</h2><div class="grid-container" style="min-height: 440px"><div ng-show="ctrl.offer.labPrice" class="grid-item"><img src="img/crown.png" style="width:65px"></div><div ng-show="ctrl.offer.labPrice" class="grid-item grid1" ng-bind-html="ctrl.offer.labText"></div><div ng-show="ctrl.offer.labPrice" class="grid-item grid1"><p class="strikethrough zeromargin" ng-show="ctrl.offer.labDiscount" ng-bind="ctrl.offer.labPrice | currency:undefined:0"></p><p class="blue" ng-bind="ctrl.offer.labFinalPrice | currency:undefined:0"></p></div><div ng-show="ctrl.offer.prosthesisPrice" class="grid-item grid1"><img src="img/prosthesis.png" style="width:65px"></div><div ng-show="ctrl.offer.prosthesisPrice" class="grid-item grid1" ng-bind-html="ctrl.offer.prosthesisText"></div><div ng-show="ctrl.offer.prosthesisPrice" class="grid-item grid1"><p class="strikethrough zeromargin" ng-show="ctrl.offer.prosthesisDiscount" ng-bind="ctrl.offer.prosthesisPrice | currency:undefined:0"></p><p class="blue" ng-bind="ctrl.offer.prosthesisFinalPrice | currency:undefined:0"></p></div><div ng-show="ctrl.offer.implantPrice" class="grid-item">+</div><div ng-show="ctrl.offer.implantPrice" class="grid-item"></div><div ng-show="ctrl.offer.implantPrice" class="grid-item">+</div><div ng-show="ctrl.offer.implantPrice" class="grid-item"><img src="img/implant.png" style="width:35px"></div><div ng-show="ctrl.offer.implantPrice" class="grid-item grid2" ng-bind-html="ctrl.offer.implantText"></div><div ng-show="ctrl.offer.implantPrice" class="grid-item grid2"><p class="strikethrough zeromargin" ng-show="ctrl.offer.implantDiscount" ng-bind="ctrl.offer.implantPrice | currency:undefined:0"></p><p class="blue" ng-bind="ctrl.offer.implantFinalPrice | currency:undefined:0"></p></div><div ng-show="ctrl.offer.dentistPrice" class="grid-item">+</div><div ng-show="ctrl.offer.dentistPrice" class="grid-item"></div><div ng-show="ctrl.offer.dentistPrice" class="grid-item">+</div><div ng-show="ctrl.offer.dentistPrice" class="grid-item bigger"><img src="img/dentalchair.png" style="width:90px"></div><div ng-show="ctrl.offer.dentistPrice" class="grid-item" style="min-height:60px" ng-bind-html="ctrl.offer.dentistText"></div><div ng-show="ctrl.offer.dentistPrice" class="grid-item"><p class="strikethrough zeromargin" ng-show="ctrl.offer.dentistDiscount" ng-bind="ctrl.offer.dentistPrice | currency:undefined:0"></p><p class="blue" ng-bind="ctrl.offer.dentistFinalPrice | currency:undefined:0"></p></div><div class="grid-item finishline"></div><div class="grid-item finishline"></div><div class="grid-item finishline"></div><div class="grid-item bigger"><h1 class="green">Fixpreis:</h1></div><div class="grid-item"></div><div class="grid-item"><p class="strikethrough zeromargin" ng-show="ctrl.offer.originalPrice" ng-bind="ctrl.offer.originalPrice | currency:undefined:0"></p><h1 class="green" style="padding:0" ng-bind="ctrl.offer.finalPrice | currency:undefined:0"></h1></div></div></div></div><div class="row"><div class="col-md-offset-2 col-md-8 divisionpad whiteedge" style="padding-bottom:30px"><div class="row"><h2 class="ser-title">Ihr Leistungserbringer</h2><div class="col-md-6"><h1 ng-bind="ctrl.offer.practiceName"></h1><p class="blue" ng-repeat="quality in ctrl.offer.practiceQualities.split(\'\\\\\')" ng-bind="\'\u2713 \' + quality"></p></div><div class="col-md-6"><img ng-src="{{ctrl.offer.practiceMapUrl}}"></div></div></div></div><div class="row"><div class="col-md-offset-1 col-md-10 divisionpad"><form id="kovo-form" novalidate="" name="KovoForm" ng-submit="ctrl.submit(KovoForm)" role="form" style="display: block"><div class="row"><div class="col-md-offset-2 col-md-8 howto" style="background:white"><p>Wir werden Sie f\xFCr die Termin-Vereinbarung telefonisch kontaktieren. Dazu bitten wir Sie, erneut Ihre Telefonnummer anzugeben.</p><table><tbody class="summarybox"><tr><th>Mobile:</th><th><input type="text" name="phone" ng-pattern="/^\\+?[0-9 ]*$/" ng-maxlength="25" ng-class="{ \'wrong_info\' : (KovoForm.phone.$invalid && ctrl.formSubmitted), \'\' :(KovoForm.phone.$valid && ctrl.formSubmitted)}" ng-model="ctrl.offer.booking.phone" class="form-control inputlength" placeholder="Bitte Telefonnummer erneut eingeben" required> <span ng-show="KovoForm.phone.$invalid && ctrl.formSubmitted" class="error-message-detail"><em>Bitte ausf\xFCllen.</em></span> <span ng-show="KovoForm.phone.$error.pattern" class="error-message-detail"><em>Bitte nur Zahlen und Plus (+) verwenden, z.B. 044 123 45 67 oder +41 44 123 45 67 .</em></span> <span ng-show="KovoForm.phone.$error.maxlength" class="error-message-detail"><em>Bitte nicht mehr als 25 Zeichen verwenden.</em></span></th></tr></tbody></table></div></div><div class="row"><div class="col-md-offset-2 col-md-8 divisionpad"><div class="form-group row" style="padding:20px;padding-bottom:0; text-align:left"><table><tbody><tr><th><label class="checkbox" style="display: inline-block"><input name="consult" type="checkbox" style="float: left" checked="checked" disabled="disabled"> <span class="checkmark"></span></label></th><th><div>Kostenloser Kennenlern-Termin: Sie werden den Zahnarzt w\xE4hrend 15 Minuten kennenlernen und sich definitiv f\xFCr das Angebot entscheiden.</div></th></tr></tbody></table></div><div class="form-group row" style="padding:20px;padding-bottom:0; text-align:left"><table><tbody><tr><th><label class="checkbox" style="display: inline-block"><input name="installmentDesired" type="checkbox" style="float: left" ng-model="ctrl.offer.booking.installmentDesired"> <span class="checkmark"></span></label></th><th><div>Ich w\xFCnsche Ratenzahlung</div></th></tr></tbody></table></div><div class="form-group row" style="padding:20px; padding-top:0;text-align:left"><table><tbody><tr><th><label class="checkbox" style="display: inline-block"><input name="termsAccepted" required type="checkbox" style="float: left" ng-model="ctrl.offer.booking.termsAccepted" ng-class="{ \'wrong_info\' : (KovoForm.termsAccepted.$invalid && ctrl.formSubmitted), \'\' :(KovoForm.termsAccepted.$valid && ctrl.formSubmitted)}"> <span class="checkmark"></span></label></th><th><div>Ich best\xE4tige, die <a class="ls-modal-inline" href="" data-text="- Der erste Termin ist kostenlos.\n- Bei unerkl\xE4rtem Nichterscheinen wird der Preis der Behandlung in der H\xF6he von CHF 100.- in Rechnung gestellt.\n- Kostenfreie Terminstornierung bis 48 Stunden vor Terminbeginn.">Terminbestimmungen</a> gelesen und akzeptiert zu haben.</div><span ng-show="KovoForm.termsAccepted.$invalid && ctrl.formSubmitted" class="error-message-detail"><em ng-bind="\'PleaseConfirm\' | translate"></em></span></th></tr></tbody></table></div><div class="finishbtn"><button type="submit" ng-show="!ctrl.bookingSuccess" ng-disabled="ctrl.validBookingSubmitted" class="btn btn-info confirmation_btn" style="min-width:250px;margin-top:20px">Kennenlern-Termin anfordern</button><p ng-show="ctrl.bookingSuccess" class="blue">Vielen Dank! Wir werden Sie in K\xFCrze f\xFCr eine Termin-Vereinbarung telefonisch kontaktieren.</p></div></div></div><div class="row"><div class="col-md-offset-2 col-md-8 divisionpad"><p>- Dieser Service von Zumedo ist f\xFCr Sie kostenlos.</p><p></p><p>- Name und Adresse der Praxis und des Praktizierenden wird Ihnen bei der Terminvereinabrung mitgeteilt und schriftlich bei der Terminbest\xE4tigung zugesendet.</p><p ng-bind="\'- \' + (ctrl.offer.offerDisclaimer ? ctrl.offer.offerDisclaimer : \'Allf\xE4lliger Mehraufwand, der durch Ihre individuelle Situation entsteht (bspw. fehlender Knochen, unerwartete Komplikationen), wird Ihnen beim Kennenlern-Termin vom Zahnarzt kommuniziert.\')"></p></div></div></form></div></div></div></section></div>');
$templateCache.put('templates/kovo-done.html','<style class="hide-on-print">.done-horizontal-lines {\n\tmargin-top:15px; \n\tmargin-bottom: 15px;\n\theight:1px; \n\twidth: 100%; \n\tborder-top: solid 2px #000;\n}\n\n.done-template-container {\n\tbackground:#F3F3F3;\n\twidth: 100%;\n\tjustify-content: center;\n\ttext-align: center;\n\tdisplay: inline-block;\n\tfont-familiy: lato;\n\tfont-size: 22px;\n\tpadding: 20px;\n\tz-index: 998;\n\tposition:relative;\n}\n@media(min-width: 479px) {\n\t.done-booking-info-block {\n\t\tbackground:#ffffff;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 40%;\n\t\tdisplay: inline-block;\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t\tpadding-top: 15px;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 50px;\n\t\tfont-size: 18px;\n\t}\n\t.done-booking-info-block-height {\n\t\theight: 500px;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-booking-info-block {\n\t\tbackground:#ffffff;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 100%;\n\t\tdisplay: inline-block;\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t\tpadding-top: 15px;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 50px;\n\t\tfont-size: 18px;\n\t}\n\t.done-booking-info-block-height {\n\t\theight: 500px;\n\t}\n}\n\n@media(min-width: 479px) {\n\t.done-second-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: center;\n\t\twidth: 60%;\n\t\tdisplay: inline-block;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-second-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: center;\n\t\twidth: 90%;\n\t\tdisplay: inline-block;\n\t\tmargin-bottom: 0px;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(min-width: 479px) {\n\t.done-third-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 60%;\n\t\tdisplay: inline-block;\n\t\tmargin-bottom: 80px;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-third-block {\n\t\tbackground:transparent;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\twidth: 90%;\n\t\tdisplay: inline-block;\n\t\tmargin-bottom: 80px;\n\t\tfont-size: 17px;\n    \tline-height: 1.29;\n\t\tword-spacing: 1px;\n\t\tfont-family: \'Lato\', sans-serif;\n    \t-webkit-font-smoothing: antialiased;\n    \tfont-weight: 300;\n\t}\n}\n\n@media(min-width: 479px) {\n\t.done-page-image {\n\t\tposition: absolute;\n\t\topacity: 1;\n\t\theight: 400px;\n\t\twidth: 600px;\n\t\tleft: 50%;\n\t\ttop: 100px;\n\t}\n}\n\n@media(max-width: 479px) {\n\t.done-page-image {\n\t\tposition: absolute;\n\t\topacity: 1;\n\t\theight: 180px;\n\t\twidth: 270px;\n\t\tleft: 50%;\n\t\ttop: 320px;\n\t}\n}\n\n.hide-on-print {\n\tdisplay: visible;\n}\n\n.show-on-print {\n\tdisplay: none;\n}\n\n@media print {\n\t@page { margin: 0; }\n\t\n\t#footer { display: none; }\n\n\t.done-template-container {\n\t\tvisibility: visible;\n\t\tdisplay: block;\n\t\tposition:absolute;\n\t\ttop: 0px;\n\t\tleft: 0px;\n\t}\n\t\n\t.done-booking-info-block {\n\t\twidth: 90%;\n\t\tfont-size: 16px;\n\t\theight: 450px;\n\t\tmargin-top:100px;\n\t\t\n\t\tbackground:#ffffff;\n\t\tfloat: center;\n\t\ttext-align: left;\n\t\tdisplay: inline-block;\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t\tpadding-top: 15px;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 50px;\n\t}\n\t\n\t.done-second-block {\n\t \twidth: 90%;\n\t \tfont-size: 16px;\n\t \theight: 80px;\n\t}\n\t\n\t.done-third-block {\n\t \twidth: 90%;\n\t \tfont-size: 16px;\n\t}\n\t\n\t.hide-on-print {\n\t    display:none !important;\n\t}\n\t\n\t\n\t.show-on-print {\n\t    display:visible;\n\t}\n\t\n\t\n\t.done-page-image {\n\t\tdisplay: none !important;\n\t}\n\t\n\t#wrapper {\n\t    overflow: inherit;\n\t}\n\t\n\t#wrapper * {\n\t    display: none;\n\t}\n\t\n\t#wrapper #js-bottom-block, #wrapper #js-bottom-block * {\n\t    display: inline-block;\n\t}\n}</style><script>$(document).ready(function () {\n\tvar nav = 0;\n\tif($(\'#done-template-container\').length>0)\n\t{\n\t\tnav = $(\'#done-template-container\').offset().top\n\t}\n    $(\'html, body\').animate({\n        scrollTop: nav\n    }, \'slow\');\n});</script><div id="print" class="forfooter done-template-container"><div class="done-booking-info-block done-booking-info-block-height"><img class="done-page-image" src="/booking/img/done-page-photo.png"><custom style="color: black">Wir haben Ihre Best\xE4tigung erhalten!</custom><br><br><br><custom style="color: black;margin-left:3px">Anliegen:</custom><br><custom ng-bind="ctrl.offer.offerInquiry" style="white-space: pre-wrap;color: black;margin-left:3px"></custom><div class="done-horizontal-lines"></div><custom ng-bind="ctrl.offer.practiceName" style="color: black"></custom><div class="done-horizontal-lines"></div><custom ng-bind="ctrl.offer.labText" style="color: black; margin-left:3px"></custom><div class="done-horizontal-lines"></div><custom ng-bind="ctrl.offer.implantText" style="color: black; margin-left:3px"></custom><div class="done-horizontal-lines" ng-show="!ctrl.isStandaloneBooking"></div><custom style="color: black; margin-left:3px"></custom><div class="done-horizontal-lines"></div><custom style="color: black">Fixpreis:</custom><br><custom ng-bind="ctrl.offer.dentistFinalPrice | currency:undefined:0" style="color: black; margin-left:3px"></custom><div class="done-horizontal-lines"></div></div><br><div class="done-second-block"><p>Wir werden Sie in K\xFCrze f\xFCr eine Termin-Vereinbarung telefonisch kontaktieren.</p><br></div><div class="done-third-block">Bitte beachten Sie die Terminbestimmungen:<br><div>&nbsp;&nbsp;&nbsp;&nbsp;<custom>- Der erste Termin ist kostenlos.</custom></div><div>&nbsp;&nbsp;&nbsp;&nbsp;<custom>- Jedoch wird bei unerkl\xE4rtem Nichterscheinen der Preis der Behandlung in der H\xF6he von CHF 100.- in Rechnung gestellt.</custom></div><div>&nbsp;&nbsp;&nbsp;&nbsp;<custom>- Kostenfreie Terminstornierung bis 48 Stunden vor Terminbeginn.</custom></div></div></div>');
$templateCache.put('templates/kovo-offer.html','<div class="about-us-block"><section id="Info_Implantat"><div class="container" style="padding-bottom:50px;margin-top:30px;text-align:left"><div class="row"><div class="col-md-offset-2 col-md-8" style="padding:20px 0 -10px 10px"><p ng-bind="\'Pers\xF6nliche Offerten f\xFCr \' + ctrl.kovoOffers[0].name + \', g\xFCltig bis \' + ctrl.kovoOffers[0].validUntil + \':\'"></p><p>Anliegen:</p><p style="white-space: pre-wrap" ng-bind="ctrl.kovoOffers[0].offerInquiry"></p></div></div><div class="row" ng-repeat="offer in ctrl.kovoOffers | orderBy:\'offerNumber\' "><div class="col-md-offset-2 col-md-8 offer"><div class="row"><div class="col-md-5" style="padding-left:30px"><h1 ng-bind="offer.practiceName"></h1><p class="green zeromargin">Fixpreis:</p><p class="strikethrough" ng-show="offer.originalPrice" ng-bind="offer.originalPrice | currency:undefined:0"></p><h4 class="" ng-bind="offer.finalPrice | currency:undefined:0"></h4><p class="blue" ng-repeat="quality in offer.practiceQualities.split(\'\\\\\')" ng-bind="\'\u2713 \' + quality"></p></div><div class="col-md-7"><div class="grid-container" style="min-height: 320px"><div ng-show="offer.labPrice" class="grid-item"><img src="img/crown.png" style="width:65px"></div><div ng-show="offer.labPrice" class="grid-item grid1" ng-bind-html="offer.labText"></div><div ng-show="offer.labPrice" class="grid-item grid1"><p class="strikethrough zeromargin" ng-show="offer.labDiscount" ng-bind="offer.labPrice | currency:undefined:0"></p><p class="blue" ng-bind="offer.labFinalPrice | currency:undefined:0"></p></div><div ng-show="offer.prosthesisPrice" class="grid-item grid1"><img src="img/prosthesis.png" style="width:65px"></div><div ng-show="offer.prosthesisPrice" class="grid-item grid1" ng-bind-html="offer.prosthesisText"></div><div ng-show="offer.prosthesisPrice" class="grid-item grid1"><p class="strikethrough zeromargin" ng-show="offer.prosthesisDiscount" ng-bind="offer.prosthesisPrice | currency:undefined:0"></p><p class="blue" ng-bind="offer.prosthesisFinalPrice | currency:undefined:0"></p></div><div ng-show="offer.implantPrice" class="grid-item">+</div><div ng-show="offer.implantPrice" class="grid-item"></div><div ng-show="offer.implantPrice" class="grid-item">+</div><div ng-show="offer.implantPrice" class="grid-item"><img src="img/implant.png" style="width:35px"></div><div ng-show="offer.implantPrice" class="grid-item grid2" ng-bind-html="offer.implantText"></div><div ng-show="offer.implantPrice" class="grid-item grid2"><p class="strikethrough zeromargin" ng-show="offer.implantDiscount" ng-bind="offer.implantPrice | currency:undefined:0"></p><p class="blue" ng-bind="offer.implantFinalPrice | currency:undefined:0"></p></div><div ng-show="offer.dentistPrice" class="grid-item">+</div><div ng-show="offer.dentistPrice" class="grid-item"></div><div ng-show="offer.dentistPrice" class="grid-item">+</div><div ng-show="offer.dentistPrice" class="grid-item bigger"><img src="img/dentalchair.png" style="width:90px"></div><div ng-show="offer.dentistPrice" class="grid-item" style="min-height:60px" ng-bind-html="offer.dentistText"></div><div ng-show="offer.dentistPrice" class="grid-item"><p class="strikethrough zeromargin" ng-show="offer.dentistDiscount" ng-bind="offer.dentistPrice | currency:undefined:0"></p><p class="blue" ng-bind="offer.dentistFinalPrice | currency:undefined:0"></p></div></div></div></div><div class="row"><div class="col-md-5 imgsetting"><img ng-src="{{offer.qualityImageUrl ? offer.qualityImageUrl : \'img/ch-product.png\'}}" style="width:250px;padding-bottom:40px" ng-show="offer.showCHFlag"></div><div class="col-md-7"><div class="offertbtn"><a class="btn btn-info confirmation_btn" style="min-width:200px;margin-top:20px" ng-click="ctrl.selectOffer(offer)">> Zur Offerte</a></div></div></div></div></div></div></section><section id="sogehts" style="background:#F3F3F3"><div class="container"><div class="row"><div class="col-md-12"><h2 class="ser-title">So funktioniert\u2019s</h2><p class="p-first">In vier Schritten zu Ihrem neuen Implantat</p></div><div class="row hidden-xs first-row-in-about"><div class="col-md-3 col-sm-3"><img src="img/icons/behandlung.svg"><p><strong>1. Offerten vergleichen</strong></p><p>Vergleichen Sie die erhaltenen Offerten. Sie finden viele Angaben zur Behandlung, zu den verwendeten Materialien sowie zum Behandler selbst.</p></div><div class="col-md-3 col-sm-3"><img src="img/icons/online_prsenz.svg"><p><strong>2. Angebot w\xE4hlen</strong></p><p>Sobald Sie sich f\xFCr ein Angebot entschieden haben, w\xE4hlen Sie dieses aus und geben an, ob Sie Ratenzahlung w\xFCnschen.</p></div><div class="col-md-3 col-sm-3"><img src="img/icons/qual.svg"><p><strong>3. Termin vereinbaren</strong></p><p>Nachdem Sie ein Angebot ausgew\xE4hlt haben, werden wir Sie f\xFCr einen Termin kontaktieren. Danach erhalten Sie eine E-Mail mit allen wichtigen Angaben zur Zahnarzt-Praxis. So sind Sie bestens f\xFCr den Besuch vorbereitet und informiert.</p></div><div class="col-md-3 col-sm-3"><img src="img/icons/gesund.svg"><p><strong>4. Zahnarzt besuchen</strong></p><p>Der Zahnarzt wird bei Ihrem Besuch noch eine vertiefte Einsch\xE4tzung der Lage vornehmen. Sie werden bestm\xF6glich \xFCber die Behandlung und deren Alternativen aufgekl\xE4rt, sodass Sie mit dem Zahnarzt die optimale Behandlung beginnen k\xF6nnen.</p></div></div></div><div id="myCarousel" class="row visible-xs first-row-xs carousel slide first-row-in-about" data-interval="false"><div class="col-xs-12 center-col-carousel"><!-- Wrapper for slides --><div class="carousel-inner"><div class="item active text-center"><img src="img/icons/behandlung.svg"><p><strong>1. Offerten vergleichen</strong></p><p>Vergleichen Sie die erhaltenen Offerten. Sie finden viele Angaben zur Behandlung, zu den verwendeten Materialien sowie zum Behandler selbst.</p></div><div class="item text-center"><img src="img/icons/online_prsenz.svg"><p><strong>2. Angebot w\xE4hlen</strong></p><p>Sobald Sie sich f\xFCr ein Angebot entschieden haben, w\xE4hlen Sie dieses aus und geben an, ob Sie Ratenzahlung w\xFCnschen.</p></div><div class="item text-center"><img src="img/icons/qual.svg"><p><strong>3. Termin vereinbaren</strong></p><p>Nachdem Sie ein Angebot ausgew\xE4hlt haben, werden wir Sie f\xFCr einen Termin kontaktieren. Danach erhalten Sie eine E-Mail mit allen wichtigen Angaben zur Zahnarzt-Praxis. So sind Sie bestens f\xFCr den Besuch vorbereitet und informiert.</p></div><div class="item text-center"><img src="img/icons/gesund.svg"><p><strong>4. Zahnarzt besuchen</strong></p><p>Der Zahnarzt wird bei Ihrem Besuch noch eine vertiefte Einsch\xE4tzung der Lage vornehmen. Sie werden bestm\xF6glich \xFCber die Behandlung und deren Alternativen aufgekl\xE4rt, sodass Sie mit dem Zahnarzt die optimale Behandlung beginnen k\xF6nnen.</p></div></div></div><div class="left-arrow-carousel"><span onclick="" class="left fa fa-chevron-left" href="#myCarousel" data-slide="prev"></span> <span onclick="" class="right fa fa-chevron-right" href="#myCarousel" data-slide="next"></span></div><!-- Indicators --><ol class="carousel-indicators"><li data-target="#myCarousel" data-slide-to="0" class="active first-indicator"></li><li data-target="#myCarousel" data-slide-to="1"></li><li data-target="#myCarousel" data-slide-to="2"></li><li data-target="#myCarousel" data-slide-to="3"></li></ol></div></div></section><!--        <section id="welchebehandlung" >\n                    <div class="container">\n                        <div class="row">\n                            <div class="col-md-12">\n                                <h2 class="ser-title">Wie setzen sich Zahnarztpreise zusammen?</h2>\n                                <p class="p-first"></p>\n                            </div>\n                        </div>\n                        <div class="row third-row-in-about">\n                            <div class="col-md-6 col-sm-6 col-xs-12">\n                                <div class="more-features-box">\n                                    <div class="more-features-box-text">\n                                        <div class="more-features-box-text-icon">\n                                            <i class="fa fa-angle-right" aria-hidden="true"></i>\n                                        </div>\n                                        <div class="more-features-box-text-description">\n                                            <h3>Zahnschmerzen oder Unfall: Zahn abgebrochen!</h3>\n                                            <p>Buchen Sie den n\xE4chsten freien Termin bei einem Zahnarzt.</p>\n                                            <div class="aligna"><a class="citylink" href="/zahnarzt/zuerich/suche?treatment=EMERGENCY_NEW">N\xE4chsten freien Termin suchen</a></div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="col-md-6 col-sm-6 col-xs-12">\n                                <div class="more-features-box-text">\n                                    <div class="more-features-box-text-icon">\n                                        <i class="fa fa-angle-right" aria-hidden="true"></i>\n                                    </div>\n                                    <div class="more-features-box-text-description">\n                                        <h3>Ich bin neu in der Stadt und suche einen Zahnarzt.</h3>\n                                        <p>Melden Sie sich f\xFCr einen Zahn-Check / eine Kontrolle an. </p>\n                                        <div class="aligna"><a class="citylink" href="/zahnarzt/zuerich/suche?treatment=CHECK_UP_NEW">Termin Zahn-Check/Kontrolle suchen</a></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    <!--    <div class="row third-row-in-about second-row hidden-xs">\n                            <div class="col-md-6 col-sm-6 col-xs-12">\n                                <a class="btn" href="">N\xE4chsten freien Termin suchen</a>\n                            </div>\n                            <div class="col-md-6 col-sm-6 col-xs-12">\n                                <a class="btn" href="">Termin Zahn-Check/Kontrolle suchen</a>\n                            </div>\n                        </div> --><!--    <div class="row third-row-in-about">\n                            <div class="col-md-6 col-sm-6 col-xs-12">\n                                <div style="visibility: visible;" class="more-features-box">\n                                    <div class="more-features-box-text">\n                                        <div class="more-features-box-text-icon">\n                                            <i class="fa fa-angle-right" aria-hidden="true"></i>\n                                        </div>\n                                        <div class="more-features-box-text-description">\n                                            <h3>Ich war schon lange nicht mehr beim Zahnarzt. </h3>\n                                            <p>Zumedo bietet auch Kombinationsangebote: Dentalhygiene, R\xF6ntgenbilder und Kurzkontrolle.</p>\n                                            <div class="aligna"><a class="citylink" href="/zahnarzt/zuerich/suche?treatment=CHECK_UP_HYGIENE">Termin Dentalhygiene & Kontrolle suchen</a></div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="col-md-6 col-sm-6 col-xs-12">\n                                <div class="more-features-box-text">\n                                    <div class="more-features-box-text-icon">\n                                        <i class="fa fa-angle-right" aria-hidden="true"></i>\n                                    </div>\n                                    <div class="more-features-box-text-description">\n                                        <h3>Ich gehe h\xE4ufig zum Zahnarzt und m\xF6chte meine Zahnhygiene verbessern.</h3>\n                                        <p>Buchen Sie den n\xE4chsten freien Termin bei einer Dentalhygienikerin oder einem Dentalhygieniker.</p>\n                                        <div class="aligna"><a class="citylink" href="/zahnarzt/zuerich/suche?treatment=DENTAL_HYGIENE">Termin Zahnreinigung suchen</a></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    <!--    <div class="row third-row-in-about second-row hidden-xs">\n                            <div class="col-md-6 col-sm-6 col-xs-12">\n                                <a class="btn" href="">Termin Dentalhygiene & Kontrolle suchen</a>\n                            </div>\n                            <div class="col-md-6 col-sm-6 col-xs-12">\n                                <a class="btn" href="">Termin Zahnreinigung suchen</a>\n                            </div>\n                        </div> --><!--    </div>\n                </section>--><section id="credentialsxs" class="visible-xs visible-sm"><div class="container testimonials"><div class="row"><div class="col-md-12"><h2 class="ser-title">Das sagen unsere Kunden</h2></div><div id="myCarousel2" class="row visible-xs visible-sm first-row-xs carousel slide first-row-in-about" data-interval="false"><div class="col-xs-12 center-col-carousel"><div class="carousel-inner"><div class="item active text-center"><div class="col-xs-12"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-10 col-sm-10"><h3>Super Service; die Preise f\xFCr meine Wurzelbehandlung und 2 Kronen auf einen Blick. Werde ich auf alle F\xE4lle weiterempfehlen.</h3><p class="downput">Anja K.</p></div></div></div></div></div><div class="item text-center"><div class="col-xs-12"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-10 col-sm-10"><h3>Zum Gl\xFCck habe ich meinen Kostenvoranschlag f\xFCr eine 4-Gliedrige Br\xFCcke bei Zumedo eingereicht. Ich konnte mehrere Tausend Franken sparen!</h3><p class="downput">Eva B.</p></div></div></div></div></div><div class="item text-center"><div class="col-xs-12"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-10 col-sm-10"><h3>Der gew\xE4hlte Zahnarzt war kompetent, freundlich und seine Offerte top!</h3><p class="downput">Maria L.</p></div></div></div></div></div><div class="item text-center"><div class="col-xs-12"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-10 col-sm-10"><h3>Ich wurde bestens beraten, sodass ich ein optimales Angebot f\xFCr mich ausw\xE4hlen konnte.</h3><p class="downput">Katharina B.</p></div></div></div></div></div><div class="item text-center"><div class="col-xs-12"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-10 col-sm-10"><h3>Endlich habe ich einen genauen \xDCberblick \xFCber die Kosten. Danke vielmals!</h3><p class="downput">Thomas G.</p></div></div></div></div></div><div class="item text-center"><div class="col-xs-12"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-10 col-sm-10"><h3>Professional, competent, and caring</h3><p class="downput">Michael O.</p></div></div></div></div></div></div><div class="left-arrow-carousel"><span onclick="" class="right fa fa-chevron-right" href="#myCarousel2" data-slide="next"></span> <span onclick="" class="left fa fa-chevron-left" href="#myCarousel2" data-slide="prev"></span></div></div></div></div></div></section><section id="credentials" class="hidden-xs hidden-sm"><div class="container testimonials"><div class="row"><div class="col-md-12"><h2 class="ser-title">Das sagen unsere Kunden</h2><p class="p-first"></p></div><div id="myCarousel23" class="row hidden-xs first-row-xs carousel slide first-row-in-about" data-interval="false"><div class="col-md-1 col-sm-1 col-xs-1 left-arrow-carousel"><span onclick="" class="left fa fa-chevron-left" href="#myCarousel23" data-slide="prev"></span></div><div class="col-md-10 col-sm-10 col-xs-10 center-col-carousel"><div class="carousel-inner"><div class="item active text-center"><div class="col-md-4 col-sm-6 col-xs-4"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-12 col-sm-10"><h3>Super Service; die Preise f\xFCr meine Wurzelbehandlung und 2 Kronen auf einen Blick. Werde ich auf alle F\xE4lle weiterempfehlen.</h3><p class="downput">Anja K.</p></div></div></div></div><div class="col-md-4 col-sm-6 col-xs-4"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-12 col-sm-12"><h3>Zum Gl\xFCck habe ich meinen Kostenvoranschlag f\xFCr eine 4-Gliedrige Br\xFCcke bei Zumedo eingereicht. Ich konnte mehrere Tausend Franken sparen!</h3><p class="downput">Eva B.</p></div></div></div></div><div class="col-md-4 col-sm-6 col-xs-4"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-12 col-sm-12"><h3>Der gew\xE4hlte Zahnarzt war kompetent, freundlich und seine Offerte top!</h3><p class="downput">Maria L.</p></div></div></div></div></div><div class="item text-center"><div class="col-md-4 col-sm-6 col-xs-4"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-12 col-sm-12"><h3>Ich wurde bestens beraten, sodass ich ein optimales Angebot f\xFCr mich ausw\xE4hlen konnte.</h3><p class="downput">Katharina B.</p></div></div></div></div><div class="col-md-4 col-sm-6 col-xs-4"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-12 col-sm-12"><h3>Endlich habe ich einen genauen \xDCberblick \xFCber die Kosten. Danke vielmals!</h3><p class="downput">Thomas G.</p></div></div></div></div><div class="col-md-4 col-sm-6 col-xs-4"><div class="testi-details"><i class="fa fa-quote-right"></i><div class="row"><div class="col-md-1 col-sm-1"></div><div class="col-md-12 col-sm-12"><h3>Professional, competent, and caring</h3><p class="downput">Michael O.</p></div></div></div></div></div></div></div><div class="col-md-1 col-sm-1 col-xs-1 right-arrow-carousel"><span onclick="" class="right fa fa-chevron-right" href="#myCarousel23" data-slide="next"></span></div></div></div></div></section><section id="FAQKoVo"><div class="wrapper"><div class="container cd-faq"><div class="cd-faq-categories"></div><div class="row"><div class="col-md-12 col-xs-12"><h2 class="ser-title" style="margin-bottom:50px">Fragen und Antworten</h2></div></div><div class="row"><ul id="basics" class="cd-faq-group-xs"><li><a class="cd-faq-trigger-xs cd-faq-trigger" href="#0">Ich habe eine Frage an einen Zahnarzt, wie kann ich diese stellen?</a><div class="cd-faq-content-xs cd-faq-content"><p>Kontaktieren Sie uns unter 044 552 04 89 oder schreiben Sie uns Ihre Frage an info@zumedo.ch. Wir werden Sie mit dem Zahnarzt in Verbindung setzen.</p></div><!-- cd-faq-content --></li><li><a class="cd-faq-trigger-xs cd-faq-trigger" href="#0">Ich habe mich f\xFCr eine Offerte entschieden, was soll ich tun?</a><div class="cd-faq-content-xs cd-faq-content"><p>Sobald Sie sich f\xFCr eine Offerte entschieden haben, k\xF6nnen Sie einen passenden Termin buchen. Nach der Buchung erhalten Sie ein Best\xE4tigungsmail mit allen wichtigen Informationen \xFCber die Praxis. Die E-Mail erhalten Sie werktags innerhalb von einer Stunde.</p></div><!-- cd-faq-content --></li><li><a class="cd-faq-trigger-xs cd-faq-trigger" href="#0">Ich habe starke Schmerzen, was soll ich tun?</a><div class="cd-faq-content-xs cd-faq-content"><p>Bei starken Schmerzen sollten Sie umgehend einen Zahnarzt konsultieren. Auf zumedo.ch k\xF6nnen Sie direkt einen Termin buchen, um schnellst m\xF6glich behandelt zu werden.</p></div><!-- cd-faq-content --></li><li><a class="cd-faq-trigger-xs cd-faq-trigger" href="#0">Mir geht keiner der vorgeschlagenen Termine</a><div class="cd-faq-content-xs cd-faq-content"><p>Falls Ihnen keiner der vorgeschlagenen Termine geht, k\xF6nnen Sie sich telefonisch unter 044 552 04 89 melden oder per Mail an info@zumedo.ch. Wir schauen, dass Sie einen passenden Termin finden.</p></div><!-- cd-faq-content --></li><li><a class="cd-faq-trigger-xs cd-faq-trigger" href="#0">Ist dieser Service kostenlos?</a><div class="cd-faq-content-xs cd-faq-content"><p>Selbstverst\xE4ndlich ist dieser Service f\xFCr Sie kostenlos.</p></div><!-- cd-faq-content --></li><li><a class="cd-faq-trigger-xs cd-faq-trigger" href="#0">Woher ergeben sich Preisunterschiede bei den Offerten?</a><div class="cd-faq-content-xs cd-faq-content"><p>Preisunterschiede ergeben sich aus verschiedenen Labor- bzw. Materialkosten, verschiedenen Behandlungsarten, Spezialisierung und Erfahrung vom behandelnden Zahnarzt, Mieten sowie Personalkosten der Praxis (die letzten drei widerspiegeln sich im Taxpunktwert).</p></div><!-- cd-faq-content --></li><li><a class="cd-faq-trigger-xs cd-faq-trigger" href="#0">Gelten die Preise wie angegeben?</a><div class="cd-faq-content-xs cd-faq-content"><p>Ja, jedoch m\xFCssen Sie vom Zahnarzt nach Begutachtung vor Ort best\xE4tigt werden. Die angegebenen Preise gelten f\xFCr Ihre spezifische Anfrage und beziehen sich auf die von Ihnen get\xE4tigten Angaben. Zahnbehandlungen sind individuell und der Zahnarzt muss mit eigenen Augen die Angaben verifizieren, die Situation beurteilen und auch alternative Behandlungsans\xE4tze pr\xFCfen.</p></div><!-- cd-faq-content --></li><li><a class="cd-faq-trigger-xs cd-faq-trigger" href="#0">Muss ich den Betrag jetzt gleich bezahlen?</a><div class="cd-faq-content-xs cd-faq-content"><p>Bez\xFCglich Bezahlung wird Sie der Zahnarzt vor Ort informieren.</p></div><!-- cd-faq-content --></li><li><a class="cd-faq-trigger-xs cd-faq-trigger" href="#0">Kann ich in Raten zahlen?</a><div class="cd-faq-content-xs cd-faq-content"><p>Die meisten Zahnarzt-Praxen bieten diesen Service an. F\xFCr weitere Informationen k\xF6nnen Sie uns telefonisch unter 044 552 04 89 erreichen oder Ihre Anfrage per Mail an info@zumedo.ch richten.</p></div><!-- cd-faq-content --></li><li><a class="cd-faq-trigger-xs cd-faq-trigger" href="#0">Ich habe nachtr\xE4glich einen Kostenvoranschlag oder R\xF6ntgenbilder erhalten, kann ich diese auch noch einreichen?</a><div class="cd-faq-content-xs cd-faq-content"><p>Nat\xFCrlich k\xF6nnen Sie uns jederzeit weitere Kostenvoranschl\xE4ge oder R\xF6ntgenbilder zukommen lassen. Je mehr Informationen wir \xFCber Ihr Anliegen haben, desto genauer k\xF6nnen unsere Zahnarztpraxen Ihnen eine Kostensch\xE4tzung bieten.</p></div><!-- cd-faq-content --></li><li><a class="cd-faq-trigger-xs cd-faq-trigger" href="#0">Wie lange sind die Offerten g\xFCltig?</a><div class="cd-faq-content-xs cd-faq-content"><p>Die Offerten bleiben mindestens f\xFCr 5 Tage gesichert, wenn nicht anders angegeben ist.</p></div><!-- cd-faq-content --></li></ul><!-- cd-faq-group --></div></div></div></section></div>');
$templateCache.put('templates/profile.html','<div class="container" ng-controller="profileController as ctrl"><!-- SEO breadcrumbs --><script ng-bind="ctrl.breadcrumb.jsonString" type="application/ld+json"></script><!-- contain the main content of the page --><div id="content"><ul class="top-header"><li ng-repeat="crumb in ctrl.breadcrumb.schemaObject.itemListElement"><a ng-if="!$last" ng-href="{{crumb.item}}" ng-bind="(crumb.name | translate)"></a> <a ng-if="$last" ng-href="{{crumb.item}}" ng-bind="crumb.name" style="font-weight: bold"></a></li></ul><div class="page-header"><h1><strong ng-bind="ctrl.profileData.practiceSalutation"></strong><custom ng-bind="ctrl.profileData.practiceNameOne"></custom>,&nbsp;<custom ng-bind="ctrl.profileData.addressCity"></custom></h1><span class="text"><custom ng-bind="ctrl.profileData.taxpunktwert"></custom></span></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><div class="excerpt"><h2 ng-show="ctrl.profileData.practiceWelcomeNote"><custom ng-bind="ctrl.profileData.practiceWelcomeNote"></custom></h2><custom ng-show="ctrl.profileData.practiceSlogan != null && ctrl.profileData.practiceSlogan != \'\'" ng-bind="ctrl.profileData.practiceSlogan"></custom></div></div></div><div class="employee"><div class="employee-list"><!-- \t\t\tadd condition to show only when no other practitioners in practice? see with Dom at later stage --><div class="employee-block" ng-if="ctrl.profileData.teaser && (ctrl.profileData.teaserData != \'\' && ctrl.profileData.teaserData != null) && ctrl.profileData.staff.length == 0"><div class="image-holder" carousel-lightbox-wrapper><!-- In case of incorrect imgUrl with male default empty img --> <img ng-show="ctrl.profileData.teaserData[0] == \'MR\'" src="https://static.zumedo.ch/resources/platzhalter_portrait_m.jpg" alt="{{ ctrl.profileData.teaserData[1] }}"><!-- In case of inncorrect imgUrl with female default empty img --> <img ng-show="ctrl.profileData.teaserData[0] != \'MR\'" src="https://static.zumedo.ch/resources/platzhalter_portrait_f.jpg" alt="{{ ctrl.profileData.teaserData[1] }}"></div><h3 ng-bind="ctrl.profileData.teaserData[1]"></h3><em class="designation" ng-bind="ctrl.profileData.teaserData[2]"></em></div><div class="employee-block" ng-repeat="employee in ctrl.profileData.staff" ng-if="(employee.hideOnProfile == null || employee.hideOnProfile == false)"><div class="image-holder" carousel-lightbox-wrapper><!-- In case of correct imgUrl with fallback on male default empty pic --> <img ng-show="employee.pictureUrl" ng-src="{{employee.pictureUrl}}" onerror="this.src=\'https://static.zumedo.ch/resources/platzhalter_portrait_m.jpg\'" alt="{{ employee.profession + \'_\' + employee.salutation | translate }} {{employee.firstname}} {{employee.lastname}}"><!-- In case of incorrect imgUrl with male default empty img --> <img ng-show="!employee.pictureUrl && employee.salutation == \'MR\'" src="https://static.zumedo.ch/resources/platzhalter_portrait_m.jpg" alt="{{ employee.profession + \'_\' + employee.salutation | translate }} {{employee.firstname}} {{employee.lastname}}"><!-- In case of inncorrect imgUrl with female default empty img --> <img ng-show="!employee.pictureUrl && employee.salutation != \'MR\'" src="https://static.zumedo.ch/resources/platzhalter_portrait_f.jpg" alt="{{ employee.profession + \'_\' + employee.salutation | translate }} {{employee.firstname}} {{employee.lastname}}"></div><h3 ng-bind="(employee.titleText ? employee.titleText + \' \' : (employee.title ? (employee.title | translate) + \' \' : \'\')) + employee.firstname + \' \' + employee.lastname"></h3><em class="designation" ng-bind="employee.customProfession ? employee.customProfession : (employee.profession + \'_\' + employee.salutation | translate)"></em> <a ng-show="employee.cvUrl && !(employee.cvUrl.indexOf(\'.pdf\') >= 0)" type="button" class="cv-link button" data-toggle="modal" data-target="#profileModal" attribute="{{employee.cvUrl}}" style="cursor:pointer">Lebenslauf</a> <a ng-show="employee.cvUrl && (employee.cvUrl.indexOf(\'.pdf\') >= 0)" type="button" class="cv-link button" target="_blank" ng-href="{{employee.cvUrl}}" style="cursor:pointer">Lebenslauf</a></div><div class="employee-block" ng-if="ctrl.profileData.teaser && ctrl.profileData.staff.length < 2 && !ctrl.isMobile"></div><div class="employee-block teaser-block-one" ng-if="ctrl.profileData.teaser && ctrl.profileData.staff.length <= 2 && !ctrl.isMobile"><p class="custom-h2-teaser">Haben Sie diese Praxis besucht?</p><p></p><p>Geben Sie Ihre Bewertung ab:</p><a class="btn btn-success btn-lg" ng-href="{{\'https://static.zumedo.ch/besuchserlebnis_zumedo/?p=\' + ctrl.data.practiceId}}" style="margin-top:20px;white-space: initial">Jetzt Praxis bewerten</a><!-- <h3 style="margin-top:80px">Zumedo ist die f\xFChrende Schweizer Zahnarztplattform.</h3>\n\t\t\t         <p style="margin-top:10px">M\xF6chten Sie Offerten f\xFCr Ihre Zahnbehandlung? <a href="https://www.zumedo.ch/zahnarzt/kostenvoranschlag">Jetzt Formular ausf\xFCllen und bis zu 5 Offerten erhalten.</a></p> --></div></div><div class="teaser-block-one" ng-if="ctrl.profileData.teaser && (ctrl.profileData.staff.length > 2 || ctrl.isMobile)"><p class="custom-h2-teaser">Haben Sie diese Praxis besucht?</p><p>Geben Sie Ihre Bewertung ab:</p><a class="btn btn-success btn-lg" ng-href="{{\'https://static.zumedo.ch/besuchserlebnis_zumedo/?p=\' + ctrl.data.practiceId}}" style="margin-top:20px;white-space: initial">Jetzt Praxis bewerten</a><!-- <h3>Zumedo ist die f\xFChrende Schweizer Zahnarztplattform.</h3>\n\t\t         <p style="margin-top:10px">M\xF6chten Sie Offerten f\xFCr Ihre Zahnbehandlung? <a href="https://www.zumedo.ch/zahnarzt/kostenvoranschlag">Jetzt Formular ausf\xFCllen und bis zu 5 Offerten erhalten.</a></p> --></div></div></div><div><!-- Modal Profile --><div class="modal fade" id="profileModal" tabindex="-1" role="dialog" aria-labelledby="profileModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title"></h4></div><div class="modal-body"></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Schliessen</button></div></div></div></div><!-- END Modal Profile --></div><article class="info"><div class="container"><div class="row" ng-if="(!ctrl.profileData.teaser) || (ctrl.profileData.galleryDescription != null && ctrl.profileData.galleryDescription != \'\') || (ctrl.profileData.gallery.length > 0)"><div class="col-sm-6" ng-if="(!ctrl.profileData.teaser) || (ctrl.profileData.galleryDescription != null && ctrl.profileData.galleryDescription != \'\')"><div class="text-holder"><p ng-bind="ctrl.profileData.galleryDescription" style="white-space: pre-wrap"></p><div class="link-holder" ng-if="ctrl.profileData.gallery.length > 0"><a ng-href="{{ctrl.profileData.gallery[0]}}" class="links lightbox-extra-opener" data-target="lighbox-opener">Bildergalerie ansehen</a></div></div></div><div class="col-sm-6" ng-if="(!ctrl.profileData.teaser) || ctrl.profileData.gallery.length > 0"><div class="gallery-holder"><ul class="image-gallery"><li class="fullwidth"><a ng-href="{{ctrl.profileData.gallery[0]}}" class="lightbox" rel="lightbox" id="lighbox-opener"><span class="img" ng-style="{\'background-image\': \'url(\' + ctrl.profileData.gallery[0] + \')\'}"></span></a></li><li><a ng-href="{{ctrl.profileData.gallery[1]}}" class="lightbox" rel="lightbox"><span class="img" ng-style="{\'background-image\': \'url(\' + ctrl.profileData.gallery[1] + \')\'}"></span></a></li><li><a ng-href="{{ctrl.profileData.gallery[2]}}" class="lightbox" rel="lightbox"><span class="img" ng-style="{\'background-image\': \'url(\' + ctrl.profileData.gallery[2] + \')\'}"></span></a></li><a ng-repeat="photo in ctrl.profileData.gallery | limitTo : 1000 : 3" rel="lightbox" ng-href="{{photo}}"></a></ul><a ng-href="{{ctrl.profileData.gallery[0]}}" class="more hidden-xs lightbox-extra-opener" data-target="lighbox-opener"><span class="icon-plus"></span></a></div></div></div><div class="contact"><div class="row"><div class="col-sm-6"><div id="customMapProfile" class="map" data-styles="json/styles.json"><div class="map-canvas"></div><!-- <a href="#" class="marker"><span class="icon-marker"></span></a> --></div></div><div class="col-sm-6"><div class="contact-block"><address><strong><custom ng-bind="ctrl.profileData.practiceName"></custom></strong><br><custom ng-bind="ctrl.profileData.addressStreetMore ? (ctrl.profileData.addressStreet + \'/\' + ctrl.profileData.addressStreetMore) : (ctrl.profileData.addressStreet)"></custom><br><custom ng-bind="ctrl.profileData.postalCode + \' \' + ctrl.profileData.addressCity"></custom></address><em ng-bind="ctrl.profileData.locationDirections" style="white-space: pre-wrap"></em></div></div></div></div><div class="row" ng-show="(!ctrl.profileData.teaser) || (ctrl.profileData.teaser && ctrl.profileData.languages != null && ctrl.profileData.languages != \'\') || (ctrl.profileData.teaser && ctrl.profileData.specializations != null && ctrl.profileData.specializations != \'\')"><div class="contact-detail"><ul><li ng-show="(!ctrl.profileData.teaser) || (ctrl.profileData.teaser && ctrl.profileData.languages != null && ctrl.profileData.languages != \'\')"><strong>Sprachen:&nbsp;</strong><custom ng-bind="ctrl.profileData.languages"></custom></li><li ng-show="(!ctrl.profileData.teaser) || (ctrl.profileData.teaser && ctrl.profileData.specializations != null && ctrl.profileData.specializations != \'\')"><strong>Fachbereiche:&nbsp;</strong><custom ng-bind="ctrl.profileData.specializations"></custom></li></ul></div></div></div></article><div class="testimonial" id="testimonialblock" ng-show="ctrl.profileData.treatmentExperiences.length"><div class="container"><h2>Das sagen unsere Patientinnen und Patienten</h2><em class="slogan" ng-if="ctrl.profileData.averageRating"><span class="counter" ng-bind="ctrl.profileData.averageRating" businesscard-tooltip-wrapper title="Besuchserlebnis von 10 m\xF6glichen Punkten"></span><custom ng-bind="ctrl.profileData.ratingText"></custom></em><script ng-bind="ctrl.profileData.practiceReview" type="application/ld+json"></script><div style="text-align: center" class="mobileHide"><p ng-show="!ctrl.profileData.teaser" style="margin: 0 200px 40px 200px">Nur <strong>echte Bewertungen</strong> sind zugelassen. Das heisst, nur PatientInnen, welche \xFCber Zumedo einen Termin vereinbart haben, d\xFCrfen Ihr Besuchserlebnis hier ver\xF6ffentlichen.</p></div><div style="text-align: center; padding-bottom: 30px" class="mobileShow"><p ng-show="!ctrl.profileData.teaser">Nur <strong>echte Bewertungen</strong> sind zugelassen. Das heisst, nur PatientInnen, welche \xFCber Zumedo einen Termin vereinbart haben, d\xFCrfen Ihr Besuchserlebnis hier ver\xF6ffentlichen.</p></div><div ng-repeat="testimonial in ctrl.profileData.treatmentExperiences | orderBy : \'date\' : true | limitTo: ctrl.treatmentExperiencesCounter"><!-- \t\t\t\t<script ng-bind="ctrl.profileData.testimonialJsonMap[testimonial.id]" type="application/ld+json"></script> --><div class="testimonial-block testimonial-default"><div class="heading"><span ng-if="testimonial.averageRating" class="counter" ng-bind="testimonial.averageRating" businesscard-tooltip-wrapper title="Besuchserlebnis von 10 m\xF6glichen Punkten"></span><div class="heading-holder"><h3 ng-bind="testimonial.summary"></h3><time><custom ng-bind="testimonial.firstname" style="text-transform: capitalize"></custom>,&nbsp;<custom ng-bind="testimonial.date | date:\'d. MMMM yyyy\'"></custom></time><strong class="category" ng-bind="testimonial.customName ? testimonial.customName : (testimonial.treatmentType | translate)"></strong></div><ul class="list"><li ng-show="testimonial.good"><div class="holder-icon" businesscard-tooltip-wrapper title="Was bei der Behandlung besonders gut war"><span class="fa fa-chevron-up"></span></div><p ng-bind="testimonial.good"></p></li><li ng-show="testimonial.improvementPotential"><div class="holder-icon" businesscard-tooltip-wrapper title="Was ich mir zus\xE4tzlich w\xFCnschen w\xFCrde"><span class="fa fa-chevron-right"></span></div><p ng-bind="testimonial.improvementPotential"></p></li></ul></div></div><blockquote class="testimonial-block testimonial-primary" ng-show="testimonial.treatmentExperienceResponse"><cite><span class="user-image"><img ng-src="{{testimonial.treatmentExperienceResponse.pictureUrl}}" src="https://static.zumedo.ch/resources/no_employee_image.png" onerror="this.src=\'https://static.zumedo.ch/resources/no_employee_image.png\'" alt="image description"> </span><span class="text"><strong class="name" ng-bind="testimonial.treatmentExperienceResponse.name" style="text-transform: capitalize"></strong><time ng-bind="testimonial.treatmentExperienceResponse.date | date:\'d. MMMM yyyy\'"></time></span></cite> <q ng-bind="testimonial.treatmentExperienceResponse.message"></q></blockquote></div></div><div class="meta"><a ng-show="ctrl.treatmentExperiencesCounter < ctrl.profileData.treatmentExperiences.length" data-toggle="collapse" data-target="#collapsedStatic" class="load-more" style="cursor:pointer" ng-click="ctrl.treatmentExperiencesCounter = (ctrl.treatmentExperiencesCounter >= ctrl.profileData.treatmentExperiences.length ? ctrl.treatmentExperiencesCounter : ctrl.treatmentExperiencesCounter + ctrl.treatmentExperiencesCounterStep)"><i class="fa fa-plus"></i> Mehr Bewertungen lesen</a><br ng-show="ctrl.treatmentExperiencesCounter < ctrl.profileData.treatmentExperiences.length"><a ng-show="ctrl.treatmentExperiencesCounter > ctrl.treatmentExperiencesCounterStep" data-toggle="collapse" data-target="#collapsedStatic" class="load-more" style="cursor:pointer" ng-click="ctrl.treatmentExperiencesCounter = (ctrl.treatmentExperiencesCounter <= ctrl.treatmentExperiencesCounterStep ? ctrl.treatmentExperiencesCounterStep : ctrl.treatmentExperiencesCounter - ctrl.treatmentExperiencesCounterStep)"><i class="fa fa-minus"></i> Weniger Bewertungen lesen</a></div></div><a ng-href="{{ctrl.platformBookingLink}}" ng-show="!ctrl.profileData.teaser && !ctrl.isExpanded" class="mobileShow btn btn-success btn-lg btn-fixed-mob external-link js-fixed-block" data-bottom-block="bottom-scroll">Jetzt Termin vereinbaren</a><!-- <a ng-href="/zahnarzt/{{ctrl.profileData.location}}/suche?highlight={{ctrl.profileData.practiceName}}"\n\t\tng-show="ctrl.profileData.teaser"\n\t\tclass="mobileShow btn btn-success btn-lg btn-fixed-mob external-link js-fixed-block btn-teaser"\n\t\tdata-bottom-block="bottom-scroll">Jetzt Termin vereinbaren</a>\n\t\t\n\t<a ng-href="/zahnarzt/{{ctrl.profileData.location}}/suche?highlight={{ctrl.profileData.practiceName}}"\n\t\tng-show="ctrl.profileData.teaser"\n\t\tstyle="width:110%; right: -5%;"\n\t\tclass="mobileHide btn btn-success btn-lg btn-fixed external-link js-fixed-block btn-teaser"\n\t\tdata-bottom-block="bottom-scroll">Jetzt Termin vereinbaren</a> --></div>');
$templateCache.put('templates/warning.html','<style>/*    @media screen and (max-width: 580px) {\n        .breadcrumb-arrow li a {\n            font-size: 0px;\n        }\n\n        .breadcrumb-arrow li:last-child a {\n            font-size: 18px;\n        }\n    }*/</style><div class="container"><strong>Bitte deaktivieren Sie den privaten Modus Ihres Browsers und rufen Sie die Seite erneut auf. Sie verwenden eine nicht mehr aktuelle Version Ihres Browsers, bei welcher im privaten Modus Probleme mit dieser Seite auftreten.</strong></div>');}]);})();